/* eslint-disable eqeqeq */
import {
  useState,
  useEffect,
  useCallback,
  useRef,
  useLayoutEffect,
} from "react";
import { SalesReturnRo, vRdxtax, vRdxUserInfo } from "../../Redux/roStore.js";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { DataGrid } from "@mui/x-data-grid";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import useMediaQuery from "@mui/material/useMediaQuery";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import SendIcon from "@mui/icons-material/Send";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {
  CmpButtonKIcon,
  SalesInvoiceCmpButton001,
} from "../../Component/Common/ToolBox/ToolBox";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import {
  fAlertToast,
  fCalculate_Detail,
  fKeyTabInput,
  fcovertToNumber,
  fcheck_null_undefine_replace_empty,
  GetAccountPostingDetail,
  GetLinkDocument,
  GetLoctionwiseStock,
  userBasedHideField,
  PdfUpload,
  DisableApproveFlag,
  DBKernObj,
} from "../../Utility/Utilitys.jsx";
import Footer from "./processComponent/Footer.jsx";
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport.jsx";

import { fExecuteAPI } from "../../Server/Apis.jsx";
import {
  inv09_INV09_Search_GETROW,
  inv09_INV09_LoadDetail_GETROW,
  inv09_fINV09_Delete_GETROW,
  inv09_fINV09_fDisplay_GETROW,
  inv09_fINV09_fDiscCalc_GETROW,
  SalesInvoice_inv08LoadVendorData_GETROW,
  SalesInvoice_inv08RefDocSearch_GETROW,
  inv09_validationINV09_GETROW,
  inv09_saveInv09_GETROW,
  SalesInvoice001_DetailAddressDropdown,
  inv09_ApproveINV09_GETROW,
  inv09_ReverseINV09_GETROW,
  GRNNormal_RefDocumentType_GETROW,
  GRNNormal_RefDocumentNo_GETROW,
  SalesOrder_getCustomerPriceLevel_GETROW,
  SubKonten_Search_Full_V3Api,
} from "../../Server/ApiV2.jsx";
import {
  fRightClick,
  fLeftClick,
  GCAudit_GridData_Columns_Def,
  columnsNarrationDropdownSearch,
  sTrnTyp,
  Get_GCSearchBtn,
  xGCSearchBtn_Columns_DropdownSearch,
  getTransItemStockUOM,
  getOSDetail,
  GetUnitArr,
} from "./SalesReturnAction";
import {
  Set_SalesReturn_HeadObject_Set,
  Set_SalesReturn_HeadObject_New,
  Set_SalesReturn_HeadObject_A_VocNo_A_DocStat,
  Set_SalesReturn_HeadObject_A_DocStatus,
  Set_SalesReturn_HeadObject_SalesGroup_SalesMan,
  Set_SalesReturn_HeadObject_Init,
  Set_SalesReturn_HeadObject_DrCrAccount,
  Set_HeadObject_Type,
} from "./SliceSalesReturn.jsx";
import "./SalesReturn.css";
import GCSearchBtn from "../../Component/Common/ReuseableComponent/GCSearchBtn.jsx";
import GCDiscountPercentage from "../../Component/Common/ReuseableComponent/GCDiscountPercentage.jsx";
import GCVanMaster from "../../Component/Common/ReuseableComponent/GCVanMaster.jsx";
import GCAudit from "../../Component/Common/ReuseableComponent/GCAudit.jsx";
import GCEmployee from "../../Component/Common/ReuseableComponent/GCEmployee.jsx";
import GCReverse from "../../Component/Common/ReuseableComponent/GCReverse.jsx";

import { FShortCutKey } from "../../Utility/Utilitys.jsx";
import {
  fCheck_Doc_Rights_001,
  GetGitterColumns,
} from "../../Utility/Utilitys.jsx";
import GCAccountDetail from "../../Component/Common/ReuseableComponent/GCAccountDetail.jsx";
import GCMenuBtn from "../../Component/Common/ReuseableComponent/GCMenuBtn.jsx";
import GCLinkDocument from "../../Component/Common/ReuseableComponent/GCLinkDocument.jsx";
import GCLocationwiseStock from "../../Component/Common/ReuseableComponent/GCLocationwiseStock.jsx";
import {
  GetAttributes,
  GridData_Columns_Detail_Def,
  GCSearch_GridData_Columns_Def,
  GridDataSalesHistoryColumns_Def,
  GridDataSalesHistoryColumns2,
  GCVanMaster_SalesGroup_GridData_Columns,
  GCEmployee_SalesGroup_GridData_Columns,
  Get_GCToggleSearch_Item_Dropdown_Grid,
  GCToggleSearch_Item_Data,
  GCToggleSearch_Customer_Data,
  Get_GCToggleSearch_Customer_Api,
  fDefaultPayload,
  GetOSAmount,
} from "./SalesReturnAction";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky.jsx";
import GCFilter from "../WmsPhysicalStockCount/processComponent/GCFilter.jsx";
import ShippingAddressForm from "./processComponent/ShippingAddressForm.jsx";
import CustomFieldsForm from "./processComponent/CustomFieldsForm.jsx";
import DespatchDetailForm from "./processComponent/DespatchDetailForm.jsx";
import LoyaltySearch from "./processComponent/LoyaltySearch.jsx";
import TermsAndConditions from "./processComponent/TermsAndConditions.jsx";
import Attachment from "../../Component/Common/ReuseableComponent/Attachment.jsx";
import BatchSelectionModal from "./processComponent/BatchSelectionModal.jsx";
import RegisterSerialNumberModal from "./processComponent/RegisterSerialNumberModal.jsx";
import FileUploadModal from "../../Component/Common/ReuseableComponent/FileUpload.jsx";
import POTypeSearchModal from "./processComponent/POTypeSearchModal.jsx";
import PoNoSearchModal from "./processComponent/PoNoSearchModal.jsx";
import GCHead from "./processComponent/GCHead.jsx";
import GCSalesContent from "./processComponent/GCContent.jsx";
import { DetailTblCard } from "./processComponent/DetailTblCard.jsx";
import GCNAV from "../../Component/Common/ReuseableComponent/GCNAV.jsx";

export default function SalesReturn() {
  const dispatch = useDispatch();
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const RefNoFocusOnLoad = useRef(null);
  const ClickNewFocsItem = useRef(null);
  const sEnterKeyObj = {
    key: "Enter",
  };

  const vRdxWmsHead = useSelector(
    (state) => state.SliceSalesReturn.value.HeadObject
  );

  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const vRdxGRNtax1 = useSelector((state) => state.SliceGRN.value.tax.tax1);
  const vRdxGRNtax2 = useSelector((state) => state.SliceGRN.value.tax.tax2);
  const [vRdxPricelevel, setType] = useState([
    {
      UId: "",
      Name1: "",
    },
    {
      UId: "Cost Price",
      Name1: "Cost Price",
    },
    {
      UId: "COST+Over Head",
      Name1: "COST+Over Head",
    },
    {
      UId: "Customer Price",
      Name1: "Customer Price",
    },
    {
      UId: "Export Price",
      Name1: "Export Price",
    },
    {
      UId: "Retail",
      Name1: "Retail Selling Price",
    },
    {
      UId: "Special Price",
      Name1: "Special Price",
    },
    {
      UId: "Wholesale Price",
      Name1: "Wholesale Price",
    },
  ]);
  // const sLocation = useSelector((state) => state.SliceGRNLocation.value);
  const [sLocation, setLocation] = useState([]);
  const [sTax, setTaxType] = useState([
    {
      UId: "OTTRN001",
      Name1: "VAT SALES",
    },
    {
      UId: "OTTRN002",
      Name1: "INTER COMPANY",
    },
    {
      UId: "OTTRN003",
      Name1: "EXPORT",
    },
  ]);
  const [sInvoiceTyp, setInvoiceTyp] = useState([]);
  const vRdxuserInfo = useSelector((state) => state.login.value);

  const roundOffValue = 2;
  const [sRoundingVal, setRoundingVal] = useState(4);
  const [GCAudit_Dropdown_Arr, set_GCAudit_Dropdown_Arr] = useState([]);
  const [GCAudit_GridData_Rows, setGridDataAuditRows] = useState([]);
  const [sDocLoading, setDocLoading] = useState([]); // GrnType Select
  // modal start
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showModal4, setShowModal4] = useState(false);
  const [TermsModal, setTermsModal] = useState(false);
  const [SerialDetalModal, setSerialDetalModal] = useState({
    SrNo: 0,
    ItemCd: "",
    Batch: "N",
    Serial: "N",
    AutoGrn: "N",
  });
  const [sbatchSelectionModal, setBatchSelectionModal] = useState(false);
  const [registerSerialNumberModal, setRegisterSerialNumberModal] =
    useState(false);
  const [ImageUploaderModal, setImageUploaderModal] = useState(false);
  // modal end
  const [sTransItemStockObj, setTransItemStockObj] = useState({
    RPStock: 0,
    MSP: 0,
    CostPr: 0,
    LPRate: 0,
  });
  const [sOSDetailObj, setOSDetailObj] = useState({
    partyos: "",
    partypdc: "",
    CrLimit: "",
    partyNetOS: "",
    CrlimitPRD: "",
    FixedCost: "",
  });
  const [sCurrency, setCurrency] = useState([]); //Currency Select
  const [sSalesman, setSalesman] = useState([]); //sSalesman Select
  const [sSalesGroup, setSalesGroup] = useState([]); //sSalesGroup Select
  const [GCSearch_SalesGroup_Arr, set_GCSearch_SalesGroup_Arr] = useState([]); //GCSeachSalesGroupSearch Select
  const [sSupervisorSlabs, setSupervisorSlabs] = useState([]); //SupervisorSlabs Select
  const [sOtherSlabs, setOtherSlabs] = useState([]); //OtherSlabs Select
  const [sDefault, setDefault] = useState([]); //OtherSlabs Select
  const [sIncentiveGroups, SetIncentiveGroups] = useState([]); //IncentiveGroups Select
  const [GCSearch_sTransPartyArr, set_GCSearch_TransParty] = useState([]); //GCSearch_sTransPartyArr Select (btn-Search party-dropdown)
  const [sUser_Doc_Arr, setUser_Doc_Arr] = useState([]);
  const [sToggleGrid, setToggleGrid] = useState(false);
  const [sNavDocValue, setNavDocValue] = useState(1); // nav bar arrow input value
  const [sSales_History_STOCK_SALES, set_Sales_History_STOCK_SALES] =
    useState("STOCK"); // tax perc 0
  const [GCReverse_sRevNarr, GCReverse_setRevNarr] = useState(""); //for Reverse API
  const sStatusArr = ["ENTER", "POST", "DELETE", "DRAFT", "CANCEL"];
  const [sShowMore, setShowMore] = useState(false); // nav bar arrow input value
  const [sRigntClick, setRigntClick] = useState(false); // nav bar arrow input value

  const [sNarrArr, setNarrArr] = useState([]);
  const sPayModeArr = ["CREDIT", "CASH", "CC"];
  const [sPaymodeEnable, setPaymodeEnable] = useState(true); //to set paymode enable or disable
  const [sOsAmount, setOsAmount] = useState({
    NetOsAmt: 0,
    PDCAmt: 0,
    BalanceOsAmt: 0,
  }); //to set paymode enable or disable
  const [sObjRights, setObjRights] = useState({
    RNew: "Y",
    RSave: "Y",
    RDelete: "Y",
    RApprove: "Y",
    RPrint: "Y",
  });
  const [sObjectRights, setObjectRights] = useState({
    DocTyp: "",
    Save: "Y",
    Edit: "Y",
    Del: "Y",
    View: "Y",
    Appr: "Y",
    Reverse: "Y",
    Cancel: "Y",
    Print: "Y",
    Clone: "Y",
    Lvl: "",
  });
  const [sBufferObj, setBufferObj] = useState({
    B_Br: "",
    B_BrName: "",
    B_VocTyp: vRdxWmsHead.A_VocTyp,
    B_VocNo: vRdxWmsHead.A_VocNo,
    B_Srno: 0,
    B_Itmcd: "",
    B_ItmName: "",
    B_Qty: 0,
    B_Unit: "",
    B_UnitName: "",
    B_PackQty: "",
    B_BaseQty: (0).toFixed(roundOffValue),
    B_URateFc: (0).toFixed(roundOffValue),
    B_URateLc: (0).toFixed(roundOffValue),
    B_GrossAmt: (0).toFixed(roundOffValue),
    B_LDiscPerc: (0).toFixed(roundOffValue),
    B_LDiscAmt: (0).toFixed(roundOffValue),
    B_TDiscPerc: (0).toFixed(roundOffValue),
    B_TDiscAmt: (0).toFixed(roundOffValue),
    B_FocFlag: "N",
    B_FocAmt: (0).toFixed(roundOffValue),
    B_NetAmt: (0).toFixed(roundOffValue), //taxable Amt

    B_Rounding: (0).toFixed(roundOffValue),
    B_LandVal: (0).toFixed(roundOffValue),
    B_RefDocTyp: "",
    B_RefDocNo: "",
    B_RefDocName: "",
    B_ExciseTaxAmt: (0).toFixed(roundOffValue),
    B_ExciseTaxNetAmt: (0).toFixed(roundOffValue),
    B_IncGroup: "",
    B_SuprvPerc: (0).toFixed(roundOffValue),
    B_OthersPerc: (0).toFixed(roundOffValue),
    B_SLANSuprv: "",
    B_SlabAmtSuprv: (0).toFixed(roundOffValue),
    B_SLANOther: "",
    B_SlabAmtOther: (0).toFixed(roundOffValue),

    TaxableAmt: "",
    Narration: "",
    Itm_DefUnit: "",
    Itm_SalUnit: "",

    B_TaxDept: vRdxGRNtax1[0].UId,
    B_TaxPerc: vRdxGRNtax1[0].Perc, //Decimal
    B_TaxAmt: (0).toFixed(roundOffValue), //Decimal
    B_TaxDept2: vRdxGRNtax2[0].UId,
    B_TaxPerc2: vRdxGRNtax2[0].Perc, //Decimal
    B_TaxAmt2: (0).toFixed(roundOffValue), //Decimal
    AddCess: (0).toFixed(roundOffValue), //Decimal
    B_NetAddCess: (0).toFixed(roundOffValue), //Decima
    Reason: "",
  });

  const [sFooterObj, setFooterObj] = useState({
    A_GrossAmt: (0).toFixed(roundOffValue),
    A_TDiscAmt: (0).toFixed(roundOffValue),
    A_LDiscAmt: (0).toFixed(roundOffValue),
    A_FocAmt: (0).toFixed(roundOffValue),
    A_NetExcise: (0).toFixed(roundOffValue),
    A_Tax: (0).toFixed(roundOffValue),
    A_Tax2: (0).toFixed(roundOffValue),
    A_AddCess: (0).toFixed(roundOffValue),
    A_LandVal: (0).toFixed(roundOffValue),
  });

  const [GCDiscountPercentage_Obj, set_GCDiscountPercentage_Obj] = useState({
    A_TDiscAmt: sFooterObj.A_TDiscAmt,
    A_DiscPerc: vRdxWmsHead.A_DiscPerc,
  });

  let vBufferObjInit = {
    B_Br: "",
    B_BrName: "",
    B_VocTyp: vRdxWmsHead.A_VocTyp,
    B_VocNo: vRdxWmsHead.A_VocNo === "" ? 0 : vRdxWmsHead.A_VocNo,
    B_Srno: 0,
    B_Itmcd: "",
    B_ItmName: "",
    B_Qty: 0,
    B_Unit: "",
    B_UnitName: "",
    B_PackQty: "",
    B_BaseQty: (0).toFixed(roundOffValue),
    B_URateFc: (0).toFixed(roundOffValue),
    B_URateLc: (0).toFixed(roundOffValue),
    B_GrossAmt: (0).toFixed(roundOffValue),
    B_LDiscPerc: (0).toFixed(roundOffValue),
    B_LDiscAmt: (0).toFixed(roundOffValue),
    B_TDiscPerc: (0).toFixed(roundOffValue),
    B_TDiscAmt: (0).toFixed(roundOffValue),
    B_FocFlag: "N",
    B_FocAmt: (0).toFixed(roundOffValue),
    B_NetAmt: (0).toFixed(roundOffValue), //taxable Amt

    B_Rounding: (0).toFixed(roundOffValue),
    B_LandVal: (0).toFixed(roundOffValue),
    B_RefDocTyp: "",
    B_RefDocNo: "",
    B_RefDocName: "",
    B_ExciseTaxAmt: (0).toFixed(roundOffValue),
    B_ExciseTaxNetAmt: (0).toFixed(roundOffValue),
    B_IncGroup: "",
    B_SuprvPerc: (0).toFixed(roundOffValue),
    B_OthersPerc: (0).toFixed(roundOffValue),
    B_SLANSuprv: sSupervisorSlabs[0],
    B_SlabAmtSuprv: (0).toFixed(roundOffValue),
    B_SLANOther: sOtherSlabs[0],
    B_SlabAmtOther: (0).toFixed(roundOffValue),

    TaxableAmt: "",
    Narration: "", //FIELD8
    Itm_DefUnit: "",
    Itm_SalUnit: "",
    B_TaxDept: vRdxGRNtax1[0].UId,
    B_TaxPerc: vRdxGRNtax1[0].Perc, //Decimal
    B_TaxAmt: (0).toFixed(roundOffValue), //Decimal
    B_TaxDept2: vRdxGRNtax2[0].UId,
    B_TaxPerc2: vRdxGRNtax2[0].Perc, //Decimal
    B_TaxAmt2: (0).toFixed(roundOffValue), //Decimal
    AddCess: (0).toFixed(roundOffValue), //Decimal
    Reason: "",
  };
  const [sItemStock, setItemStock] = useState({
    rpStock: "",
    wmsStock: "",
    msp: "",
    costpr: "",
    OpenBinStock: "",
  });
  let vErrorMessageInit = {
    A_VocTyp: "",
    A_VocNo: "",
    A_PostDt: "",
    A_RefNo: "",
    A_RefDt: "",
    A_Loc: "",
    A_PayMode: "",
    A_Curr: "",
    A_ExRate: "",
    A_Party: "",
    A_PartyName: "",
    A_TaxType: "",
    A_Type: "",
    A_Taxable: "",
    A_InvoiceType: "",
    CreditNote: "",
    A_Buyer: "",
    A_Narr: "",
    A_Rounding: "",
    A_DiscPerc: "",
    A_SalesGroup: "",
    A_ECOM: "",
    No: "",
    A_DropShipment: "",
    Commity: "",
    Note: "",
    LoyaltyName: "",
  };
  let vErrorMessageDetailInit = {
    B_Srno: "",
    B_Itmcd: "",
    B_ItmName: "",
    B_Qty: "",
    B_UneQty: "",
    B_URait: "",
    B_BasteFc: "",
    B_URateLc: "",
    B_GrossAmt: "",
    B_LDiscPerc: "",
    B_LDiscAmt: "",
    B_TDiscPerc: "",
    B_TDiscAmt: "",
    B_FocFlag: "",
    B_FocAmt: "",
    B_ExciseTaxAmt: "",
    B_ExciseTaxNetAmt: "",
    B_NetAmt: "",
    B_URateFc: "",
    B_NetAddCess: "",
    B_Unit: "",
    B_LandVal: "",
    Narration: "",
    B_IncGroup: "",
    B_SuprvPerc: "",
    B_OthersPerc: "",
    B_SLANSuprv: "",
    B_SlabAmtSuprv: "",
    B_SLANOther: "",
    B_SlabAmtOther: "",
    B_TaxDept: "",
    B_TaxPerc: "",
    B_TaxAmt: "",
    B_TaxDept2: "",
    B_TaxPerc2: "",
    B_TaxAmt2: "",
    AddCess: "",
    Reason: "",
    B_RefDocTyp: "",
    B_RefDocNo: "",
    B_RefDocName: "",
  };
  const [sErrorMsg, setErrorMsg] = useState(vErrorMessageInit);
  const [sReason, setReason] = useState([]);

  const [sErrorMsgDetail, setErrorMsgDetail] = useState(
    vErrorMessageDetailInit
  );
  const [GCDiscountPercentage_sErrorMsg, setErrorMsgDiscountModal] = useState({
    A_TDiscAmt: "",
    A_DiscPerc: "",
  });

  let vErrorMsgDiscountModalInit = {
    A_TDiscAmt: "",
    A_DiscPerc: "",
  };
  const [sItemSearchModalObj, setItemSearchModalObj] = useState({
    vAnydata: sBufferObj.B_ItmName,
    vItemNameCode: "",
    vItemNameName: "",
    vItemNameBarcode: "",
    vItemNameGroupCode: "ALL",
    vItemNameRefNo: "",
    vItemNameNameFL: "",
    vItemNameCostPrice: "",
    vItemNameRSP: "",
  });
  const [GCSearch_Obj, setSearchModalObj] = useState({
    Status: "ENTER",
    VocNo: "",
    PostDt: "",
    Loc: sLocation[0]?.UID ? sLocation[0]?.UID : "",
    RefNo: "",
    SalesGroup: "",
    Party: "All",
    PartyName: "All",
  });
  const [sItemUnit, setUnit] = useState([]);
  const [sItemLocation, setItemLocation] = useState([]);
  const [sInvoiceSalesModal, setInvoiceSalesModal] = useState(false);
  const [GCSearch_Toggle, setSearchModal] = useState(false);
  const [sGridSelectRowData, setGridSelectRowData] = useState([]);
  const [GCSearch_GridData_Row, setGridSearchHeadRowData] = useState([]);
  const [sGridSalesHistoryRowData, setGridSalesHistoryRowData] = useState([]);
  const [sDetailDispatchDrpdown, setDetailDispatchDrpdown] = useState([]);
  const [sDetailGridData, setDetailGridData] = useState([]);

  const [sNarrationSearchGridFullData, setNarrationSearchGridFullData] =
    useState([]); //for Narration full data
  const [sNarrationSearchGridData, setNarrationSearchGridData] = useState([]); //for Narration search

  const [GCDiscountPercentage_Toggle, setDiscountPercentageModal] =
    useState(false);

  const [GCReverse_Toggle, setReverseTransactionModal] = useState(false);
  const fOpenReverseTransactionModal = () => {
    setReverseTransactionModal(true);
  };
  const GCReverse_fClose = (e) => {
    setReverseTransactionModal(false);
  };

  const fOpenDiscountPercentageModal = (e) => {
    if (sDetailGridData.length > 0) {
      setDiscountPercentageModal(true);
      set_GCDiscountPercentage_Obj((obj) => ({
        ...obj,
        A_TDiscAmt: sFooterObj.A_TDiscAmt,
        A_DiscPerc: vRdxWmsHead.A_DiscPerc,
      }));
    } else {
      fAlertToast("FAILED", "save atleast one line item");
    }
  };

  const GCDiscountPercentage_fClose = (e) => {
    setDiscountPercentageModal(false);
    setErrorMsgDiscountModal((obj) => ({
      ...obj,
      A_TDiscAmt: "",
      A_DiscPerc: "",
    }));
  };

  const [GCAudit_Toggle, set_GCAudit_Toggle] = useState(false);
  const fOpenAuditModal = (e) => {
    set_GCAudit_Toggle(true);
  };
  const GCAudit_fClose = (e) => {
    set_GCAudit_Toggle(false);
  };

  // const [sPrintModal, setPrintModal] = useState(false);
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };
  const fPrint = useCallback(
    (xPrnTyp) => {
      let webReport = vRdxDBKernObj.WEB_REPORT_BASE_URL;

      //Sales/SalesReturn?trntyp=INV09&voctyp=SR01&vocno=SR26000002&prntyp=D
      console.log(webReport);
      let urlPrint =
        webReport?.Val +
        "Sales/SalesReturn?trntyp" +
        sTrnTyp +
        "&voctyp=" +
        vRdxWmsHead.A_VocTyp +
        "&vocno=" +
        vRdxWmsHead.A_VocNo +
        "&prntyp=" +
        xPrnTyp +
        "&amountInWord=''";
      console.log(urlPrint);

      setWebReportUrlModal(urlPrint);
      fWebReport();
    },
    [vRdxWmsHead.A_VocNo, vRdxWmsHead.A_VocTyp, vRdxDBKernObj]
  );

  //Sales Group Modal
  const GCVanMaster_SalesGroup_TypeArr = [
    { UId: "Supervisor", Name: "Supervisor" },
    { UId: "Driver", Name: "Driver" },
    { UId: "Salesman", Name: "Salesman" },
    { UId: "Helper", Name: "Helper" },
  ];
  const [GCVanMaster_SalesGroup_Toggle, set_GCVanMaster_SalesGroup_Toggle] =
    useState(false);
  const [GCVanMaster_SalesGroup_ModalObj, set_GCVanMaster_SalesGroup_ModalObj] =
    useState({
      Group: "",
      SrNo: "0",
      Type: GCVanMaster_SalesGroup_TypeArr[0].UId,
      EmployeeID: "",
      EmployeeName: "",
      // Branch: "1",
      Active: "Y",
      // ImageUrl: "",
    });
  var vErrorMsgVanMasterInit = {
    SrNo: "",
    Type: "",
    EmployeeID: "",
    EmployeeName: "",
    Active: "",
  };
  const [
    GCVanMaster_SalesGroup_sErrorMsg,
    set_GCVanMaster_SalesGroup_ErrorMsg,
  ] = useState(vErrorMsgVanMasterInit);

  const [
    GCVanMaster_SalesGroup_GridData_Row,
    set_GCVanMaster_SalesGroup_GridData_Row,
  ] = useState([]);
  const GCVanMaster_SalesGroup_GetSearchEnter = (e) => {
    if (e.key == "Backspace") {
      set_GCVanMaster_SalesGroup_ModalObj((obj) => ({
        ...obj,
        EmployeeID: "",
      }));
    }
    if (
      e._reactName === "onClick" ||
      (e.key == "Enter" && e.target.name == "EmployeeName")
    ) {
      fOpenSalesGroupEmployeeModal();
      setSalesGroupEmployeeModelObj((obj) => ({
        ...obj,
        AnyData: GCVanMaster_SalesGroup_ModalObj.EmployeeName,
      }));
      if (GCVanMaster_SalesGroup_ModalObj.EmployeeName !== "") {
        GetEmployeeSearchVanGroup(GCVanMaster_SalesGroup_ModalObj.EmployeeName);
      }
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      var selectedLength =
        document.getElementsByClassName("Mui-selected").length;
      setTimeout(() => {
        if (Number(selectedLength) === 0) {
          let tabel = document.getElementById("table-main-grid-5");
          // vIsDownKeyPressedSimpleSearch = true;
          // tabel?.getElementsByClassName('MuiDataGrid-row')[0].firstChild.click();
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            .firstChild?.focus();
        }
      }, 100);
    }
  };

  //GCSimpleSearch Sales Group Modal
  const GCVanMaster_SalesGroup_fRowClick = (e) => {
    set_GCVanMaster_SalesGroup_ModalObj((obj) => ({
      ...obj,
      SrNo: e?.row?.Srno,
      Type: e?.row?.Typ,
      EmployeeID: e?.row?.EMPID,
      EmployeeName: e?.row?.EMPNAME,
      Active: e?.row?.Active,
    }));
  };

  // Sales Group Modal
  const GCVanMaster_SalesGroup_fRowCellClick = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      set_GCVanMaster_SalesGroup_ModalObj((obj) => ({
        ...obj,
        SrNo: newSelectionModel?.row?.Srno,
        Type: newSelectionModel?.row?.Typ,
        EmployeeID: newSelectionModel?.row?.EMPID,
        EmployeeName: newSelectionModel?.row?.EMPNAME,
        Active: newSelectionModel?.row?.Active,
      }));
    }
  };
  const GCVanMaster_SalesGroup_fSrNoModal = (e) => {
    set_GCVanMaster_SalesGroup_ModalObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const GCVanMaster_SalesGroup_OnChange_Input = (e) => {
    set_GCVanMaster_SalesGroup_ModalObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const GCVanMaster_SalesGroup_fActiveModal = (e) => {
    set_GCVanMaster_SalesGroup_ModalObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.checked ? "Y" : "N",
    }));
  };
  const GCVanMaster_SalesGroup_fEmployeeModal = (e) => {
    set_GCVanMaster_SalesGroup_ModalObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
    //IN MOBILE Backspace KEY NOT DETECTED TO CALL API WE USE BLUR
    if (
      e.target.value.length <
        GCVanMaster_SalesGroup_ModalObj.EmployeeName.toString().length &&
      vMediaQuery &&
      e.target.name === "EmployeeName"
    ) {
      var vBackspaceObj = {
        key: "Backspace",
      };
      GCVanMaster_SalesGroup_GetSearchEnter(vBackspaceObj);
    }
  };

  const fOpenSalesGroupModal = async () => {
    if (vRdxWmsHead.A_VocNo !== 0 && vRdxWmsHead.A_SalesGroup !== "") {
      if (vRdxWmsHead.A_DocStat == "ENTER") {
        let vFillVanMaster = await GetFillVanMaster();
        if (vFillVanMaster.toUpperCase() === "SUCCESS") {
          set_GCVanMaster_SalesGroup_Toggle(true);
          GetVANMastItemList();
          set_GCVanMaster_SalesGroup_ModalObj((obj) => ({
            ...obj,
            Group: vRdxWmsHead.A_SalesGroup,
          }));
          setTimeout(() => {
            document.getElementsByName("EmployeeName")[0]?.focus();
          }, 100);
        } else {
          fAlertToast("FAILED", "FillVanMaster not Saved ");
        }
      }
    } else {
      fAlertToast("FAILED", "Voc.No and Sales Group shouldn't be Empty ");
    }
  };

  const GCVanMaster_SalesGroup_fCloseModal = (e) => {
    set_GCVanMaster_SalesGroup_Toggle(false);
    fClearSalesGroupSearch();
  };

  const fClearSalesGroupSearch = () => {
    set_GCVanMaster_SalesGroup_ModalObj((obj) => ({
      ...obj,
      Group: vRdxWmsHead.A_SalesGroup,
      SrNo: "0",
      Type: GCVanMaster_SalesGroup_TypeArr[0].UId,
      EmployeeID: "",
      EmployeeName: "",
      // Branch: "1",
      Active: "Y",
      // ImageUrl: "",
    }));
    set_GCVanMaster_SalesGroup_GridData_Row([]);
    set_GCVanMaster_SalesGroup_ErrorMsg(vErrorMsgVanMasterInit);
  };
  const GCVanMaster_SalesGroup_fNew = () => {
    fClearSalesGroupSearch();
    GetVANMastItemList();
  };
  const fValidationVanMasterSalesGroup = () => {
    let iRes = true;
    if (GCVanMaster_SalesGroup_ModalObj.SrNo === "") {
      set_GCVanMaster_SalesGroup_ErrorMsg((obj) => ({
        ...obj,
        SrNo: "SrNo should not be empty",
      }));
      iRes = false;
    }
    if (GCVanMaster_SalesGroup_ModalObj?.Type === "") {
      set_GCVanMaster_SalesGroup_ErrorMsg((obj) => ({
        ...obj,
        Type: "Type should not be empty",
      }));
      iRes = false;
    }
    if (GCVanMaster_SalesGroup_ModalObj.EmployeeID === "") {
      set_GCVanMaster_SalesGroup_ErrorMsg((obj) => ({
        ...obj,
        EmployeeID: "EmployeeID should not be empty",
      }));
      iRes = false;
    }
    if (GCVanMaster_SalesGroup_ModalObj.EmployeeName === "") {
      set_GCVanMaster_SalesGroup_ErrorMsg((obj) => ({
        ...obj,
        EmployeeID: "EmployeeName should not be empty",
      }));
      iRes = false;
    }
    if (GCVanMaster_SalesGroup_ModalObj.Active === "") {
      set_GCVanMaster_SalesGroup_ErrorMsg((obj) => ({
        ...obj,
        Active: "Active should not be empty",
      }));
      iRes = false;
    }
    return iRes;
  };
  const GCVanMaster_SalesGroup_fSave = async () => {
    set_GCVanMaster_SalesGroup_ErrorMsg(vErrorMsgVanMasterInit);
    if (fValidationVanMasterSalesGroup()) {
      GetVANMastItemSave();
    }
  };
  const GCVanMaster_SalesGroup_fDelete = async () => {
    if (GCVanMaster_SalesGroup_ModalObj.SrNo > 0) {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete.",
        buttons: [
          {
            className: "alertBtn",
            name: "DeletYes",
            label: "Yes",
            onClick: () => {
              GCVanMaster_SalesGroup_GetDelete();
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }

    // GCVanMaster_SalesGroup_GetDelete();
  };

  // Employee Modal
  const [GCEmployee_SalesGroup_Toggle, set_GCEmployee_SalesGroup_Toggle] =
    useState(false);
  const [
    GCEmployee_SalesGroup_GridData_Row,
    set_GCEmployee_SalesGroup_GridData_Row,
  ] = useState([]);
  const [GCEmployee_SalesGroup_Obj, setSalesGroupEmployeeModelObj] = useState({
    AnyData: "",
    FirstName: "",
    MiddleName: "",
    LastName: "",
  });
  const fOpenSalesGroupEmployeeModal = () => {
    GCEmployee_SalesGroup_fClear();
    setTimeout(() => {
      document.getElementsByName("AnyData")[0]?.focus();
    }, 100);
    set_GCEmployee_SalesGroup_Toggle(true);
  };
  const GCEmployee_SalesGroup_fClose = (e) => {
    set_GCEmployee_SalesGroup_Toggle(false);
    setTimeout(() => {
      document.getElementsByName("EmployeeName")[0]?.focus();
    }, 100);
  };

  //GCEmployeeSearch
  const GCEmployee_SalesGroup_Get_SearchEnter = (e) => {
    if (e.key == "Enter") {
      GetEmployeeSearchVanGroup(GCEmployee_SalesGroup_Obj.AnyData);
    }

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      var selectedLength =
        document.getElementsByClassName("Mui-selected").length;
      setTimeout(() => {
        if (Number(selectedLength) === 0) {
          let tabel = document.getElementById("table-main-grid-6");
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            .firstChild?.focus();
        }
      }, 200);
    }
  };
  const GCEmployee_SalesGroup_onChange_Input = (event) => {
    setSalesGroupEmployeeModelObj((obj) => ({
      ...obj,
      [event.target.name]: event.target.value,
    }));
  };
  //GCEmployeeSearch
  const GCEmployee_SalesGroup_fRowClick = (e, x) => {
    set_GCVanMaster_SalesGroup_ModalObj((obj) => ({
      ...obj,
      EmployeeID: e?.row?.EMPID,
      EmployeeName: e?.row?.SName,
      Active: e?.row?.InActive,
    }));
    GCEmployee_SalesGroup_fClose();
  };

  //GCEmployeeSearch
  const GCEmployee_SalesGroup_fRowCellClick = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      set_GCVanMaster_SalesGroup_ModalObj((obj) => ({
        ...obj,
        EmployeeID: newSelectionModel?.row?.EMPID,
        EmployeeName: newSelectionModel?.row?.SName,
        Active: newSelectionModel?.row?.InActive,
      }));
      GCEmployee_SalesGroup_fClose();
    }
  };

  const GCEmployee_SalesGroup_fClear = () => {
    setSalesGroupEmployeeModelObj((obj) => ({
      ...obj,
      AnyData: "",
      FirstName: "",
      MiddleName: "",
      LastName: "",
    }));
    set_GCEmployee_SalesGroup_GridData_Row([]);
  };

  //GCSimpleSearch CUSTOMER SEARCH MODAL

  const fCloseInvoiceSalesModal = () => {
    setInvoiceSalesModal(false);
    fClearItem();
  };

  const GCSearch_fClose = (e) => {
    setSearchModal(false);
    GCSearch_fClear();
  };

  const GCSearch_fClear = (e) => {
    setSearchModalObj({
      Status: "ENTER",
      VocNo: "",
      PostDt: "",
      Loc: sLocation[0].UID,
      RefNo: "",
      SalesGroup: GCSearch_SalesGroup_Arr[0]?.UID,
      Party: "All",
      PartyName: "All",
    });
    setGridSearchHeadRowData([]);
  };

  const fSearch = async () => {
    setGCSearchBtn_ToggleDropDowm(false);
    setSearchModal(true);
    document.getElementById("INV08BtnSearch")?.blur();
    // SALESGROUPSSEARCH_GETROW
    let iSalesGroupArr = await fSalesgroupArr_GETROW(vRdxWmsHead.A_Loc);
    if (iSalesGroupArr.length > 0) {
      set_GCSearch_SalesGroup_Arr(iSalesGroupArr);
      setSearchModalObj({
        ...GCSearch_Obj,
        Loc: sLocation[0]?.UID,
        SalesGroup: iSalesGroupArr[0]?.UID,
        Party: "All",
        PartyName: "All",
      });
      GCSearch_Get("", "APICallSalesGroupModal", iSalesGroupArr[0]?.UId);
    }
  };

  const GCSearch_fonChange_Status = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((value, index) => {
      return value == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Status: vSelectedValue,
    }));

    GCSearch_Get("", "APICALL", vSelectedValue);
  };

  const GCSearch_fonChange_Party = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((obj, index) => {
      return obj.AcCd == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Party: vSelectedValue.AcCd,
    }));
    GCSearch_Get("", "APICallPartyModal", vSelectedValue.AcCd);
  };

  const GCSearch_fonChange_Loc = (event, selectArr) => {
    var vSelectedValue = sLocation?.find((obj, index) => {
      return obj.UID == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Loc: event.target.value,
    }));
    GCSearch_Get("", "APICallLocModal", vSelectedValue.UID);
  };

  const GCSearch_fonChange_SalesGroup = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((obj, index) => {
      return obj.UId == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      SalesGroup: vSelectedValue.UId,
    }));
    GCSearch_Get("", "APICallSalesGroupModal", vSelectedValue.UId);
  };

  const GCSearch_fonChange_VocNo = (event) => {
    setSearchModalObj((obj) => ({
      ...obj,
      VocNo: event.target.value,
    }));
  };
  const GCSearch_fonChange_RefNo = (event) => {
    setSearchModalObj((obj) => ({
      ...obj,
      RefNo: event.target.value,
    }));
  };

  const GCSearch_fOnChange_Date = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      setSearchModalObj((obj) => ({
        ...obj,
        PostDt: "",
      }));
    } else {
      setSearchModalObj((obj) => ({
        ...obj,
        PostDt: event?.$d,
      }));
    }

    let changedDate = event?.$d;
    if (new Date(event?.$d) > new Date("01-01-1990")) {
      GCSearch_Get("", "APICALLDATE", changedDate);
    }
    // setSearchModalObj((obj) => ({
    //   ...obj,
    //   PostDt: !!event.target.value
    //     ? moment(event.target.value, "YYYY-MM-DD")._d
    //     : "",
    // }));
    // let changedDate = moment(event.target.value, "YYYY-MM-DD")._d;
    // if (new Date(event.target.value) > new Date("01/01/1990")) {
    //   GCSearch_Get("", "APICALLDATE", changedDate);
    // }
  };

  //API  UNIT_RATE_GETROW
  const GetUnitRateArr = async (xItmCd, xUnitId) => {
    let vUnitRateObj = {
      itemCd: xItmCd,
      unit: xUnitId,
      loc: vRdxWmsHead.A_Loc,
      type: vRdxWmsHead.A_Type,
      party: vRdxWmsHead.A_Party,
      date: moment(vRdxWmsHead.A_PostDt).format("MM/DD/YYYY"),
      curr: vRdxWmsHead.A_Curr,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vUnitRateObj);

    const UnitRateInfo = await fExecuteAPI("UNITRATE_GETROW", FinalObj);
    if (UnitRateInfo?.Type?.toUpperCase() === "SUCCESS") {
      if (UnitRateInfo?.ResultSet?.length > 0) {
        return UnitRateInfo.ResultSet;
      } else {
        return [];
      }
    } else {
      fAlertToast(
        "FAILED",
        UnitRateInfo?.Type?.response?.data?.message ||
          UnitRateInfo?.message ||
          UnitRateInfo?.response?.data?.Status ||
          "Error in UnitRateArr"
      );
      return [];
    }
  };

  //TODO FULLSEARCH ,UNITARR ,AND CALCULATION
  const fItemCodeDependency = async (vItemSearchFull) => {
    let { HeadObject } = SalesReturnRo();
    const { tax1, tax2 } = vRdxtax();
    let iTax =
      HeadObject.TaxType == "OTTRN003" || HeadObject.TaxType == "OTTRN002"
        ? vRdxDBKernObj.DEF_ZERO_TAX_CODE.Val
        : vItemSearchFull[0].TaxDept;

    let iCess =
      HeadObject.TaxType == "OTTRN003" || HeadObject.TaxType == "OTTRN002"
        ? vRdxDBKernObj.DEF_ZERO_CESS_CODE.Val
        : vItemSearchFull[0].TaxDept2;
    let vRdxGRNtax1arr = tax1?.find((obj) => {
      return obj.UId === iTax;
    });

    let vRdxGRNtax2arr = tax2?.find((obj) => {
      return obj.UId === iCess;
    });

    if (vItemSearchFull.length > 0) {
      setBufferObj((obj) => ({
        ...obj,
        B_Itmcd: vItemSearchFull[0].ItmCd,
        B_ItmName: vItemSearchFull[0].Name2,
        B_Barcode: vItemSearchFull[0].BarCode,
        B_TaxDept: vRdxGRNtax1arr?.UId,
        B_TaxDept2: vRdxGRNtax2arr?.UId,
        B_TaxPerc: vRdxGRNtax1arr?.Perc,
        B_TaxPerc2: vRdxGRNtax2arr?.Perc,
      }));

      let currentUnitArr = await GetUnitArr(vItemSearchFull[0].ItmCd, setUnit);

      let iUnit = vItemSearchFull[0]?.DefUnit || "";

      if (!iUnit) {
        iUnit = vItemSearchFull[0]?.SalUOM || "";
      }

      let vItemUnitSet = currentUnitArr.find((obj) => {
        return obj.Unit === iUnit;
      });

      if (!vItemUnitSet) {
        iUnit = currentUnitArr[0]?.Unit || "";

        vItemUnitSet = currentUnitArr.find((obj) => {
          return obj.Unit === iUnit;
        });
      }

      await Unit_Onchange_001(
        iUnit,
        vItemUnitSet,
        vItemSearchFull[0]?.ItmCd,
        vRdxGRNtax1arr?.Perc,
        vRdxGRNtax2arr?.Perc
      );

      if (vRdxDBKernObj?.SONAS_INVOICE?.Val === "Y") {
        const vIncentiveGroups = await GetIncentiveGroup(
          vItemSearchFull[0]?.ItmCd,
          vRdxWmsHead.A_Loc
        );
        if (vIncentiveGroups?.Type?.toUpperCase() === "SUCCESS") {
          SetIncentiveGroups(vIncentiveGroups.ResultSet);
          if (vIncentiveGroups.ResultSet.length > 0) {
            setBufferObj((object) => ({
              ...object,
              B_IncGroup: vIncentiveGroups.ResultSet[0].UId,
              B_SuprvPerc: vIncentiveGroups.ResultSet[0].SuprvPerc,
              B_OthersPerc: vIncentiveGroups.ResultSet[0].OthersPerc,
            }));
          }
        } else {
          fAlertToast(
            "FAILED",
            vIncentiveGroups?.Message ||
              vIncentiveGroups?.response?.data?.message ||
              vIncentiveGroups?.response?.data?.Status ||
              vIncentiveGroups?.message
          );
        }
      }

      setTimeout(() => {
        document.getElementsByName("B_Qty")[0]?.focus();
      }, 100);
      document.getElementsByName("B_Qty")[0]?.focus();
    }
  };
  const Unit_Onchange_001 = async (
    xUnit = "",
    xUnitObj = {},
    xItemCode = sBufferObj.B_Itmcd,
    iTax1Perc = sBufferObj.B_TaxPerc,
    iTax2Perc = sBufferObj.B_TaxPerc2
  ) => {
    let currentPackQty = "";
    //by sir
    if (!!xUnitObj) {
      setBufferObj((obj) => ({
        ...obj,
        B_Unit: xUnitObj.Unit,
        B_UnitName: xUnitObj.Name1,
        B_PackQty: xUnitObj.PackQty,
      }));
      currentPackQty = xUnitObj?.PackQty;
    }

    let currentUnitRateArr = await GetUnitRateArr(xItemCode, xUnit);

    let currentUnitRateObj = {
      UnitRateFC: 0,
      DiscPerc: 0,
      AddCess: 0,
    };

    if (currentUnitRateArr.length > 0) {
      currentUnitRateObj = {
        UnitRateFC: currentUnitRateArr[0].UnitRateFC,
        DiscPerc: currentUnitRateArr[0].DiscPerc,
        AddCess: currentUnitRateArr[0].AddiCess,
      };
      setBufferObj((obj) => ({
        ...obj,
        B_URateFc: currentUnitRateArr[0].UnitRateFC,
        B_LDiscPerc: currentUnitRateArr[0].DiscPerc,
        AddCess: currentUnitRateArr[0].AddiCess,
      }));
    }

    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_NetAddCess,
      B_Rounding,
      B_LandVal,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      currentPackQty,
      vRdxWmsHead.A_ExRate,
      currentUnitRateObj.UnitRateFC,
      currentUnitRateObj.DiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      iTax1Perc,
      iTax2Perc,
      currentUnitRateObj.AddCess,
      0
    );
    setBufferObj((object) => ({
      ...object,
      B_Qty: sBufferObj.B_Qty,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_NetAddCess,
      B_Rounding,
      B_LandVal,
    }));
  };

  const fOnChangeSelectIncGroup = (event, selectArr) => {
    var vSelectedObj = selectArr?.find((option, index) => {
      const keys = Object.keys(option);
      return option[keys[0]] == event.target.value;
    });

    const selectObj = Object.keys(vSelectedObj);
    setBufferObj((obj) => ({
      ...obj,
      B_IncGroup: vSelectedObj[selectObj[0]],
      B_SuprvPerc: vSelectedObj[selectObj[2]],
      B_OthersPerc: vSelectedObj[selectObj[3]],
    }));
  };

  const fOnChangeSelectSupervisorSlab = (event, selectArr) => {
    setBufferObj((obj) => ({
      ...obj,
      B_SLANSuprv: event.target.value,
    }));
  };

  const fOnChangeSelectOtherSlab = (event, selectArr) => {
    setBufferObj((obj) => ({
      ...obj,
      B_SLANOther: event.target.value,
    }));
  };

  const fonChangeInputUnit = async (event, selectArr) => {
    var vSelectedObj = selectArr?.find((option, index) => {
      return option.Unit == event.target.value;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: vSelectedObj?.Unit,
      B_UnitName: vSelectedObj?.Name1,
      B_PackQty: vSelectedObj?.PackQty,
    }));

    await Unit_Onchange_001(vSelectedObj?.Unit, vSelectedObj);
  };

  const fContent_Focus = (e) => {
    if (e.target.value == 0) {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: "",
      }));
    }
  };
  const fContent_Blur = (e) => {
    if (e.target.value == "") {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: (0).toFixed(roundOffValue),
      }));
      setToggleGrid(false);
    }
  };
  const fFocusShowSalesHistoryGrid = async () => {
    let vSalesHistoryArr = await GetSalesHistory(sBufferObj.B_Itmcd);
    if (vSalesHistoryArr.length > 0) {
      setToggleGrid(true);
    } else {
      setToggleGrid(false);
    }
  };

  const fonChangeInputQty = (event) => {
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,

      B_Rounding,
      B_TaxAmt,
      B_TaxAmt2,
      B_NetAddCess,
      B_LandVal,
    } = fCalculate_Detail(
      event.target.value,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0
    );

    setBufferObj((obj) => ({
      ...obj,
      B_Qty: event.target.value,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,

      B_Rounding,
      B_TaxAmt,
      B_TaxAmt2,
      B_NetAddCess,
      B_LandVal,
    }));
  };

  const [sNarrationToggleDropdown, setNarrationToggleDropdown] =
    useState(false);

  const fonChangeInputNarration = (event) => {
    setBufferObj((obj) => ({ ...obj, Narration: event }));
    ffilterNarrationDropDownSearch(event, sNarrationSearchGridFullData);
  };

  const fNarrationKeyEnter = (e) => {
    if (e.key == "Enter" || e._reactName === "onClick") {
      setNarrationToggleDropdown(!sNarrationToggleDropdown);
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (Number(selectedLength) === 0) {
          let tabel = document.getElementById("table-main-grid-dropdown");
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const ffilterNarrationDropDownSearch = useCallback((xValue, xArray) => {
    let vNewFilterSearchArr = xArray?.filter((obj) => {
      return (
        obj.Code.toString()
          .toLowerCase()
          .includes(xValue.toString().toLowerCase()) ||
        obj.Name.toString()
          .toLowerCase()
          .includes(xValue.toString().toLowerCase())
      );
    });
    if (xValue !== "") {
      setNarrationSearchGridData(vNewFilterSearchArr);
    } else {
      setNarrationSearchGridData(xArray);
    }
  }, []);

  const fonChangeInputSupervisorAmtSc = (event) => {
    setBufferObj((obj) => ({
      ...obj,
      [event.target.name]: event.target.value,
    }));
  };

  const fonChangeInputOtherAmtSc = (event) => {
    setBufferObj((obj) => ({
      ...obj,
      [event.target.name]: event.target.value,
    }));
  };

  const fonChangeInputUnitRateFC = (event) => {
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,

      B_Rounding,
      B_TaxAmt,
      B_TaxAmt2,
      B_NetAddCess,
      B_LandVal,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      event.target.value,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0
    );

    setBufferObj((obj) => ({
      ...obj,
      [event.target.name]: event.target.value,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,

      B_Rounding,
      B_TaxAmt,
      B_TaxAmt2,
      B_NetAddCess,
      B_LandVal,
    }));
  };

  const fReason = (event) => {
    setBufferObj((obj) => ({
      ...obj,
      Reason: event.target.value,
    }));
  };

  const fGrossAmt = (event) => {
    setBufferObj((obj) => ({
      ...obj,
      B_GrossAmt: event.target.value,
    }));
    let {
      B_BaseQty,
      B_URateLc,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,

      B_Rounding,
      B_TaxAmt,
      B_TaxAmt2,
      B_NetAddCess,
      B_LandVal,
      B_URateFc,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0,
      0,
      event.target.value,
      true
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      // B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,

      B_Rounding,
      B_TaxAmt,
      B_TaxAmt2,
      B_NetAddCess,
      B_LandVal,
      B_URateFc,
    }));
  };
  const fTaxGroup = (e) => {
    let vtaxGroupValue = vRdxGRNtax1.find((obj) => {
      return obj.UId == e.target.value;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_TaxDept: vtaxGroupValue?.UId,
      B_TaxPerc: vtaxGroupValue?.Perc,
    }));
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      vtaxGroupValue?.Perc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0
    );
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    }));
  };
  const fCessGroup = (e) => {
    let vCessGroupValue = vRdxGRNtax2.find((obj) => {
      return obj.UId == e.target.value;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_TaxDept2: vCessGroupValue?.UId,
      B_TaxPerc2: vCessGroupValue?.Perc,
    }));
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      vCessGroupValue?.Perc,
      sBufferObj.AddCess,
      0
    );
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    }));
  };

  const fUnitRateFCSave_onKeyUp = (e) => {
    // if (e.key === "Enter" && !isSaved) {
    //   setIsSaved(true);
    //   fSave();
    // }

    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (
        e.key === "Enter" &&
        // !isSaved &&
        vRdxWmsHead.A_DocStat == "ENTER"
      ) {
        document.getElementsByName("B_URateFc")[0]?.blur();
        // setIsSaved(true);
        fSave();
      }
    }, 1000);
  };
  //discAmt footer
  const fonChangeInputDiscount = (event) => {
    let vTDiscAmt =
      (fcovertToNumber(event.target.value) / 100) *
      (fcovertToNumber(sFooterObj.A_GrossAmt) -
        fcovertToNumber(sFooterObj.A_LDiscAmt));
    dispatch(
      Set_SalesReturn_HeadObject_Set({
        ...vRdxWmsHead,
        A_DiscPerc: fcovertToNumber(event.target.value),
      })
    );
    set_GCDiscountPercentage_Obj({
      ...GCDiscountPercentage_Obj,
      A_DiscPerc: fcovertToNumber(event.target.value),
      A_TDiscAmt: vTDiscAmt,
    });
  };

  //Discount% modal
  const GCDiscountPercentage_fonChange_Discount = (event) => {
    let vTDiscAmt =
      (fcovertToNumber(event.target.value) / 100) *
      (fcovertToNumber(sFooterObj.A_GrossAmt) -
        fcovertToNumber(sFooterObj.A_LDiscAmt));
    set_GCDiscountPercentage_Obj({
      ...GCDiscountPercentage_Obj,
      A_DiscPerc: Number(event.target.value),
      A_TDiscAmt: vTDiscAmt.toFixed(2),
    });
  };

  //DiscountAmt modal
  const GCDiscountPercentage_fOnChange_TDiscAmt = (e) => {
    let vCheckValue =
      fcovertToNumber(sFooterObj.A_GrossAmt) -
      fcovertToNumber(sFooterObj.A_LDiscAmt);
    let vTDiscPer =
      (fcovertToNumber(e.target.value) * 100) /
      (fcovertToNumber(sFooterObj.A_GrossAmt) -
        fcovertToNumber(sFooterObj.A_LDiscAmt));
    set_GCDiscountPercentage_Obj({
      ...GCDiscountPercentage_Obj,
      A_DiscPerc:
        Number(vCheckValue) === 0 ? 0 : fcovertToNumber(vTDiscPer).toFixed(2),
      A_TDiscAmt: Number(e.target.value),
    });
  };

  const fLandValueCalc = (event) => {
    let iLandVal =
      fcovertToNumber(sFooterObj.A_GrossAmt) -
      fcovertToNumber(sFooterObj.A_TDiscAmt) -
      fcovertToNumber(sFooterObj.A_LDiscAmt) -
      fcovertToNumber(sFooterObj.A_FocAmt) +
      fcovertToNumber(sFooterObj.A_NetExcise) +
      fcovertToNumber(sFooterObj.A_Tax) +
      fcovertToNumber(sFooterObj.A_Tax2) +
      fcovertToNumber(sFooterObj.A_AddCess) +
      fcovertToNumber(Number(event.target.value));

    setFooterObj((obj) => ({
      ...obj,
      A_LandVal: iLandVal.toFixed(roundOffValue),
    }));
  };

  const fFooter_Rounding_OnChange = (event) => {
    dispatch(
      Set_SalesReturn_HeadObject_Set({
        ...vRdxWmsHead,
        A_Rounding: event.target.value,
      })
    );
    fLandValueCalc(event);
  };

  const fFooter_Rounding_Focus = (event) => {
    if (event.target.value == 0) {
      dispatch(
        Set_SalesReturn_HeadObject_Set({
          ...vRdxWmsHead,
          A_Rounding: "",
        })
      );
    }
  };

  const fFooter_Rounding_Blur = (event) => {
    const iRounding = fcovertToNumber(event.target.value);
    if (iRounding == 0) {
      dispatch(
        Set_SalesReturn_HeadObject_Set({
          ...vRdxWmsHead,
          A_Rounding: (0).toFixed(4),
        })
      );

      fLandValueCalc(event);
    }
  };

  const fonChangeInputLDisc = (event) => {
    if (event.target.value <= 100) {
      let {
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,

        B_Rounding,
        B_TaxAmt,
        B_TaxAmt2,
        B_NetAddCess,
        B_LandVal,
      } = fCalculate_Detail(
        sBufferObj.B_Qty,
        sBufferObj.B_PackQty,
        vRdxWmsHead.A_ExRate,
        sBufferObj.B_URateFc,
        event.target.value,
        sBufferObj.B_TDiscPerc,
        sBufferObj.B_FocFlag,
        sBufferObj.B_ExciseTaxAmt,
        sBufferObj.B_TaxPerc,
        sBufferObj.B_TaxPerc2,
        sBufferObj.AddCess,
        0
      );

      setBufferObj((obj) => ({
        ...obj,
        [event.target.name]: event.target.value,
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,

        B_Rounding,
        B_TaxAmt,
        B_TaxAmt2,
        B_NetAddCess,
        B_LandVal,
      }));
    }
  };

  const fonChangeInputLDiscAmt = (event) => {
    setBufferObj((obj) => ({
      ...obj,
      B_LDiscAmt: event.target.value,
    }));
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      // B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,

      B_Rounding,
      B_TaxAmt,
      B_TaxAmt2,
      B_NetAddCess,
      B_LandVal,
      B_LDiscPerc,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0,
      0,
      sBufferObj.B_GrossAmt,
      false,
      event.target.value,
      true
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,

      B_Rounding,
      B_TaxAmt,
      B_TaxAmt2,
      B_NetAddCess,
      B_LandVal,
      B_LDiscPerc,
    }));
  };

  const fonChangeInputExcise = (event) => {
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,

      B_Rounding,
      B_TaxAmt,
      B_TaxAmt2,
      B_NetAddCess,
      B_LandVal,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      event.target.value,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0
    );

    setBufferObj((obj) => ({
      ...obj,
      [event.target.name]: event.target.value,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_NetAddCess,
      B_Rounding,

      B_LandVal,
    }));
  };

  const fonChangeCheckBoxFoc = (event) => {
    let isChecked = event.target.checked ? "Y" : "N";
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,

      B_Rounding,
      B_TaxAmt,
      B_TaxAmt2,
      B_NetAddCess,
      B_LandVal,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      isChecked,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0
    );

    setBufferObj((obj) => ({
      ...obj,
      B_FocFlag: isChecked,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,

      B_Rounding,
      B_TaxAmt,
      B_TaxAmt2,
      B_NetAddCess,
      B_LandVal,
    }));
  };

  const [GCAudit_xAuditId, set_GCAudit_AuditId] = useState("All");
  const GCAudit_OnChange_Select = (e) => {
    set_GCAudit_AuditId(e.target.value);
    GCAudit_GetTransAudit(e.target.value);
  };

  const fClearItem = (event) => {
    setGridSelectRowData([]);
  };

  //GCItemSearch

  //GCItemSearch

  //mahmoodha
  //GCToggleSearch_Item start
  //Item Search
  const [xcolumnsDropdownSearch, setxcolumnsDropdownSearch] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "ItmCd", headerName: "Item Code", width: 100 },
    { field: "Name2", headerName: "Name", width: 450 },
    { field: "Barcode", headerName: "Barcode", width: 220 },
  ]);
  const [
    GCToggleSearch_Item_Row_GridData,
    set_GCToggleSearch_Item_Row_GridData,
  ] = useState([]); //for item search

  //API
  const Get_GCToggleSearch_Item_Exact = async (
    xItemName,
    xLoc = vRdxWmsHead.A_Loc
  ) => {
    let vItemFullSearchDataObj = {
      anyData: xItemName,
      transType: "F",
      report: "Y",
      loc: xLoc,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vItemFullSearchDataObj);

    const vItemSearchFull = await fExecuteAPI(
      // "ITEM_SEARCHFULL_GETROW",
      "SEARCHEXACTITEM_GETROW",
      FinalObj
    );
    //status code "" so Success is checked
    if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
      if (vItemSearchFull.ResultSet.length > 0) {
        return vItemSearchFull.ResultSet;
      } else {
        return [];
      }
    } else {
      fAlertToast(
        "FAILED",
        vItemSearchFull?.Type?.response?.data?.message ||
          vItemSearchFull?.message ||
          vItemSearchFull.response.data.Status ||
          "Error in vItemSearchFullArr"
      );
      return [];
    }
  };

  const GCToggleSearch_Item_Main_Enter = async (e, ModalName) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      //not to open modal if value is exact match
      if (sBufferObj.B_Itmcd == "") {
        const vItemSearchFull = await Get_GCToggleSearch_Item_Exact(
          sBufferObj.B_ItmName
        );
        if (vItemSearchFull.length > 0) {
          fItemCodeDependency(vItemSearchFull);
        } else {
          GCToggleSearch_Item_Open_Toggle(e);
        }
      } else {
        setTimeout(() => {
          document.getElementsByName("B_Qty")[0]?.focus();
        }, 200);
      }
    } else if (e.key === "Backspace") {
      let {
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,

        B_Rounding,
        B_TaxAmt,
        B_TaxAmt2,
        B_NetAddCess,
        B_LandVal,
      } = fCalculate_Detail(
        0, //sBufferObj.B_Qty,
        0, //sBufferObj.B_PackQty,
        vRdxWmsHead.A_ExRate, //exchangeRate
        0, //sBufferObj.B_URateFc,
        0, //sBufferObj.B_LDiscPerc,
        0, //sBufferObj.B_TDiscPerc,
        "N", //sBufferObj.B_FocFlag,
        0, //sBufferObj.B_ExciseTaxAmt,
        vRdxGRNtax1[0].Perc,
        vRdxGRNtax2[0].Perc,
        sBufferObj.AddCess,
        0 //Rounding
      );

      setBufferObj((obj) => ({
        ...obj,
        B_Itmcd: "",
        B_ItmName: e.target.value,

        B_Unit: "",
        B_UnitName: "",
        B_PackQty: "",
        B_URateFc: 0,
        B_LDiscPerc: 0,

        B_IncGroup: "",
        B_SuprvPerc: 0,
        B_SLANOther: 0,
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,
        B_Rounding,
        B_TaxAmt,
        B_TaxAmt2,
        B_NetAddCess,
        B_LandVal,
      }));

      setUnit([]);
      SetIncentiveGroups([]);
    }
  };

  //ItemSearch Dropdowm
  const [GCToggleSearch_Item_ToggleDropdown, setToggleDropdown] =
    useState(false);

  const handleClick = useCallback(() => {
    if (GCToggleSearch_Item_ToggleDropdown) {
      setToggleDropdown(false);
      set_GCToggleSearch_Item_Row_GridData([]);
      set_GCToggleSearch_Item_Obj({
        Type: "Any",
        Data: "",
      });
    } else {
      setToggleDropdown(true);
    }
  }, [GCToggleSearch_Item_ToggleDropdown]);

  const [GCToggleSearch_Item_Obj, set_GCToggleSearch_Item_Obj] = useState({
    Type: "Any",
    Data: "",
  });

  const GCToggleSearch_Item_Sub_Input = (e) => {
    set_GCToggleSearch_Item_Obj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const GCToggleSearch_Item_Sub_Enter = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      Get_GCToggleSearch_Item_Dropdown_Grid(
        GCToggleSearch_Item_Obj.Data,
        GCToggleSearch_Item_Obj.Type,
        vRdxWmsHead.A_Loc,
        set_GCToggleSearch_Item_Row_GridData
      );
    }
    //   id="table-main-grid-dropdown"
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (Number(selectedLength) === 0) {
          // let tabel = document.getElementById("table-main-grid-dropdown");
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const GCToggleSearch_Item_Open_Toggle = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      set_GCToggleSearch_Item_Obj((obj) => ({
        ...obj,
        Data: sBufferObj.B_ItmName,
      }));
      if (sBufferObj.B_ItmName != "") {
        Get_GCToggleSearch_Item_Dropdown_Grid(
          sBufferObj.B_ItmName,
          "Any",
          vRdxWmsHead.A_Loc,
          set_GCToggleSearch_Item_Row_GridData
        );
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      handleClick();
    }
  };

  const GCToggleSearch_Item_Main_Input = (event) => {
    setBufferObj((obj) => ({
      ...obj,
      [event.target.name]: event.target.value,
    }));
    // ffilterDropDownSearch(event.target.value, sSearchGridDataFullData);
  };

  const GCToggleSearch_Item_fOnCellClick = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      GCToggleSearch_Item_fOnRowClick(newSelectionModel);
    }
  };

  const GCToggleSearch_Item_fOnRowClick = async (e) => {
    const vItemSearchFull = await Get_GCToggleSearch_Item_Exact(e?.row?.ItmCd);
    if (vItemSearchFull.length > 0) {
      fItemCodeDependency(vItemSearchFull);
    }

    if (!vIsDownKeyPressed) {
      setToggleDropdown(false);
      fCloseInvoiceSalesModal();
      document.getElementsByName("B_Qty")[0]?.focus();
    }
    vIsDownKeyPressed = false;
  };

  //GCToggleSearch_Item end

  //GCToggleSearch_Customer start
  //Customer Search
  const [columnsCustomerDropdownSearch, setcolumnsCustomerDropdownSearch] =
    useState([
      {
        field: "id",
        headerName: "ID",
        hide: true,
        width: 70,
        align: "center",
        headerAlign: "center",
        Typ: "S",
        NumberFormat: "0",
      },
      {
        field: "AcCd",
        headerName: "Code",
        hide: false,
        width: 72,
        align: "left",
        headerAlign: "left",
        Typ: "S",
        NumberFormat: "0",
      },
      {
        field: "Name2",
        headerName: "Name2",
        hide: false,
        width: 450,
        align: "left",
        headerAlign: "left",
        Typ: "S",
        NumberFormat: "0",
      },
      {
        field: "Name1",
        headerName: "Name1",
        hide: false,
        width: 450,
        align: "left",
        headerAlign: "left",
        Typ: "S",
        NumberFormat: "0",
      },
    ]);
  const [
    GCToggleSearch_Customer_Row_GridData,
    set_GCToggleSearch_Customer_Row_GridData,
  ] = useState([]); //for ARR FOR CUSTOMER SEARCH

  const [
    GCToggleSearch_Customer_ModelObj,
    set_GCToggleSearch_Customer_ModelObj,
  ] = useState({
    AnyData: "",
    Name: "",
    Code: "",
  });

  const fClearSimpleSearch = () => {
    set_GCToggleSearch_Customer_ModelObj({
      ...GCToggleSearch_Customer_ModelObj,
      AnyData: "",
      Name: "",
      Code: "",
    });
  };

  const [
    GCToggleSearch_Customer_CloseModal,
    set_GCToggleSearch_Customer_Close_Modal,
  ] = useState(false);
  // const GCToggleSearch_Customer_Open_Modal = () => {
  //   set_GCToggleSearch_Customer_Close_Modal(true);
  // };
  const GCToggleSearch_Customer_fCloseModal = (e) => {
    set_GCToggleSearch_Customer_Close_Modal(false);
    fClearSimpleSearch();

    set_GCToggleSearch_Customer_ModelObj({
      AnyData: "",
      Name: "",
      Code: "",
    });
  };

  const GCToggleSearch_Customer_RowClick = async (e) => {
    // let iDefaultTaxType = await GetTransTaxType(
    //   vRdxWmsHead.A_Loc,
    //   e?.row?.AcCd
    // );
    let vDefaultTaxType = "OTTRN001";
    let iDefaultTaxType = await GetTransTaxType(
      vRdxWmsHead.A_Loc,
      e?.row?.AcCd
    );
    if (Object.keys(iDefaultTaxType[0]).length != 0) {
      vDefaultTaxType = iDefaultTaxType[0]?.TaxType;
    }
    //if inter.comp then tax group should be 0
    if (vDefaultTaxType == "OTTRN002" || vDefaultTaxType == "OTTRN003") {
      InterCompanyDependency(
        vRdxDBKernObj.DEF_ZERO_TAX_CODE.Val,
        vRdxDBKernObj.DEF_ZERO_CESS_CODE.Val
      );
    }

    dispatch(
      Set_SalesReturn_HeadObject_Set({
        ...vRdxWmsHead,
        A_Party: e?.row?.AcCd,
        A_PartyName: e?.row?.Name1,
        A_Buyer: e?.row?.SalesmanCode,
        A_TaxType: vDefaultTaxType,
      })
    );

    if (!vIsDownKeyPressedSimpleSearch) {
      GetDefcustomersetting(e?.row?.AcCd, vRdxWmsHead.A_Loc);
      DefaultPriceLevel(e?.row?.AcCd, vRdxWmsHead.A_Loc);
      setTimeout(() => {
        document.getElementsByName("B_ItmName")[0]?.focus();
      }, 500);
      GCToggleSearch_Customer_fCloseModal();
      set_GCToggleSearch_Customer_Toggle(false);
    }
    vIsDownKeyPressedSimpleSearch = false;
  };

  const GCToggleSearch_Customer_RowCellClick = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      GCToggleSearch_Customer_RowClick(newSelectionModel);
    }
  };

  const GCToggleSearch_Customer_Enter_ModalKey = async (e, ModalName) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      const vSupplierSearchDataObj = {
        Typ: "D",
        Data: vRdxWmsHead?.A_PartyName ?? "",
      };

      const vSupplierSearch = await SubKonten_Search_Full_V3Api(
        vSupplierSearchDataObj
      );

      if (vSupplierSearch?.status === 200) {
        const rows = vSupplierSearch?.data?.ResultSet ?? [];
        if (rows.length > 0) {
          const vSupplier = rows[0];

          let vDefaultTaxType = "OTTRN001";
          let iDefaultTaxType = await GetTransTaxType(
            vRdxWmsHead.A_Loc,
            vSupplier?.AcCd
          );
          if (Object.keys(iDefaultTaxType[0]).length != 0) {
            vDefaultTaxType = iDefaultTaxType[0]?.TaxType;
          }
          //if inter.comp then tax group should be 0
          if (vDefaultTaxType == "OTTRN002" || vDefaultTaxType == "OTTRN003") {
            InterCompanyDependency(
              vRdxDBKernObj.DEF_ZERO_TAX_CODE.Val,
              vRdxDBKernObj.DEF_ZERO_CESS_CODE.Val
            );
          }

          if (!!vSupplier) {
            if (iDefaultTaxType.length > 0) {
              dispatch(
                Set_SalesReturn_HeadObject_Set({
                  ...vRdxWmsHead,
                  A_Party: vSupplier?.AcCd,
                  A_PartyName: vSupplier?.Name1,
                  A_Buyer: vSupplier?.SalesmanCode,
                  A_TaxType: vDefaultTaxType,
                })
              );
              GetDefcustomersetting(vSupplier?.AcCd, vRdxWmsHead.A_Loc);
              DefaultPriceLevel(vSupplier?.AcCd, vRdxWmsHead.A_Loc);
            } else {
              dispatch(
                Set_SalesReturn_HeadObject_Set({
                  ...vRdxWmsHead,
                  A_Party: vSupplier?.AcCd,
                  A_PartyName: vSupplier?.Name1,
                })
              );
            }

            setTimeout(() => {
              fKeyTabInput(e, "B_ItmName");
            }, 500);
          } else {
            GCToggleSearch_Customer_SearchModalKey(e);
          }
          if (vRdxWmsHead.A_Party != "") {
            setTimeout(() => {
              fKeyTabInput(e, "B_ItmName");
            }, 500);
          }
        } else {
          GCToggleSearch_Customer_SearchModalKey(e);
        }
      }
    }
    if (e.key === "Backspace") {
      dispatch(
        Set_SalesReturn_HeadObject_Set({
          ...vRdxWmsHead,
          A_Party: "",
          A_PartyName: e.target.value,
        })
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          // let tabel = document.getElementById("table-main-grid-dropdown");
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const [GCToggleSearch_Customer_Toggle, set_GCToggleSearch_Customer_Toggle] =
    useState(false);
  const [GCToggleSearch_Customer_Obj, setGCToggleSearch_Customer_Obj] =
    useState({
      Type: "Any",
      Data: "",
    });
  const GCToggleSearch_Customer_Sub_Input = (e) => {
    setGCToggleSearch_Customer_Obj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const GCToggleSearch_Customer_Click = useCallback(() => {
    if (GCToggleSearch_Customer_Toggle) {
      set_GCToggleSearch_Customer_Toggle(false);
      set_GCToggleSearch_Customer_Row_GridData([]);
      set_GCToggleSearch_Item_Obj({
        Type: "Any",
        Data: "",
      });
    } else {
      set_GCToggleSearch_Customer_Toggle(true);
    }
  }, [GCToggleSearch_Customer_Toggle]);

  const GCToggleSearch_Customer_OnKeyUpCustomer = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      Get_GCToggleSearch_Customer_Api(
        GCToggleSearch_Customer_Obj.Data,
        GCToggleSearch_Customer_Obj.Type,
        vRdxWmsHead.A_Loc,
        set_GCToggleSearch_Customer_Row_GridData
      );
    }
    //   id="table-main-grid-dropdown"
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          // let tabel = document.getElementById("table-main-grid-dropdown");
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );

          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const GCToggleSearch_Customer_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setGCToggleSearch_Customer_Obj((obj) => ({
        ...obj,
        Data: vRdxWmsHead.A_PartyName,
      }));
      if (vRdxWmsHead.A_PartyName != "") {
        Get_GCToggleSearch_Customer_Api(
          vRdxWmsHead.A_PartyName,
          "Any",
          vRdxWmsHead.A_Loc,
          set_GCToggleSearch_Customer_Row_GridData
        );
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      GCToggleSearch_Customer_Click();
    }
  };
  const GCToggleSearch_Customer_Main_Input = (event) => {
    //IN MOBILE Backspace KEY NOT DETECTED TO CALL API WE USE BLUR
    if (
      event.target.value.length < vRdxWmsHead.A_PartyName.toString().length &&
      vMediaQuery &&
      event.target.name === "A_PartyName"
    ) {
      var vBackspaceObj = {
        key: "Backspace",
      };
      GCToggleSearch_Customer_Enter_ModalKey(vBackspaceObj);
    }
    dispatch(
      Set_SalesReturn_HeadObject_Set({
        ...vRdxWmsHead,
        [event.target.name]: event.target.value,
      })
    );

    set_GCToggleSearch_Customer_ModelObj((obj) => ({
      ...obj,
      AnyData: event.target.value,
    }));
    // ffilterCustomerDropDownSearch(
    //   event.target.value,
    //   sCustFullSearchGridData
    // );
  };
  //GCToggleSearch_Customer end

  //GCSearch
  const GCSearch_fTrans_fRowCellClick = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fDisplay(e?.row?.A_VocTyp, e?.row?.A_VocNo);
      GCSearch_fClose();
      GCSearch_fClear();
    }
  };
  //GCSearch
  const GCSearch_fTrans_fRowClick = (e) => {
    fDisplay(e?.row?.A_VocTyp, e?.row?.A_VocNo);
    GCSearch_fClose();
    GCSearch_fClear();
  };

  const xfGCSearchBtn_Name = (e) => {
    setGCSearchBtn_ToggleDropDowm(false);
    setSearchModalObj((obj) => ({
      ...obj,
      Party: "",
      PartyName: e.target.value,
    }));
  };

  const [
    sGCSearchBtn_SearchDropdownObj_SearchDropdownObj,
    setGCSearchBtn_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });
  const [sGCSearchBtn_GridData, setGCSearchBtn_GridData] = useState([]);
  const [sGCSearchBtn_Toggle_ToggleDropDowm, setGCSearchBtn_ToggleDropDowm] =
    useState(false);

  const xfGCSearchBtn_Toggle = useCallback(() => {
    if (sGCSearchBtn_Toggle_ToggleDropDowm) {
      setGCSearchBtn_ToggleDropDowm(false);
      setGCSearchBtn_GridData([]);
      setGCSearchBtn_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setGCSearchBtn_ToggleDropDowm(true);
    }
  }, [sGCSearchBtn_Toggle_ToggleDropDowm]);

  //2nd call
  const fGCSearchBtn_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setGCSearchBtn_SearchDropdownObj((obj) => ({
        ...obj,
        Data: GCSearch_Obj.PartyName,
      }));
      if (GCSearch_Obj.PartyName != "") {
        const vLandedCostExactSearch = await Get_GCSearchBtn(
          GCSearch_Obj.PartyName,
          "Any",
          "N"
        );
        setGCSearchBtn_GridData(vLandedCostExactSearch);
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      xfGCSearchBtn_Toggle();
    }
  };

  //1stcall
  const fGCSearchBtn_onKeyUp_onKeyUp = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      //not to open modal if value is exact match
      if (GCSearch_Obj.Party == "") {
        const vLandedCostExactSearch = await Get_GCSearchBtn(
          GCSearch_Obj.PartyName,
          "Any",
          "Y"
        );
        if (vLandedCostExactSearch.length > 0) {
          setSearchModalObj((obj) => ({
            ...obj,
            Party: vLandedCostExactSearch[0].AcCd,
            PartyName: vLandedCostExactSearch[0].Name2,
          }));
          Get_GCSearchBtn(
            "",
            "APICallPartyModal",
            vLandedCostExactSearch[0].AcCd
          );
        } else {
          fGCSearchBtn_Dropdown_SearchModalKey(e);
        }
      }
    } else if (e.key === "Backspace") {
      setSearchModalObj((obj) => ({
        ...obj,
        Party: "",
      }));
    }
  };

  const xGCSearchBtn_Dropdown_onChange = (e) => {
    setGCSearchBtn_SearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fGCSearchBtn__Dropdown_OnKeyUp_Load = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      const vLandedCostDropdownSearch = await Get_GCSearchBtn(
        sGCSearchBtn_SearchDropdownObj_SearchDropdownObj.Data,
        sGCSearchBtn_SearchDropdownObj_SearchDropdownObj.Type
      );
      if (vLandedCostDropdownSearch.length > 0) {
        setGCSearchBtn_GridData(vLandedCostDropdownSearch);
      } else {
        setGCSearchBtn_GridData([]);
      }
    }
    //   id="table-main-grid-dropdown"

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fGCSearchBtn_OnRowClick = (e) => {
    setSearchModalObj((obj) => ({
      ...obj,
      Party: e?.row?.AcCd,
      PartyName: e?.row?.Name2,
    }));
    GCSearch_Get("", "APICallPartyModal", e?.row?.AcCd);
    xfGCSearchBtn_Toggle();
  };
  const fGCSearchBtn_OnCellKeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGCSearchBtn_OnRowClick(newSelectionModel);
    }
  };
  //GCSearchBtn End

  //Narration input search
  const OnCellKeyNarrationDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      OnRowNarrationClick(newSelectionModel);
    }
  };

  //Narration input search
  const OnRowNarrationClick = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      Narration: e?.row?.Name,
    }));
    setNarrationToggleDropdown(false);
  };

  const fClearErrorMsg = () => {
    setErrorMsg(vErrorMessageInit);
    setErrorMsgDetail(vErrorMessageDetailInit);
    setGridSalesHistoryRowData([]);
    GCReverse_setRevNarr("");
    setToggleGrid(false);
  };

  const fNew = async () => {
    fClearErrorMsg();
    if (sBufferObj.B_ItmName == "") {
      fNewHead();
      document.getElementsByName("A_PartyName")[0]?.focus();
    } else {
      fNewDetail(
        vRdxWmsHead.A_VocNo,
        vRdxWmsHead.A_Rounding,
        vRdxWmsHead.A_VocTyp,
        vRdxWmsHead.A_TaxType
      );
    }
  };

  const fNewHead = async () => {
    fClearErrorMsg();
    dispatch(Set_SalesReturn_HeadObject_Init()); // Head Clearing
    // Setting Initial List Box 0th Object
    // let iDefaultTaxType = await GetTransTaxType(sLocation[0].UId, "");
    let idefaultTaxTypeValue = "OTTRN001";
    let iDefault = sDefault?.find((x) => x?.Field == "LOCATION");

    let iLoc = sLocation[0]?.UID;
    if (iDefault) {
      iLoc = iDefault?.val;
    }
    let iDefaultTaxType = await GetTransTaxType(
      iLoc, //locaation
      ""
    );

    // GetSalesGroups(sLocation[0]?.UID);
    if (Object.keys(iDefaultTaxType[0]).length != 0) {
      idefaultTaxTypeValue = iDefaultTaxType[0]?.TaxType;
    }

    console.log(sDefault);

    const vSalesGroup = await GetSalesGroups(iLoc);
    dispatch(
      Set_SalesReturn_HeadObject_New({
        A_VocTyp: sDocLoading[0]?.VocTyp,
        A_VocTypName: sDocLoading[0]?.VocName,
        A_VocNo: 0,
        A_Loc: iLoc,
        A_Curr: sCurrency[0]?.Uid,
        A_Currname: sCurrency[0]?.Name1,
        A_ExRate: sCurrency[0]?.Rate,
        A_Type: vRdxPricelevel[0]?.UId,
        A_Buyer: "", //sSalesman[0]?.UId,
        A_SalesGroup:
          vSalesGroup?.ResultSet.length > 0
            ? vSalesGroup?.ResultSet[0]?.UId
            : "",
        A_TaxType: idefaultTaxTypeValue,
      })
    );

    fDefaultPayload("CASH", dispatch, setPaymodeEnable);

    setNavDocValue(1); // nav init 1
    setDetailGridData([]);
    // setBufferObj(vBufferObjInit);
    setFooterObj((obj) => ({
      ...obj,
      A_GrossAmt: (0).toFixed(roundOffValue),
      A_TDiscAmt: (0).toFixed(roundOffValue),
      A_LDiscAmt: (0).toFixed(roundOffValue),
      A_FocAmt: (0).toFixed(roundOffValue),
      A_NetExcise: (0).toFixed(roundOffValue),
      A_Tax: (0).toFixed(roundOffValue),
      A_Tax2: (0).toFixed(roundOffValue),
      A_AddCess: (0).toFixed(roundOffValue),
      A_LandVal: (0).toFixed(roundOffValue),
    }));
    // RefNoFocusOnLoad.current.focus();
    fNewDetail(0, 0, sDocLoading[0].VocTyp, idefaultTaxTypeValue);
    document.getElementsByName("A_PartyName")[0]?.focus();
  };

  const fNewDetail = (xVocNo, xRounding, xVocTyp, vTaxType) => {
    fClearErrorMsg();
    const { HeadObject } = SalesReturnRo();
    setBufferObj(vBufferObjInit);

    setBufferObj((obj) => ({
      ...obj,
      B_TDiscPerc: HeadObject?.A_DiscPerc,
    }));

    SetIncentiveGroups([]);
    let iTaxPerc = 0;
    let iCessPerc = 0;
    if (vTaxType == "OTTRN003" || vTaxType == "OTTRN002") {
      let vtaxGroupValue = vRdxGRNtax1.find((obj) => {
        return obj.UId == vRdxDBKernObj.DEF_ZERO_TAX_CODE.Val;
      });
      let vCessGroupValue = vRdxGRNtax2.find((obj) => {
        return obj.UId == vRdxDBKernObj.DEF_ZERO_CESS_CODE.Val;
      });
      if (vtaxGroupValue) {
        setBufferObj((obj) => ({
          ...obj,
          B_TaxDept: vtaxGroupValue?.UId,
          B_TaxPerc: vtaxGroupValue?.Perc,
          B_TaxDept2: vCessGroupValue?.UId,
          B_TaxPerc2: vCessGroupValue?.Perc,
        }));
      }
      iTaxPerc = vtaxGroupValue?.Perc;
      iCessPerc = vCessGroupValue?.Perc;
    }
    setUnit([]);

    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,

      B_Rounding,
      B_TaxAmt,
      B_TaxAmt2,
      B_NetAddCess,
      B_LandVal,
    } = fCalculate_Detail(
      0, //sBufferObj.B_Qty,
      0, //sBufferObj.B_PackQty,
      sCurrency[0]?.Rate, //exchangeRate
      0, //sBufferObj.B_URateFc,
      0, //sBufferObj.B_LDiscPerc,
      HeadObject?.A_DiscPerc, //sBufferObj.B_TDiscPerc,
      "N", //sBufferObj.B_FocFlag,
      0, //sBufferObj.B_ExciseTaxAmt,
      vTaxType == "OTTRN003" || vTaxType == "OTTRN002"
        ? iTaxPerc
        : vRdxGRNtax1[0].Perc, //tax1%
      vTaxType == "OTTRN003" || vTaxType == "OTTRN002"
        ? iCessPerc
        : vRdxGRNtax2[0].Perc, //tax%2
      0, //sBufferObj.AddCess,
      0 //Rounding
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,

      B_Rounding,
      B_TaxAmt,
      B_TaxAmt2,
      B_NetAddCess,
      B_LandVal,
    }));

    fLoad_Grid(xVocNo, 0, xRounding, xVocTyp);

    document.getElementsByName("B_ItmName")[0]?.focus();
  };
  const [GridData_Columns_Detail, setGridData_Columns_Detail] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },

    // {
    //   field: "Open",
    //   headerName: "Open",
    //   hide: false,
    //   width: 100,
    //   renderCell: (params) => {
    //     return (
    //       <Button
    //         size="small"
    //         color="primary"
    //         onClick={() => {
    //           fDetail_Grid_DoubleClick(params);
    //         }}
    //       >
    //         open
    //       </Button>
    //     );
    //   },
    // },
    {
      field: "B_Srno",
      headerName: "Sr.No",
      width: 50,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_Itmcd",
      headerName: "Item Code",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "ItmName",
      headerName: "Item Name",
      width: 300,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_Qty",
      headerName: "Qty",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "UnitName",
      headerName: "Unit",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_URateFc",
      headerName: "Unit Rate",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_GrossAmt",
      headerName: "Gross.Amt",
      width: 90,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_LDiscPerc",
      headerName: "L Disc %",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_LDiscAmt",
      headerName: "L Disc.Amt",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_FocAmt",
      headerName: "Foc.Amt",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_NetAmt",
      headerName: "Net.Amt",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_ExciseTaxNetAmt",
      headerName: "B_ExciseTaxNetAmt",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_TaxAmt",
      headerName: "B_TaxAmt1",
      width: 100,
      headerClassName: "grid-header-row",
    },

    {
      field: "B_ExciseTaxAmt",
      headerName: "B_ExciseTaxAmt",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "SplDiscAmt1",
      headerName: "SplDiscAmt1",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_TaxDept",
      headerName: "B_TaxDept",
      width: 150,
      headerClassName: "grid-header-row",
    },

    {
      field: "B_Unit",
      headerName: "B_Unit",
      width: 100,
      hide: true,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_BaseQty",
      headerName: "B_BaseQty",
      width: 90,
      hide: true,
      headerClassName: "grid-header-row",
    },
    {
      field: "B_URateLc",
      headerName: "B_URateLc",
      width: 90,
      hide: true,
      headerClassName: "grid-header-row",
    },

    { field: "B_TDiscPerc", headerName: "B_TDiscPerc", width: 90, hide: true },
    { field: "B_TDiscAmt", headerName: "B_TDiscAmt", width: 90, hide: true },
    { field: "B_FocFlag", headerName: "B_FocFlag", width: 90, hide: true },
    { field: "B_TaxPerc", headerName: "B_TaxPerc", width: 90, hide: true },
    { field: "B_Rounding", headerName: "B_Rounding", width: 90, hide: true },
    { field: "B_LandVal", headerName: "B_LandVal", width: 90, hide: true },
    { field: "B_RefDocTyp", headerName: "B_RefDocTyp", width: 90, hide: true },
    { field: "RefVocName", headerName: "RefVocName", width: 90, hide: true },
    { field: "B_RefDocNo", headerName: "B_RefDocNo", width: 90, hide: true },
    { field: "B_BatchNo", headerName: "B_BatchNo", width: 90, hide: true },
    { field: "BatchCrl", headerName: "BatchCrl", width: 90, hide: true },
    { field: "DOFlag", headerName: "DOFlag", width: 90, hide: true },

    { field: "B_TaxDept2", headerName: "B_TaxDept2", width: 90, hide: true },
    { field: "B_TaxPerc2", headerName: "B_TaxPerc2", width: 90, hide: true },
    { field: "B_TaxAmt2", headerName: "B_TaxAmt2", width: 90, hide: true },
    { field: "B_IncGroup", headerName: "B_IncGroup", width: 100, hide: true },
    {
      field: "IncGroupName",
      headerName: "IncGroupName",
      width: 100,
      hide: true,
    },
    { field: "B_SuprvPerc", headerName: "B_SuprvPerc", width: 90, hide: true },
    {
      field: "B_OthersPerc",
      headerName: "B_OthersPerc",
      width: 90,
      hide: true,
    },
    { field: "B_SLANSuprv", headerName: "B_SLANSuprv", width: 90, hide: true },
    {
      field: "B_SlabAmtSuprv",
      headerName: "B_SlabAmtSuprv",
      width: 90,
      hide: true,
    },
    { field: "B_SLANOther", headerName: "B_SLANOther", width: 90, hide: true },
    {
      field: "B_SlabAmtOther",
      headerName: "B_SlabAmtOther",
      width: 90,
      hide: true,
    },
    { field: "Field8", headerName: "Field8", width: 90, hide: true },
  ]);
  const [GridDataSalesHistoryColumns, setGridDataSalesHistoryColumns] =
    useState(GridDataSalesHistoryColumns_Def);
  const [GCAudit_GridData_Columns, setGridDataAuditColumns] = useState(
    GCAudit_GridData_Columns_Def
  );
  const [GridDataColumnsSearch, setGridDataColumnsSearch] = useState(
    GCSearch_GridData_Columns_Def
  );
  useEffect(() => {
    // GetGitterColumns(
    //   setGridData_Columns_Detail,
    //   "INV08B001",
    //   GridData_Columns_Detail_Def
    // );
    // GetGitterColumns(
    //   setcolumnsCustomerDropdownSearch,
    //   "WMS_SALES_INVOICE_CUST",
    //   columnsCustomerDropdownSearch
    // );
    GetGitterColumns(
      setxcolumnsDropdownSearch,
      "WMS_SALES_INVOICE_ITEM_SEARCH",
      xcolumnsDropdownSearch
    );
    GetGitterColumns(
      setGridDataSalesHistoryColumns,
      "STKQRYWB",
      GridDataSalesHistoryColumns_Def
    );
    GetGitterColumns(
      setGridDataAuditColumns,
      "WMS_SALES_INVOICE_AUDIT",
      GCAudit_GridData_Columns_Def
    );
    GetGitterColumns(
      setGridDataColumnsSearch,
      "WMS_SALES_INVOICE_SEARCH",
      GCSearch_GridData_Columns_Def
    );
    GetGitterColumns(
      setGridDataAccountDetailColumns,
      "ACPSTINGDTLTRNS",
      sGridDataAccountDetailColumns
    );
    GetGitterColumns(
      setGridDataLinkDocumentColumns,
      "WMINV08LINKDDOC",
      sGridDataLinkDocumentColumns
    );
  }, []);
  useEffect(() => {
    console.log("sBufferObj", sBufferObj);
  }, [sBufferObj]);

  const GCReverse_fReverse = (e) => {
    GCReverse_fClose();
    confirmAlert({
      title: "Reverse",
      message: "Are you sure to Reverse.",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: () => fSave(),
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => GCReverse_setRevNarr(""),
        },
      ],
    });
  };
  let timeout = null;

  const processResponse = (
    response,
    xsave = true,
    docstatus = vRdxWmsHead.A_DocStat
  ) => {
    console.log("response", response);
    // Step 1: Check if there's any STOP type message
    const stopItem = response.find((item) => item.Type === "STOP");

    if (stopItem) {
      fAlertToast("FAILED", stopItem.Message);
      return false;
    }

    // Step 2: If no STOP, process CONFIRMATION dialogs
    let confirmationIndex = 0;
    console.log("confirmationIndex", confirmationIndex);

    const askConfirmation = async () => {
      if (confirmationIndex >= response.length) {
        // All confirmations processed successfully
        // fAlertToast("SUCCESS", "Saved Successfully");
        await handleSaveOrApprove(xsave, docstatus);
        // return true;
      }

      const currentItem = response[confirmationIndex];
      if (currentItem?.Type === "CONFIRMATION") {
        setTimeout(() => {
          confirmAlert({
            title: "Confirmation",
            message: currentItem.Message,
            buttons: [
              {
                label: "Yes",
                onClick: () => {
                  confirmationIndex = confirmationIndex + 1;
                  askConfirmation(); // Proceed to next confirmation
                },
              },
              {
                label: "No",
                onClick: () => {
                  fAlertToast("FAILED", currentItem.Message);
                  return false;
                },
              },
            ],
          });
        }, 200);
      }
    };

    askConfirmation();
  };
  const handleSaveOrApprove = async (
    xsave = true,
    docstatus = vRdxWmsHead.A_DocStat
  ) => {
    if (vRdxWmsHead.A_VocNo == "0" || !xsave) {
      setTimeout(() => {
        confirmAlert({
          title: `${xsave ? "Save" : "Approve"}`,
          message: `Are you want to ${xsave ? "Save" : "Approve"}?`,
          buttons: [
            {
              className: "alertBtn",
              name: "SaveYes",
              label: "Yes",
              onClick: async () => {
                await SaveINV09(xsave, docstatus);
              },
            },
            {
              className: "alertBtn",
              label: "No",
              onClick: () => {
                return;
              },
            },
          ],
        });
      }, 100);
      setTimeout(() => {
        document.getElementsByName("SaveYes")[0]?.focus();
      }, 150);
    } else if (xsave) {
      await SaveINV09(xsave, docstatus);
    }
  };
  const fSave = async (e) => {
    GCReverse_fClose();
    fClearErrorMsg();

    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (vRdxWmsHead.A_DocStat == "POST" || vRdxWmsHead.A_DocStat == "DRAFT") {
        if (DBKernObj("REVERSE_NARR_MANDATORY")) {
          if (GCReverse_sRevNarr == "") {
            fOpenReverseTransactionModal();
          } else {
            let reverseResp = await GetRevereTransaction();

            if (reverseResp) {
              fClearErrorMsg();
              GCReverse_setRevNarr("");

              dispatch(
                Set_SalesReturn_HeadObject_A_DocStatus({
                  A_DocStat: "ENTER",
                })
              );
              fAlertToast("SUCCESS", "SUCCESSFULLY REVERSED");
            }
          }
        } else {
          fAlertToast("FAILED", "Not Allowed to reverse");
          return;
        }
      } else if (vRdxWmsHead.A_DocStat !== "ENTER") {
        fAlertToast("FAILED", "Document status should be  Enter");
        return;
      } else if (vRdxWmsHead.A_DocStat == "ENTER") {
        let validation = fValidationHead();
        if (!validation) return;

        let validationDetil = fValidationDetail();
        if (!validationDetil) return;

        let server_Validation = await ValidationInv09();
        if (!server_Validation) return;

        if (server_Validation) {
          await handleSaveOrApprove(true);
        }
      }
    }, 800);
  };

  const fApprove = async (xDocStatus) => {
    fClearErrorMsg();
    clearTimeout(timeout);

    timeout = setTimeout(async () => {
      let validation = fValidationHead();
      if (!validation) return;

      if (sBufferObj.B_Itmcd != "") {
        fAlertToast("FAILED", "Please save current line item before approve");
        return;
      }

      if (sDetailGridData.length == 0) {
        fAlertToast("INFO", "Add atleast one line item");
        return;
      }
      let Searver_ValidationApprove = await ValidationApprove(
        false,
        xDocStatus
      );
      if (!Searver_ValidationApprove) return;

      if (!!Searver_ValidationApprove) {
        setTimeout(() => {
          confirmAlert({
            title: "Approve",
            message: "Are you want to Approve..",
            buttons: [
              {
                className: "alertBtn",
                name: "SaveYes",
                label: "Yes",
                onClick: async () => {
                  await SaveINV09(false, xDocStatus);
                },
              },
              {
                className: "alertBtn",
                label: "No",
                onClick: () => {
                  return;
                },
              },
            ],
          });
        }, 200);
      }
    }, 800);
  };

  const fDelete = (Srno = sBufferObj.B_Srno) => {
    if (vRdxWmsHead.A_DocStat == "POST") {
      fAlertToast("FAILED", "You are not allowed to delete in post status");
      return;
    } else {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete.",
        buttons: [
          {
            className: "alertBtn",
            name: "DeletYes",
            label: "Yes",
            onClick: () => {
              fDeleteHead(Srno);
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });

      setTimeout(() => {
        document.getElementsByName("DeletYes")[0]?.focus();
      }, 100);
    }
  };

  const fAudit = async (e) => {
    let auditResp = await GetAuditField();
    if (!!auditResp) {
      set_GCAudit_AuditId(auditResp[0]?.id);
      GCAudit_GetTransAudit(auditResp[0]?.id);
    }

    fOpenAuditModal();
  };
  const GetRefDocSearch = async (
    xData,
    xType,
    xA_Loc,
    setRefDocSearchGridData
  ) => {
    let vSeatchVendor = {
      v_Data: xData,
      v_Type: xType,
      v_Loc: xA_Loc,
    };
    const RefDocSearch = await SalesInvoice_inv08RefDocSearch_GETROW(
      vSeatchVendor
    );
    if (RefDocSearch?.status === 200) {
      let RefDocSearchArr = RefDocSearch?.data?.ResultSet.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setRefDocSearchGridData(RefDocSearchArr);
    }
  };

  //quotation start

  const fOpenContentRefDocSearchModalKey = async (e) => {
    //not to open modal if value is exact match
    if (sBufferObj.B_RefDocNo == "") {
      let vRefDocSearchDataObj = {
        v_Data: sBufferObj.B_RefDocName,
        v_Type: "Any",
        v_Loc: vRdxWmsHead.A_Loc,
      };
      const RefDocSearch = await SalesInvoice_inv08RefDocSearch_GETROW(
        vRefDocSearchDataObj
      );

      if (
        RefDocSearch?.status === 200 &&
        RefDocSearch?.data?.ResultSet.length > 0 &&
        RefDocSearch?.data?.ResultSet.length === 1
      ) {
        setBufferObj((obj) => ({
          ...obj,
          B_RefDocNo: RefDocSearch.ResultSet[0].UId,
          B_RefDocName: RefDocSearch.ResultSet[0].Name1,
          B_RefDocTyp: RefDocSearch.ResultSet[0].DocNo,
        }));
      } else {
        fOnClickDropdownRefDocSearchModalKey(e);
      }
    } else {
      setTimeout(() => {
        document.getElementsByName("B_Qty")[0]?.focus();
      }, 200);
    }
  };
  const [RefDocToggleDropdown, setRefDocToggleDropdown] = useState(false);
  const [sRefDocRowSearchDropdownObj, setRefDocSearchDropdownObj] = useState({
    Type: "Any",
    Data: "",
  });
  const [xRefDoccolumnsDropdownSearch, setxRefDoccolumnsDropdownSearch] =
    useState([
      { field: "id", headerName: "ID", width: 70, hide: true },
      { field: "UId", headerName: "Code", width: 100 },
      { field: "Name1", headerName: "Name", width: 350 },
      { field: "DocNo", headerName: "DocNo", width: 220 },
    ]);
  const [sRefDocSearchGridData, setRefDocSearchGridData] = useState([]); //for item search

  const RefDocHandleClick = useCallback(() => {
    if (RefDocToggleDropdown) {
      setRefDocToggleDropdown(false);
      setRefDocSearchGridData([]);
      setRefDocSearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setRefDocToggleDropdown(true);
    }
  }, [RefDocToggleDropdown]);

  const fOnClickDropdownRefDocSearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setRefDocSearchDropdownObj((obj) => ({
        ...obj,
        Data: sBufferObj.B_RefDocName,
      }));
      if (sBufferObj.B_RefDocName != "") {
        GetRefDocSearch(
          sBufferObj.B_RefDocName,
          "Any",
          vRdxWmsHead.A_Loc,
          setRefDocSearchGridData
        );
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      RefDocHandleClick();
    }
  };
  //quotation end

  //accountDetail start
  const [sAccountDetailModal, setAccountDetailModal] = useState(false);
  const [sGridDataAccountDetailRows, setGridDataAccountDetailRows] = useState(
    []
  );
  const [sGridDataAccountDetailColumns, setGridDataAccountDetailColumns] =
    useState([
      {
        field: "id",
        headerName: "Sr.No",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "AcCd",
        headerName: "AcCd",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "AcName",
        headerName: "AcName",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "Br",
        headerName: "Br",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "BrName",
        headerName: "BrName",
        width: 130,
        headerClassName: "grid-header-row",
      },

      {
        field: "AmtLc",
        headerName: "AmtLc",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "DrCr",
        headerName: "DrCr",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "Narr",
        headerName: "Narr",
        width: 200,
        headerClassName: "grid-header-row",
      },
      {
        field: "Narr1",
        headerName: "Narr1",
        width: 200,
        headerClassName: "grid-header-row",
      },
    ]);
  const fOpenAccountDetailModal = () => {
    setAccountDetailModal(true);
  };
  const fAccountDetail = async (e) => {
    const { HeadObject } = SalesReturnRo();
    await GetAccountPostingDetail(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      setGridDataAccountDetailRows
    );

    fOpenAccountDetailModal();
  };
  const fCloseAccountDetailModal = (e) => {
    setAccountDetailModal(false);
  };
  //accountDetail end

  const [poType, setPoType] = useState(false);
  const [poNo, setPoNo] = useState(false);

  //LocationwiseStock start
  const [sLocationwiseStockModal, setLocationwiseStockModal] = useState(false);
  const [sGridDataLocationwiseStockRows, setGridDataLocationwiseStockRows] =
    useState([]);
  const [
    sGridDataLocationwiseStockColumns,
    setGridDataLocationwiseStockColumns,
  ] = useState([
    {
      field: "Location",
      headerName: "Location",
      hide: false,
      width: 170,
      align: "left",
      headerAlign: "left",
      Typ: "S",
      NumberFormat: "",
    },
    {
      field: "StkQty",
      headerName: "StkQty",
      hide: false,
      width: 60,
      align: "right",
      headerAlign: "right",
      Typ: "N",
      NumberFormat: "N2",
    },
    {
      field: "StkVal",
      headerName: "StkVal",
      hide: false,
      width: 60,
      align: "right",
      headerAlign: "right",
      Typ: "N",
      NumberFormat: "N2",
    },
    {
      field: "SrNo",
      headerName: "SrNo",
      hide: true,
      width: 60,
      align: "right",
      headerAlign: "right",
      Typ: "N",
      NumberFormat: "",
    },
    {
      field: "Cost",
      headerName: "Cost",
      hide: false,
      width: 60,
      align: "right",
      headerAlign: "right",
      Typ: "N",
      NumberFormat: "N2",
    },
    {
      field: "LP.Rate",
      headerName: "Rate",
      hide: false,
      width: 60,
      align: "right",
      headerAlign: "right",
      Typ: "N",
      NumberFormat: "N2",
    },
    {
      field: "PRQty",
      headerName: "PRQty",
      hide: false,
      width: 60,
      align: "right",
      headerAlign: "right",
      Typ: "N",
      NumberFormat: "N2",
    },
    {
      field: "SOQty",
      headerName: "SOQty",
      hide: false,
      width: 60,
      align: "right",
      headerAlign: "right",
      Typ: "N",
      NumberFormat: "N2",
    },
    {
      field: "DOQty",
      headerName: "DOQty",
      hide: false,
      width: 60,
      align: "right",
      headerAlign: "right",
      Typ: "N",
      NumberFormat: "N2",
    },
    {
      field: "SIQty",
      headerName: "SIQty",
      hide: false,
      width: 60,
      align: "right",
      headerAlign: "right",
      Typ: "N",
      NumberFormat: "N2",
    },
    {
      field: "TRFQty",
      headerName: "TRFQty",
      hide: false,
      width: 60,
      align: "right",
      headerAlign: "right",
      Typ: "N",
      NumberFormat: "N2",
    },
    {
      field: "ADJQty",
      headerName: "ADJQty",
      hide: false,
      width: 60,
      align: "right",
      headerAlign: "right",
      Typ: "N",
      NumberFormat: "N2",
    },
    {
      field: "Reserved",
      headerName: "Reserved",
      hide: false,
      width: 60,
      align: "right",
      headerAlign: "right",
      Typ: "N",
      NumberFormat: "N2",
    },
    {
      field: "Loc",
      headerName: "Loc",
      hide: true,
      width: 60,
      align: "right",
      headerAlign: "right",
      Typ: "N",
      NumberFormat: "",
    },
    {
      field: "AvlQty",
      headerName: "AvlQty",
      hide: false,
      width: 60,
      align: "right",
      headerAlign: "right",
      Typ: "N",
      NumberFormat: "N2",
    },
    {
      field: "LiveSales",
      headerName: "Live.Sales",
      hide: false,
      width: 60,
      align: "right",
      headerAlign: "right",
      Typ: "N",
      NumberFormat: "N2",
    },
    {
      field: "id",
      headerName: "id",
      hide: false,
      width: 40,
      align: "right",
      headerAlign: "right",
      Typ: "N",
      NumberFormat: "N2",
    },
  ]);
  const fOpenLocationwiseStockModal = () => {
    setLocationwiseStockModal(true);
  };
  const fLocationwiseStock = async (e) => {
    // const { HeadObject } = SalesOrderRo();
    fLocationwiseStockBranch();
    await GetLoctionwiseStock(
      sBufferObj.B_Itmcd,
      fLocationwiseStockBranch(),
      setGridDataLocationwiseStockRows,
      vRdxuserInfo.UserID
    );

    fOpenLocationwiseStockModal();
  };
  const fCloseLocationwiseStockModal = (e) => {
    setLocationwiseStockModal(false);
  };
  //LocationwiseStock end
  const fLocationwiseStockBranch = () => {
    let { Br = "", Name1 = "" } = sLocation.find(
      (obj) => obj?.UID === vRdxWmsHead.A_Loc
    );
    setBufferObj((obj) => ({
      ...obj,
      B_Br: Br,
      B_BrName: Name1,
    }));
    return Br;
  };

  //fLinkDocument start
  const [sLinkDocumentModal, setLinkDocumentModal] = useState(false);
  const [sGridDataLinkDocumentRows, setGridDataLinkDocumentRows] = useState([]);
  const [sGridDataLinkDocumentColumns, setGridDataLinkDocumentColumns] =
    useState([
      {
        field: "A_VocTyp",
        headerName: "Doc.Type",
        hide: false,
        width: 80,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "VocName",
        headerName: "Doc.Name",
        hide: false,
        width: 180,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "A_VocNo",
        headerName: "Doc.No",
        hide: false,
        width: 80,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "A_DocStat",
        headerName: "Status",
        hide: false,
        width: 50,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "id",
        headerName: "id",
        hide: false,
        width: 40,
        align: "left",
        headerAlign: "left",
      },
    ]);
  const fOpenLinkDocumentModal = () => {
    setLinkDocumentModal(true);
  };
  const fLinkDocument = async (e) => {
    const { HeadObject } = SalesReturnRo();
    await GetLinkDocument(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      sTrnTyp,
      setGridDataLinkDocumentRows
    );

    fOpenLinkDocumentModal();
  };
  const fCloseLinkDocumentModal = (e) => {
    setLinkDocumentModal(false);
  };
  //LinkDocument end

  //Modal View
  const [sViewModal, setViewModal] = useState(false);
  const fView = () => {
    setViewModal(true);
  };

  const fCloseViewModal = (e) => {
    setViewModal(false);
  };
  //view end

  //Modal Summary
  const [sSummaryModal, setSummaryModal] = useState(false);
  const fSummary = () => {
    setSummaryModal(true);
  };

  const fCloseSummaryModal = (e) => {
    setSummaryModal(false);
  };
  //summary end
  const fMove_First = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);

    fDisplay(sUser_Doc_Arr[0].A_VocTyp, sUser_Doc_Arr[0].A_VocNo);

    setNavDocValue(1);
  };

  const fMove_Last = (e) => {
    fClearErrorMsg();

    setBufferObj(vBufferObjInit);
    fDisplay(
      sUser_Doc_Arr[sUser_Doc_Arr.length - 1].A_VocTyp,
      sUser_Doc_Arr[sUser_Doc_Arr.length - 1].A_VocNo
    );
    setNavDocValue(sUser_Doc_Arr.length);
  };

  const fMove_Previouse = (e) => {
    fClearErrorMsg();

    setBufferObj(vBufferObjInit);
    if (sNavDocValue > 1) {
      var row = sNavDocValue - 1;
      fDisplay(sUser_Doc_Arr[row - 1].A_VocTyp, sUser_Doc_Arr[row - 1].A_VocNo);
      setNavDocValue(row);
    }
  };

  const fMove_Next = (e) => {
    fClearErrorMsg();

    setBufferObj(vBufferObjInit);
    if (sNavDocValue < sUser_Doc_Arr.length) {
      var row = sNavDocValue + 1;
      fDisplay(sUser_Doc_Arr[row - 1].A_VocTyp, sUser_Doc_Arr[row - 1].A_VocNo);
      setNavDocValue(row);
    }
  };

  const fValidationHead = () => {
    let iRes = true;

    if (
      vRdxWmsHead.A_VocTyp === "" ||
      vRdxWmsHead.A_VocTyp === null ||
      vRdxWmsHead.A_VocTyp === undefined
    ) {
      fAlertToast("FAILED", "VocTyp should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_VocTyp: "VocTyp should not be empty",
      }));
      iRes = false;
    }

    if (
      vRdxWmsHead.A_VocNo === "" ||
      vRdxWmsHead.A_VocNo === null ||
      vRdxWmsHead.A_VocNo === undefined
    ) {
      fAlertToast("FAILED", "VocNo should not be empty");
      setErrorMsg((obj) => ({ ...obj, A_VocNo: "VocNo should not be empty" }));
      iRes = false;
    }

    if (
      vRdxWmsHead.A_PostDt === "" ||
      vRdxWmsHead.A_PostDt === null ||
      vRdxWmsHead.A_PostDt === undefined
    ) {
      fAlertToast("FAILED", "PostDt should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_PostDt: "PostDt should not be empty",
      }));
      iRes = false;
    }

    if (vRdxWmsHead.A_RefNo.toUpperCase() === "CREDIT") {
      const vRdxUserInfoObj = vRdxUserInfo();
      if ((vRdxUserInfoObj?.UserGroupCode).toString() == "01") {
        fAlertToast(
          "FAILED",
          "Invoice generated from POS, are you sure to alter?"
        );
        iRes = false;
      } else {
        fAlertToast("FAILED", "Enter valid Ref.No");
        iRes = false;
      }
    }

    if (
      vRdxWmsHead.A_RefNo.toUpperCase() === "POS" ||
      vRdxWmsHead.A_RefNo === null ||
      vRdxWmsHead.A_RefNo === undefined
    ) {
      fAlertToast("FAILED", "Text should not be POS");
      setErrorMsg((obj) => ({ ...obj, A_RefNo: "Text should not be POS" }));
      iRes = false;
    } else if (vRdxWmsHead.A_RefNo.toUpperCase() === "CREDIT") {
      setErrorMsg((obj) => ({ ...obj, A_RefNo: "Text should not be CREDIT" }));
      fAlertToast("FAILED", "Text should not be CREDIT");
      iRes = false;
    }

    if (
      vRdxWmsHead.A_Party === "" ||
      vRdxWmsHead.A_Party === null ||
      vRdxWmsHead.A_Party === undefined
    ) {
      fAlertToast("FAILED", "Party should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_PartyName: "Party should not be empty",
      }));
      iRes = false;
    }

    if (
      vRdxWmsHead.A_PartyName === "" ||
      vRdxWmsHead.A_PartyName === null ||
      vRdxWmsHead.A_PartyName === undefined
    ) {
      fAlertToast("FAILED", "PartyName should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_PartyName: "PartyName should not be empty",
      }));
      iRes = false;
    }

    if (
      vRdxWmsHead.A_Curr === "" ||
      vRdxWmsHead.A_Curr === null ||
      vRdxWmsHead.A_Curr === undefined
    ) {
      fAlertToast("FAILED", "Currency should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_Curr: "Currency should not be empty",
      }));
      iRes = false;
    }

    if (
      vRdxWmsHead.A_ExRate === "" ||
      vRdxWmsHead.A_ExRate === null ||
      vRdxWmsHead.A_ExRate === undefined
    ) {
      fAlertToast("FAILED", "Exchange rate should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_ExRate: "Exchange rate should not be empty",
      }));
      iRes = false;
    } else if (Number(vRdxWmsHead.A_ExRate) === 0) {
      fAlertToast("FAILED", "Exchange rate should not be zero");
      setErrorMsg((obj) => ({
        ...obj,
        A_ExRate: "Exchange rate should not be zero",
      }));
      iRes = false;
    }

    if (
      vRdxWmsHead.A_PayMode === "" ||
      vRdxWmsHead.A_PayMode === null ||
      vRdxWmsHead.A_PayMode === undefined
    ) {
      fAlertToast("FAILED", "Payment mode should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_PayMode: "Payment mode should not be empty",
      }));
      iRes = false;
    }
    if (
      (vRdxWmsHead.A_SalesGroup === "" ||
        vRdxWmsHead.A_SalesGroup === null ||
        vRdxWmsHead.A_SalesGroup === undefined) &&
      userBasedHideField()
    ) {
      if (vMediaQuery) {
        fSummary();
      }
      setErrorMsg((obj) => ({
        ...obj,
        A_SalesGroup: "Sales Group should not be Empty",
      }));
      fAlertToast("FAILED", "Sales Group should not be Empty");

      iRes = false;
    }

    if (
      vRdxWmsHead.A_Type === "" ||
      vRdxWmsHead.A_Type === null ||
      vRdxWmsHead.A_Type === undefined
    ) {
      fAlertToast("FAILED", "Type should not be empty");
      setErrorMsg((obj) => ({ ...obj, A_Type: "Type should not be empty" }));
      iRes = false;
    }

    if (
      vRdxWmsHead.A_TaxType === "" ||
      vRdxWmsHead.A_TaxType === null ||
      vRdxWmsHead.A_TaxType === undefined
    ) {
      fAlertToast("FAILED", "Tax Type should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_TaxType: "Tax Type should not be empty",
      }));
      iRes = false;
    }
    if (
      vRdxWmsHead.A_Loc === "" ||
      vRdxWmsHead.A_Loc === null ||
      vRdxWmsHead.A_Loc === undefined
    ) {
      fAlertToast("FAILED", "Location should not be Empty");

      setErrorMsg((obj) => ({ ...obj, A_Loc: "Location should not be Empty" }));
      iRes = false;
    }
    if (
      vRdxWmsHead.A_RefDt === "" ||
      vRdxWmsHead.A_RefDt === null ||
      vRdxWmsHead.A_RefDt === undefined
    ) {
      fAlertToast("FAILED", "Reference Date should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_RefDt: "Reference Date should not be empty",
      }));
      iRes = false;
    }
    if (
      vRdxWmsHead.A_Buyer === "" ||
      vRdxWmsHead.A_Buyer === null ||
      vRdxWmsHead.A_Buyer === undefined
    ) {
      if (vMediaQuery) {
        fSummary();
      }
      fAlertToast("FAILED", "Salesman should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_Buyer: "Salesman should not be empty",
      }));
      iRes = false;
    }

    if (
      vRdxWmsHead.A_Taxable === "" ||
      vRdxWmsHead.A_Taxable === null ||
      vRdxWmsHead.A_Taxable === undefined
    ) {
      fAlertToast("FAILED", "Taxable should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_Taxable: "Taxable should not be empty",
      }));
      iRes = false;
    }

    if (
      vRdxWmsHead.CreditNote === "" ||
      vRdxWmsHead.CreditNote === null ||
      vRdxWmsHead.CreditNote === undefined
    ) {
      fAlertToast("FAILED", "Credit Note should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        CreditNote: "Credit Note should not be empty",
      }));
      iRes = false;
    }

    if (
      vRdxWmsHead.A_ECOM === "" ||
      vRdxWmsHead.A_ECOM === null ||
      vRdxWmsHead.A_ECOM === undefined
    ) {
      fAlertToast("FAILED", "E-Commerce field should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_ECOM: "E-Commerce field should not be empty",
      }));
      iRes = false;
    }

    if (
      vRdxWmsHead.A_DropShipment === "" ||
      vRdxWmsHead.A_DropShipment === null ||
      vRdxWmsHead.A_DropShipment === undefined
    ) {
      fAlertToast("FAILED", "Drop Shipment should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_DropShipment: "Drop Shipment should not be empty",
      }));
      iRes = false;
    }

    if (
      vRdxWmsHead.Commity === "" ||
      vRdxWmsHead.Commity === null ||
      vRdxWmsHead.Commity === undefined
    ) {
      fAlertToast("FAILED", "Commity should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        Commity: "Commity should not be empty",
      }));
      iRes = false;
    }
    if (
      vRdxWmsHead.CreditNote === "" ||
      vRdxWmsHead.CreditNote === null ||
      vRdxWmsHead.CreditNote === undefined
    ) {
      fAlertToast("FAILED", "CreditNote should not be Empty");
      setErrorMsg((obj) => ({
        ...obj,
        CreditNote: "CreditNote should not be Empty",
      }));
      iRes = false;
    }

    if (
      vRdxWmsHead.A_Rounding === "" ||
      vRdxWmsHead.A_Rounding === null ||
      vRdxWmsHead.A_Rounding === undefined
    ) {
      if (vMediaQuery) {
        fSummary();
      }
      fAlertToast("FAILED", "Rounding should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_Rounding: "Rounding should not be empty",
      }));
      iRes = false;
    }

    if (sFooterObj.A_LandVal < 0) {
      if (vMediaQuery) {
        fSummary();
      }
      fAlertToast("FAILED", "Transaction amount should be greater than zero");
      setErrorMsg((obj) => ({
        ...obj,
        A_Rounding: "Transaction amount should be greater than zero",
      }));
      iRes = false;
    }

    if (
      vRdxWmsHead.A_DiscPerc === "" ||
      vRdxWmsHead.A_DiscPerc === null ||
      vRdxWmsHead.A_DiscPerc === undefined
    ) {
      if (vMediaQuery) {
        fSummary();
      }
      fAlertToast("FAILED", "Discount percentage should not be empty");
      setErrorMsg((obj) => ({
        ...obj,
        A_DiscPerc: "Discount percentage should not be empty",
      }));
      iRes = false;
    } else if (
      Number(vRdxWmsHead.A_DiscPerc) !== 0 &&
      Number(sFooterObj.A_TDiscAmt) === 0
    ) {
      if (vMediaQuery) {
        fSummary();
      }
      fAlertToast("FAILED", "Check discount percentage2");
      setErrorMsg((obj) => ({
        ...obj,
        A_TDiscAmt: "Check discount percentage2",
      }));
      iRes = false;
    } else if (vRdxWmsHead.A_DiscPerc == 0 && sFooterObj.A_TDiscAmt != 0) {
      if (vMediaQuery) {
        fSummary();
      }
      fAlertToast("FAILED", "Check discount percentage1");
      setErrorMsg((obj) => ({
        ...obj,
        A_DiscPerc: "Check discount percentage1",
      }));
      iRes = false;
    } else if (
      Number(vRdxWmsHead.A_DiscPerc) > 100 ||
      Number(vRdxWmsHead.A_DiscPerc) < 0
    ) {
      if (vMediaQuery) {
        fSummary();
      }
      fAlertToast("FAILED", "Discount percentage must be between 0 and 100");
      setErrorMsg((obj) => ({
        ...obj,
        A_DiscPerc: "Discount percentage must be between 0 and 100",
      }));
      iRes = false;
    }

    if (vRdxWmsHead.A_DocStat !== "ENTER") {
      fAlertToast("FAILED", "Document status should be 'ENTER'");
      iRes = false;
    }

    return iRes;
  };

  const fValidationDetail = () => {
    let iRes = true;

    if (vRdxWmsHead.A_DocStat !== "ENTER") {
      fAlertToast("FAILED", "Check Doc Status");
      iRes = false;
    }

    if (sBufferObj.B_Srno === "") {
      fAlertToast("FAILED", "Serial number should not be empty");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_Srno: "Serial number should not be empty",
      }));
      iRes = false;
    }

    if (sBufferObj.B_Itmcd === "") {
      fAlertToast("FAILED", "Item code should not be empty");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_ItmName: "Item code should not be empty",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_ItmName === "" ||
      sBufferObj.B_ItmName === null ||
      sBufferObj.B_ItmName === undefined
    ) {
      fAlertToast("FAILED", "Item name should not be empty");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_ItmName: "Item name should not be empty",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_Qty === "" ||
      sBufferObj.B_Qty === null ||
      sBufferObj.B_Qty === undefined
    ) {
      fAlertToast("FAILED", "Enter quantity");
      setErrorMsgDetail((obj) => ({ ...obj, B_Qty: "Enter quantity" }));
      iRes = false;
    } else if (Number(sBufferObj.B_Qty) <= 0) {
      fAlertToast("FAILED", "Quantity should not be zero");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_Qty: "Quantity should not be zero",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_Unit === "" ||
      sBufferObj.B_Unit === null ||
      sBufferObj.B_Unit === undefined
    ) {
      fAlertToast("FAILED", "Select unit");
      setErrorMsgDetail((obj) => ({ ...obj, B_Unit: "Select unit" }));
      iRes = false;
    }

    if (
      sBufferObj.B_PackQty === "" ||
      sBufferObj.B_PackQty === null ||
      sBufferObj.B_PackQty === undefined
    ) {
      fAlertToast("FAILED", "Pack quantity should not be empty");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_PackQty: "Pack quantity should not be empty",
      }));
      iRes = false;
    } else if (Number(sBufferObj.B_PackQty) === 0) {
      fAlertToast("FAILED", "Pack quantity should not be zero");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_PackQty: "Pack quantity should not be zero",
      }));
      iRes = false;
    }
    if (
      sBufferObj.B_BaseQty === "" ||
      sBufferObj.B_BaseQty === null ||
      sBufferObj.B_BaseQty === undefined
    ) {
      fAlertToast("FAILED", "Base quantity should not be empty");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_BaseQty: "Base quantity should not be empty",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_URateFc === "" ||
      sBufferObj.B_URateFc === null ||
      sBufferObj.B_URateFc === undefined
    ) {
      fAlertToast("FAILED", "Enter unit rate [F.C]");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_URateFc: "Enter unit rate [F.C]",
      }));
      iRes = false;
    } else if (Number(sBufferObj.B_URateFc) === 0) {
      fAlertToast("FAILED", "Unit rate [F.C] should not be zero");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_URateFc: "Unit rate [F.C] should not be zero",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_URateLc === "" ||
      sBufferObj.B_URateLc === null ||
      sBufferObj.B_URateLc === undefined
    ) {
      fAlertToast("FAILED", "Enter unit rate [L.C]");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_URateLc: "Enter unit rate [L.C]",
      }));
      iRes = false;
    } else if (Number(sBufferObj.B_URateLc) <= 0) {
      fAlertToast(
        "FAILED",
        `Unit rate [L.C] should not be zero ${sBufferObj.B_URateLc}`
      );
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_URateLc: "Unit rate [L.C] should not be zero",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_GrossAmt === "" ||
      sBufferObj.B_GrossAmt === null ||
      sBufferObj.B_GrossAmt === undefined
    ) {
      fAlertToast("FAILED", "Gross amount should not be empty");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_GrossAmt: "Gross amount should not be empty",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_LDiscPerc === "" ||
      sBufferObj.B_LDiscPerc === null ||
      sBufferObj.B_LDiscPerc === undefined
    ) {
      fAlertToast("FAILED", "LDiscPerc should not be empty");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_LDiscPerc: "LDiscPerc should not be empty",
      }));
      iRes = false;
    } else if (
      Number(sBufferObj.B_LDiscPerc) == 0 &&
      Number(sBufferObj.B_LDiscAmt) != 0
    ) {
      fAlertToast("FAILED", "LDiscAmt should be zero when LDiscPerc is zero");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_LDiscPerc: "LDiscAmt should be zero",
      }));
      iRes = false;
    } else if (
      Number(sBufferObj.B_LDiscPerc) != 0 &&
      Number(sBufferObj.B_LDiscAmt) <= 0
    ) {
      fAlertToast(
        "FAILED",
        "LDiscAmt should not be zero when LDiscPerc is non-zero"
      );
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_LDiscPerc: "LDiscAmt should not be zero",
      }));
      iRes = false;
    } else if (
      Number(sBufferObj.B_LDiscPerc) > 100 ||
      Number(sBufferObj.B_LDiscPerc) < 0
    ) {
      fAlertToast("FAILED", "LDisc Percentage must be between 0 and 100");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_LDiscPerc: "LDisc Percentage must be between 0 and 100",
      }));
      iRes = false;
    }
    if (
      sBufferObj.B_LDiscAmt === "" ||
      sBufferObj.B_LDiscAmt === null ||
      sBufferObj.B_LDiscAmt === undefined
    ) {
      fAlertToast("FAILED", "LDiscAmt should not be  Empty");

      setErrorMsgDetail((obj) => ({
        ...obj,
        B_LDiscAmt: "LDiscAmt should not be  Empty",
      }));
      iRes = false;
    }
    if (
      sBufferObj.B_TDiscPerc === "" ||
      sBufferObj.B_TDiscPerc === null ||
      sBufferObj.B_TDiscPerc === undefined
    ) {
      fAlertToast("FAILED", "TDiscPerc should not be Empty");

      setErrorMsgDetail((obj) => ({
        ...obj,
        B_TDiscPerc: "TDiscPerc should not be Empty",
      }));
      iRes = false;
    }
    if (
      sBufferObj.B_TDiscAmt === "" ||
      sBufferObj.B_TDiscAmt === null ||
      sBufferObj.B_TDiscAmt === undefined
    ) {
      fAlertToast("FAILED", "Total discount amount should not be empty");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_TDiscAmt: "Total discount amount should not be empty",
      }));
      iRes = false;
    }
    if (
      sBufferObj.B_FocFlag === "" ||
      sBufferObj.B_FocFlag === null ||
      sBufferObj.B_FocFlag === undefined
    ) {
      fAlertToast("FAILED", "FocFlag should not be empty");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_FocFlag: "FocFlag should not be empty",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_FocAmt === "" ||
      sBufferObj.B_FocAmt === null ||
      sBufferObj.B_FocAmt === undefined
    ) {
      fAlertToast("FAILED", "FocAmt should not be empty");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_FocAmt: "FocAmt should not be empty",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_ExciseTaxAmt === "" ||
      sBufferObj.B_ExciseTaxAmt === null ||
      sBufferObj.B_ExciseTaxAmt === undefined
    ) {
      fAlertToast("FAILED", "ExciseTaxAmt should not be empty");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_ExciseTaxAmt: "ExciseTaxAmt should not be empty",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_ExciseTaxNetAmt === "" ||
      sBufferObj.B_ExciseTaxNetAmt === null ||
      sBufferObj.B_ExciseTaxNetAmt === undefined
    ) {
      fAlertToast("FAILED", "ExciseTaxNetAmt should not be empty");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_ExciseTaxNetAmt: "ExciseTaxNetAmt should not be empty",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_NetAmt === "" ||
      sBufferObj.B_NetAmt === null ||
      sBufferObj.B_NetAmt === undefined
    ) {
      fAlertToast("FAILED", "NetAmt should not be empty");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_NetAmt: "NetAmt should not be empty",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_LandVal === "" ||
      sBufferObj.B_LandVal === null ||
      sBufferObj.B_LandVal === undefined
    ) {
      fAlertToast("FAILED", "LandVal should not be empty");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_LandVal: "LandVal should not be empty",
      }));
      iRes = false;
    }

    // Uncomment if Narration validation is needed
    // if (sBufferObj.Narration === "") {
    //     fAlertToast("FAILED", "Narration should not be empty");
    //     setErrorMsgDetail((obj) => ({ ...obj, Narration: "Narration should not be empty" }));
    //     iRes = false;
    // }

    if (userBasedHideField()) {
      if (sBufferObj.B_IncGroup === "" && sIncentiveGroups.length > 0) {
        fAlertToast("FAILED", "B_IncGroup should not be empty");
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_IncGroup: "B_IncGroup should not be empty",
        }));
        iRes = false;
      }

      if (
        sBufferObj.B_SuprvPerc === "" ||
        sBufferObj.B_SuprvPerc === null ||
        sBufferObj.B_SuprvPerc === undefined
      ) {
        fAlertToast("FAILED", "SuprvPerc should not be empty");
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_SuprvPerc: "SuprvPerc should not be empty",
        }));
        iRes = false;
      }

      if (
        sBufferObj.B_OthersPerc === "" ||
        sBufferObj.B_OthersPerc === null ||
        sBufferObj.B_OthersPerc === undefined
      ) {
        fAlertToast("FAILED", "OthersPerc should not be empty");
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_OthersPerc: "OthersPerc should not be empty",
        }));
        iRes = false;
      }

      if (
        sBufferObj.B_SLANSuprv === "" ||
        sBufferObj.B_SLANSuprv === null ||
        sBufferObj.B_SLANSuprv === undefined
      ) {
        fAlertToast("FAILED", "SLANSuprv should not be empty");
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_SLANSuprv: "SLANSuprv should not be empty",
        }));
        iRes = false;
      }

      if (
        sBufferObj.B_SlabAmtSuprv === "" ||
        sBufferObj.B_SlabAmtSuprv === null ||
        sBufferObj.B_SlabAmtSuprv === undefined
      ) {
        fAlertToast("FAILED", "SlabAmtSuprv should not be empty");
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_SlabAmtSuprv: "SlabAmtSuprv should not be empty",
        }));
        iRes = false;
      }

      if (
        sBufferObj.B_SLANOther === "" ||
        sBufferObj.B_SLANOther === null ||
        sBufferObj.B_SLANOther === undefined
      ) {
        fAlertToast("FAILED", "SLANOther should not be empty");
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_SLANOther: "SLANOther should not be empty",
        }));
        iRes = false;
      }

      if (
        sBufferObj.B_SlabAmtOther === "" ||
        sBufferObj.B_SlabAmtOther === null ||
        sBufferObj.B_SlabAmtOther === undefined
      ) {
        fAlertToast("FAILED", "SlabAmtOther should not be empty");
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_SlabAmtOther: "SlabAmtOther should not be empty",
        }));
        iRes = false;
      }
    }

    if (
      sBufferObj.B_TaxDept === "" ||
      sBufferObj.B_TaxDept === null ||
      sBufferObj.B_TaxDept === undefined
    ) {
      fAlertToast("FAILED", "Tax department should not be empty");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_TaxDept: "Tax department should not be empty",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_TaxPerc === "" ||
      sBufferObj.B_TaxPerc === null ||
      sBufferObj.B_TaxPerc === undefined
    ) {
      fAlertToast("FAILED", "Tax percentage should not be empty");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_TaxPerc: "Tax percentage should not be empty",
      }));
      iRes = false;
    }
    if (
      sBufferObj.B_TaxAmt === "" ||
      sBufferObj.B_TaxAmt === null ||
      sBufferObj.B_TaxAmt === undefined
    ) {
      fAlertToast("FAILED", "TaxAmt should not be empty");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_TaxAmt: "TaxAmt should not be empty",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_TaxDept2 === "" ||
      sBufferObj.B_TaxDept2 === null ||
      sBufferObj.B_TaxDept2 === undefined
    ) {
      fAlertToast("FAILED", "TaxDept2 should not be empty");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_TaxDept2: "TaxDept2 should not be empty",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_TaxPerc2 === "" ||
      sBufferObj.B_TaxPerc2 === null ||
      sBufferObj.B_TaxPerc2 === undefined
    ) {
      fAlertToast("FAILED", "TaxPerc2 should not be empty");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_TaxPerc2: "TaxPerc2 should not be empty",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_TaxAmt2 === "" ||
      sBufferObj.B_TaxAmt2 === null ||
      sBufferObj.B_TaxAmt2 === undefined
    ) {
      fAlertToast("FAILED", "TaxAmt2 should not be empty");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_TaxAmt2: "TaxAmt2 should not be empty",
      }));
      iRes = false;
    }

    if (
      sBufferObj.AddCess === "" ||
      sBufferObj.AddCess === null ||
      sBufferObj.AddCess === undefined
    ) {
      fAlertToast("FAILED", "Additional cess should not be empty");
      setErrorMsgDetail((obj) => ({
        ...obj,
        AddCess: "Additional cess should not be empty",
      }));
      iRes = false;
    }

    if (sBufferObj.B_NetAddCess === "") {
      fAlertToast("FAILED", "Net additional cess should not be empty");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_NetAddCess: "Net additional cess should not be empty",
      }));
      iRes = false;
    }

    return iRes;
  };

  //onchange we will not get value so 2 parameter added
  //GCItemSearch
  let vIsDownKeyPressed = false;

  const GCSearch_Get = async (e, xAPICALL, xSTATUS) => {
    if (
      e.key === "Enter" ||
      xAPICALL === "APICALL" ||
      xAPICALL === "APICALLDATE" ||
      xAPICALL === "APICallPartyModal" ||
      xAPICALL === "APICallLocModal" ||
      xAPICALL === "APICallSalesGroupModal"
    ) {
      let vSearchObj = {
        v_TrnTyp: sTrnTyp,
        v_VocNo: GCSearch_Obj.VocNo,
        v_PostDt:
          xAPICALL === "APICALLDATE"
            ? moment(xSTATUS).format("DD/MM/YYYY")
            : !!GCSearch_Obj.PostDt
            ? moment(GCSearch_Obj.PostDt).format("DD/MM/YYYY")
            : "01/01/1900",
        // PostDt: "01/01/1900",
        v_RefNo: GCSearch_Obj.RefNo,
        v_Party:
          xAPICALL === "APICallPartyModal"
            ? !!xSTATUS
              ? xSTATUS
              : "All"
            : !!GCSearch_Obj.Party
            ? GCSearch_Obj.Party
            : "All",
        // v_Type: "",
        v_Loc: xAPICALL === "APICallLocModal" ? xSTATUS : GCSearch_Obj.Loc,
        v_Status: xAPICALL === "APICALL" ? xSTATUS : GCSearch_Obj.Status,
        v_UserCd: vRdxuserInfo.UserID,
        v_Type:
          xAPICALL === "APICallSalesGroupModal"
            ? xSTATUS == "All"
              ? ""
              : xSTATUS
            : GCSearch_Obj.SalesGroup == "All"
            ? ""
            : GCSearch_Obj.SalesGroup || "",
      };
      const vSearch = await inv09_INV09_Search_GETROW(vSearchObj);
      if (vSearch?.status === 200) {
        let vSearchArr = vSearch?.data?.ResultSet?.map((obj, i) => ({
          ...obj,
          id: i + 1,
          // A_PostDt: moment(obj.A_PostDt).format("DD/MM/YYYY"),
        }));
        setGridSearchHeadRowData(vSearchArr);
      }
    }
  };

  //HEAD Component

  const fOnChangeSelectDocType = (event) => {
    var vSelectedObj = sDocLoading?.find((obj, index) => {
      return obj.VocTyp === event.target.value;
    });
    dispatch(
      Set_SalesReturn_HeadObject_Set({
        ...vRdxWmsHead,
        A_VocTyp: vSelectedObj.VocTyp,
        A_VocTypName: vSelectedObj.VocName,
      })
    );
    fDefaultPayload(vSelectedObj.Paymode, dispatch, setPaymodeEnable);
  };

  const fOnChangeSelectCurr = (event) => {
    var vCurrency = sCurrency?.find((option, index) => {
      return option.Uid === event.target.value;
    });

    dispatch(
      Set_SalesReturn_HeadObject_Set({
        ...vRdxWmsHead,
        A_Curr: vCurrency.Uid,
        A_Currname: vCurrency.Name1,
        A_ExRate: vCurrency?.Rate,
      })
    );

    fonChangeGetValueExRate(vCurrency?.Rate);
  };

  // const fOnChangeInputDate = useCallback(
  //   (event) => {
  //     if (event.target.value === "") {
  //       dispatch(
  //         Set_SalesReturn_HeadObject_Set({
  //           ...vRdxWmsHead,
  //           [event.target.name]: "",
  //         })
  //       );
  //     } else {
  //       dispatch(
  //         Set_SalesReturn_HeadObject_Set({
  //           ...vRdxWmsHead,
  //           [event.target.name]: moment(event.target.value, "YYYY-MM-DD")._d,
  //         })
  //       );
  //     }
  //   },
  //   [vRdxWmsHead]
  // );
  const fOnChangeInputDate = useCallback(
    (event) => {
      if (
        event?.$d == "Invalid Date" ||
        event?.$d == null ||
        event?.$d === undefined ||
        event?.$d === ""
      ) {
        dispatch(
          Set_SalesReturn_HeadObject_Set({
            ...vRdxWmsHead,
            A_PostDt: "",
          })
        );
      } else {
        dispatch(
          Set_SalesReturn_HeadObject_Set({
            ...vRdxWmsHead,
            A_PostDt: event?.$d,
          })
        );
      }
      // dispatch(
      //   Set_SalesReturn_HeadObject_Set({
      //     ...vRdxWmsHead,
      //     A_PostDt: event.$d,
      //   })
      // );
    },
    [vRdxWmsHead, dispatch]
  );

  const fOnChangeInputDateRefDate = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      dispatch(
        Set_SalesReturn_HeadObject_Set({
          ...vRdxWmsHead,
          A_RefDt: "",
        })
      );
    } else {
      dispatch(
        Set_SalesReturn_HeadObject_Set({
          ...vRdxWmsHead,
          A_RefDt: event?.$d,
        })
      );
    }
    // dispatch(
    //   Set_SalesReturn_HeadObject_Set({
    //     ...vRdxWmsHead,
    //     // A_RefDt: moment(event.target.value, "YYYY-MM-DD")._d,
    //     A_RefDt: event.$d,
    //   })
    // );
  };

  const fonChangeInput = useCallback(
    (event) => {
      dispatch(
        Set_SalesReturn_HeadObject_Set({
          ...vRdxWmsHead,
          [event.target.name]: event.target.value,
        })
      );
    },
    [vRdxWmsHead, dispatch]
  );
  const fonChangeInputTaxType = async (event) => {
    dispatch(
      Set_SalesReturn_HeadObject_Set({
        ...vRdxWmsHead,
        [event.target.name]: event.target.value,
        A_Taxable:
          event.target.value == "OTTRN001" || event.target.value == "INTRN001"
            ? "Y"
            : "N",
      })
    );
    //if inter.comp then tax group should be 0

    if (event.target.value == "OTTRN002" || event.target.value == "OTTRN003") {
      InterCompanyDependency(
        vRdxDBKernObj.DEF_ZERO_TAX_CODE.Val,
        vRdxDBKernObj.DEF_ZERO_CESS_CODE.Val
      );
    } else {
      if (sBufferObj.B_Itmcd === "") {
        InterCompanyDependency(vRdxGRNtax1[0].UId, vRdxGRNtax2[0].UId);
      } else {
        if (sBufferObj.B_Itmcd != "") {
          const vItemSearchFull = await Get_GCToggleSearch_Item_Exact(
            sBufferObj.B_Itmcd
          );
          if (vItemSearchFull.length > 0) {
            fItemCodeDependency(vItemSearchFull);
          }
        }
      }
    }
  };
  const fonChangeInputInvoiceType = (event) => {
    dispatch(
      Set_SalesReturn_HeadObject_Set({
        ...vRdxWmsHead,
        [event.target.name]: event.target.value,
      })
    );
  };
  const fonChangeInputPayMode = (event) => {
    dispatch(
      Set_SalesReturn_HeadObject_Set({
        ...vRdxWmsHead,
        [event.target.name]: event.target.value,
      })
    );
  };
  const fonChangeInputTaxable = (event) => {
    dispatch(
      Set_SalesReturn_HeadObject_Set({
        ...vRdxWmsHead,
        [event.target.name]: event.target.checked ? "Y" : "N",
      })
    );
  };
  const fonChangeInput_CreditNote = (event) => {
    dispatch(
      Set_SalesReturn_HeadObject_Set({
        ...vRdxWmsHead,
        [event.target.name]: event.target.checked ? "Y" : "N",
      })
    );
  };
  const fonChangeInput_Checkbox = (event) => {
    dispatch(
      Set_SalesReturn_HeadObject_Set({
        ...vRdxWmsHead,
        [event.target.name]: event.target.checked ? "Y" : "N",
      })
    );
  };
  const fonChangeInput_A_DropShipment = (event) => {
    dispatch(
      Set_SalesReturn_HeadObject_Set({
        ...vRdxWmsHead,
        [event.target.name]: event.target.checked ? "Y" : "N",
      })
    );
  };
  const fonChangeInput_Commity = (event) => {
    dispatch(
      Set_SalesReturn_HeadObject_Set({
        ...vRdxWmsHead,
        [event.target.name]: event.target.checked ? "Y" : "N",
      })
    );
  };

  const fonChangeInput_A_ECOM = (event) => {
    dispatch(
      Set_SalesReturn_HeadObject_Set({
        ...vRdxWmsHead,
        A_ECOM: event.target.checked ? "Y" : "N",
      })
    );
  };

  const fonChangeInputLocation = async (event) => {
    let iDefaultTaxType = await GetTransTaxType(
      event.target.value,
      vRdxWmsHead.A_Party
    );
    let iLocation = sLocation.find((obj) => obj.UID === event.target.value);
    dispatch(
      Set_SalesReturn_HeadObject_Set({
        ...vRdxWmsHead,
        A_Loc: iLocation.UID,
        A_TaxType: iDefaultTaxType[0]?.TaxType,
      })
    );
    fonChangeGetValueLocation(event.target.value);

    GetDefcustomersetting(vRdxWmsHead.A_Party, event.target.value);
    DefaultPriceLevel(vRdxWmsHead.A_Party, event.target.value);
  };

  //getting value (ExRate) from head
  const fonChangeGetValueExRate = (ExRate) => {
    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_NetAddCess,
      B_Rounding,
      B_LandVal,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      sBufferObj.B_TaxPerc,
      sBufferObj.B_TaxPerc2,
      sBufferObj.AddCess,
      0
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,

      B_Rounding,
      B_TaxAmt,
      B_TaxAmt2,
      B_NetAddCess,
      B_LandVal,
    }));
  };

  //getting value (Location) from head
  const fonChangeGetValueLocation = async (xA_Loc) => {
    const vIncentiveGroups = await GetIncentiveGroup(
      sBufferObj.B_Itmcd,
      xA_Loc
    );
    if (vIncentiveGroups?.Type?.toUpperCase() === "SUCCESS") {
      SetIncentiveGroups(vIncentiveGroups.ResultSet);

      setBufferObj((obj) => ({
        ...obj,
        B_IncGroup: vIncentiveGroups.ResultSet[0].UId,
        B_SuprvPerc: vIncentiveGroups.ResultSet[0].SuprvPerc,
        B_OthersPerc: vIncentiveGroups.ResultSet[0].OthersPerc,
      }));
    }
    // WmsSI/getSalesGroups?loc=64
    const vSalesGroup = await GetSalesGroups(xA_Loc);
    if (vSalesGroup?.Type?.toUpperCase() === "SUCCESS") {
      setSalesGroup(vSalesGroup.ResultSet);
      dispatch(
        Set_SalesReturn_HeadObject_Set({
          ...vRdxWmsHead,
          A_Loc: xA_Loc,
          A_SalesGroup: vSalesGroup?.ResultSet[0]?.UId,
        })
      );
    } else {
      fAlertToast("FAILED", vSalesGroup.Message);
    }
  };

  // if any data value is not empty filter array
  //GCSimpleSearch
  let vIsDownKeyPressedSimpleSearch = false;

  const fSalesGroup = async (xA_Loc) => {
    // WmsSI/getSalesGroups?loc=64
    const vSalesGroup = await GetSalesGroups(xA_Loc);
    if (vSalesGroup?.Type?.toUpperCase() === "SUCCESS") {
      setSalesGroup(vSalesGroup.ResultSet);
      let vSalesGroupObj = {
        A_Loc: xA_Loc,
        A_SalesGroup:
          vSalesGroup.ResultSet.length > 0 ? vSalesGroup.ResultSet[0].UId : "",
      };
      return vSalesGroupObj;
    } else {
      fAlertToast("FAILED", vSalesGroup.Message);
    }
  };
  //Footer Component
  const fonChangeSelectSalesMan = (event, selectArr) => {
    dispatch(
      Set_SalesReturn_HeadObject_Set({
        ...vRdxWmsHead,
        A_Buyer: event.target.value,
      })
    );
  };
  const fonChangeSelectSalesGroup = (event, selectArr) => {
    dispatch(
      Set_SalesReturn_HeadObject_Set({
        ...vRdxWmsHead,
        A_SalesGroup: event.target.value,
      })
    );
  };

  const fonChangeInputFooter = (event) => {
    dispatch(
      Set_SalesReturn_HeadObject_Set({
        ...vRdxWmsHead,
        [event.target.name]: event.target.value,
      })
    );
  };

  //API INCENTIVEGROUP_GETROW
  const GetIncentiveGroup = async (xB_Itmcd, xA_Loc, loaderScreen = true) => {
    let vIncentiveGroupsObj = {
      itemCd: xB_Itmcd,
      loc: xA_Loc,
    };
    const vIncentiveGroups = await fExecuteAPI(
      "INCENTIVEGROUP_GETROW",
      vIncentiveGroupsObj,
      loaderScreen
    );
    return vIncentiveGroups;
  };

  //API SALESGROUP
  const GetSalesGroups = async (xA_Loc) => {
    const vSalesGroups = await fExecuteAPI("SALESGROUPS_GETROW", xA_Loc);
    if (vSalesGroups?.Type?.toUpperCase() === "SUCCESS") {
      setSalesGroup(vSalesGroups.ResultSet);
    }
    return vSalesGroups;
  };
  //API SALESGROUP search
  const fSalesgroupArr_GETROW = async (xA_Loc) => {
    const vSalesGroupSearchs = await fExecuteAPI(
      "SALESGROUPSSEARCH_GETROW",
      xA_Loc
    );
    if (vSalesGroupSearchs?.Type?.toUpperCase() == "SUCCESS") {
      return vSalesGroupSearchs.ResultSet;
    } else {
      fAlertToast(
        "FAILED",
        vSalesGroupSearchs?.response?.data?.message ||
          vSalesGroupSearchs?.message ||
          vSalesGroupSearchs.Message ||
          "Error SalesgroupArr"
      );
    }
  };

  //API GETSIHEAD_GETROW to gethead
  const fDisplay = async (xA_VocTyp, A_VocNo) => {
    let vSIHeadObj = {
      v_A_VocTyp: xA_VocTyp,
      v_A_VocNo: A_VocNo,
    };
    const vSIHead = await inv09_fINV09_fDisplay_GETROW(vSIHeadObj);
    if (vSIHead?.status === 200) {
      await GetSalesGroups(vSIHead?.data?.ResultSet[0]?.A_Loc);
      dispatch(
        Set_SalesReturn_HeadObject_Set({
          ...vRdxWmsHead,
          A_VocTyp: vSIHead?.data?.ResultSet[0].A_VocTyp,
          A_VocTypName: vSIHead?.data?.ResultSet[0].VocName,
          A_VocNo: vSIHead?.data?.ResultSet[0].A_VocNo,
          A_PostDt: vSIHead?.data?.ResultSet[0].A_PostDt,
          A_RefDt: vSIHead?.data?.ResultSet[0].A_RefDt,
          A_RefNo: vSIHead?.data?.ResultSet[0].A_VATRefNo,
          A_Party: vSIHead?.data?.ResultSet[0].A_Party,
          A_PartyName: vSIHead?.data?.ResultSet[0].PartyName,
          A_Curr: vSIHead?.data?.ResultSet[0].A_Curr,
          A_Currname: vSIHead?.data?.ResultSet[0].CurrName,
          A_ExRate: vSIHead?.data?.ResultSet[0].A_ExRate,
          A_PayMode: vSIHead?.data?.ResultSet[0].A_PayMode,
          A_Type: vSIHead?.data?.ResultSet[0].A_Type,
          A_Loc: vSIHead?.data?.ResultSet[0].A_Loc,
          A_Buyer: vSIHead?.data?.ResultSet[0].A_Buyer, ////SalesMan
          A_Narr: vSIHead?.data?.ResultSet[0].A_Narr,
          A_DiscPerc: vSIHead?.data?.ResultSet[0].A_DiscPerc
            ? vSIHead?.data?.ResultSet[0].A_DiscPerc
            : 0,
          A_Rounding: vSIHead?.data?.ResultSet[0].A_Rounding
            ? vSIHead?.data?.ResultSet[0].A_Rounding
            : 0,
          A_DocStat: vSIHead?.data?.ResultSet[0].A_DocStat,
          A_SalesGroup: vSIHead?.data?.ResultSet[0].A_CUSTFIELD2 || "", //vSIHead?.data?.ResultSet[0].A_CUSTFIELD2, //SalesGroup
          A_TaxType: vSIHead?.data?.ResultSet[0].A_CUSTFIELD3,
          A_Taxable: !!vSIHead?.data?.ResultSet[0].A_Taxable
            ? vSIHead?.data?.ResultSet[0].A_Taxable
            : "N",

          A_DropShipment: !!vSIHead?.data?.ResultSet[0].A_CUSTFIELD1
            ? vSIHead?.data?.ResultSet[0].A_CUSTFIELD1
            : "N",

          A_EnBy: vSIHead?.data?.ResultSet[0].A_EnBy,
          A_ECOM: !!vSIHead?.data?.ResultSet[0].A_ECOM
            ? vSIHead?.data?.ResultSet[0].A_ECOM
            : "N",
          No: vSIHead?.data?.ResultSet[0].A_RefNo,
          Note: vSIHead?.data?.ResultSet[0].A_CUSTFIELD2 || "",
          LoyaltyName: vSIHead?.data?.ResultSet[0].A_LCustName,
          LoyaltyCd: vSIHead?.data?.ResultSet[0].A_LCust,
          Commity: !!vSIHead?.data?.ResultSet[0].A_CrNote_Commi
            ? vSIHead?.data?.ResultSet[0].A_CrNote_Commi
            : "N",
          A_InvoiceType: vSIHead?.data?.ResultSet[0].A_InvoiceType,
        })
      );
      fNewDetail(
        vSIHead?.data?.ResultSet[0].A_VocNo,
        vSIHead?.data?.ResultSet[0].A_Rounding,
        vSIHead?.data?.ResultSet[0].A_VocTyp,
        vSIHead?.data?.ResultSet[0].A_CUSTFIELD3
      );
    }
  };

  //API GETSIDETAILS_GETROW
  const fLoad_Grid = async (
    xB_VocNo,
    xB_Srno,
    xRoundingValue = "",
    xVocTyp
  ) => {
    let iSIDetailObj = {
      // TrnTyp: sTrnTyp,
      v_VocTyp: !!xVocTyp ? xVocTyp : "",
      v_VocNo: !!xB_VocNo ? xB_VocNo : "",
      v_SrNo: xB_Srno,
    };
    const iSIDetail = await inv09_INV09_LoadDetail_GETROW(iSIDetailObj);
    if (iSIDetail?.status === 200) {
      let gridResp = iSIDetail?.data?.ResultSet.map((obj, i) => {
        return { ...obj, id: i + 1 };
      });
      setDetailGridData(gridResp);
      var iGrossAmt = 0,
        iTDiscAmt = 0,
        iLDiscAmt = 0,
        iFocAmt = 0,
        iExciseTaxNetAmt = 0,
        iTaxAmt = 0,
        iTaxAmt2 = 0,
        iAddCess = 0;
      console.log("grid", iSIDetail?.data?.ResultSet);

      for (let i = 0; i < iSIDetail?.data?.ResultSet?.length; i++) {
        iGrossAmt += iSIDetail?.data?.ResultSet[i]?.B_GrossAmt;
        iTDiscAmt += iSIDetail?.data?.ResultSet[i]?.B_TDiscAmt;
        iLDiscAmt += iSIDetail?.data?.ResultSet[i]?.B_LDiscAmt;
        iFocAmt += iSIDetail?.data?.ResultSet[i]?.B_FocAmt;
        iExciseTaxNetAmt += iSIDetail?.data?.ResultSet[i]?.B_ExciseTaxNetAmt;
        iTaxAmt += iSIDetail?.data?.ResultSet[i]?.B_TaxAmt;
        iTaxAmt2 += iSIDetail?.data?.ResultSet[i]?.B_TaxAmt2;
        iAddCess += iSIDetail?.data?.ResultSet[i]?.B_Ad_NetCessAmt;
      }

      let iLandVal =
        iGrossAmt -
        iTDiscAmt -
        iLDiscAmt -
        iFocAmt +
        iExciseTaxNetAmt +
        iTaxAmt +
        iTaxAmt2 +
        iAddCess +
        fcovertToNumber(xRoundingValue);

      console.log("footer", {
        A_GrossAmt: iGrossAmt?.toFixed(roundOffValue),
        A_TDiscAmt: iTDiscAmt?.toFixed(roundOffValue),
        A_LDiscAmt: iLDiscAmt?.toFixed(roundOffValue),
        A_FocAmt: iFocAmt?.toFixed(roundOffValue),
        A_NetExcise: iExciseTaxNetAmt?.toFixed(roundOffValue),
        A_Tax: iTaxAmt?.toFixed(roundOffValue),
        A_Tax2: iTaxAmt2?.toFixed(roundOffValue),
        A_AddCess: iAddCess?.toFixed(roundOffValue),
        A_LandVal: iLandVal?.toFixed(roundOffValue),
      });

      setFooterObj((obj) => ({
        ...obj,
        A_GrossAmt: iGrossAmt?.toFixed(roundOffValue),
        A_TDiscAmt: iTDiscAmt?.toFixed(roundOffValue),
        A_LDiscAmt: iLDiscAmt?.toFixed(roundOffValue),
        A_FocAmt: iFocAmt?.toFixed(roundOffValue),
        A_NetExcise: iExciseTaxNetAmt?.toFixed(roundOffValue),
        A_Tax: iTaxAmt?.toFixed(roundOffValue),
        A_Tax2: iTaxAmt2?.toFixed(roundOffValue),
        A_AddCess: iAddCess?.toFixed(roundOffValue),
        A_LandVal: iLandVal?.toFixed(roundOffValue),
      }));
    }
  };

  //DELETESIHEAD_GETROW
  const fDeleteHead = async (Srno = sBufferObj.B_Srno) => {
    let vDeleteSIHeadObj = {
      v_VocTyp: vRdxWmsHead.A_VocTyp,
      v_VocNo: vRdxWmsHead.A_VocNo,
      v_SrNo: Srno,
      v_IP: vRdxuserInfo.IP,
      v_UserId: vRdxuserInfo.UserID,
    };
    const vDeleteSIHead = await inv09_fINV09_Delete_GETROW(vDeleteSIHeadObj);
    if (vDeleteSIHead?.status === 200) {
      if (Srno == 0) {
        // vocno,srno
        dispatch(
          Set_SalesReturn_HeadObject_A_DocStatus({
            A_DocStat: "DELETE",
          })
        );
        fDisplay(vRdxWmsHead.A_VocTyp, vRdxWmsHead.A_VocNo);
        fNewDetail(
          vRdxWmsHead.A_VocNo,
          vRdxWmsHead.A_Rounding,
          vRdxWmsHead.A_VocTyp,
          vRdxWmsHead.A_TaxType
        );
        fAlertToast("SUCCESS", "Successfully Deleted");
      } else {
        fAlertToast("SUCCESS", "Successfully Deleted Line Item");
        fNewDetail(
          vRdxWmsHead.A_VocNo,
          "",
          vRdxWmsHead.A_VocTyp,
          vRdxWmsHead.A_TaxType
        );
      }
    }
  };

  const fonRowClickGridObj = async (item) => {
    setBufferObj((obj) => ({
      ...obj,
      B_VocTyp: vRdxWmsHead.A_VocTyp,
      B_VocNo: vRdxWmsHead.A_VocNo,
      B_Srno: item.row.B_Srno,
      B_Itmcd: item.row.B_Itmcd,
      B_ItmName: item.row.ItmName,
      B_Qty: item.row.B_Qty,
      B_Unit: item.row.B_Unit,

      B_UnitName: item.row.UnitName,
      B_PackQty: item.row.B_PackQty,
      B_BaseQty: item.row.B_BaseQty,
      B_URateFc: item.row.B_URateFc,
      B_URateLc: item.row.B_URateLc,
      B_GrossAmt: item.row.B_GrossAmt,
      B_LDiscPerc: item.row.B_LDiscPerc,
      B_LDiscAmt: item.row.B_LDiscAmt,
      B_TDiscPerc: item.row.B_TDiscPerc,
      B_TDiscAmt: item.row.B_TDiscAmt,
      B_FocFlag: item.row.B_FocFlag,
      B_FocAmt: item.row.B_FocAmt,
      B_Rounding: item.row.B_Rounding ? item.row.B_Rounding : 0,
      B_LandVal: item.row.B_LandVal,
      B_NetAmt: item.row.B_NetAmt,
      B_RefDocTyp: item.row.B_RefDocTyp,
      B_RefDocNo: item.row.B_RefDocNo,
      B_ExciseTaxAmt: item.row.B_ExciseTaxAmt,
      B_ExciseTaxNetAmt: item.row.B_ExciseTaxNetAmt,
      B_IncGroup: item.row.B_IncGroup,
      B_SuprvPerc: item.row.B_SuprvPerc,
      B_OthersPerc: item.row.B_OthersPerc,
      B_SLANSuprv: item.row.B_SLANSuprv,
      B_SlabAmtSuprv: item.row.B_SlabAmtSuprv,
      B_SLANOther: item.row.B_SLANOther,
      B_SlabAmtOther: item.row.B_SlabAmtOther,
      Reason: item.row.B_Type,
    }));

    let iUnit = await GetUnitArr(item.row.B_Itmcd, setUnit, false);
    let vItemUnitSet = iUnit.find((obj) => {
      return obj.Unit === item.row.B_Unit;
    });
    if (!!vItemUnitSet) {
      setBufferObj((obj) => ({
        ...obj,
        B_Unit: vItemUnitSet.Unit,
        B_UnitName: vItemUnitSet.Name1,
        B_PackQty: vItemUnitSet.PackQty,
      }));
    }
    if (vRdxDBKernObj?.SONAS_INVOICE?.Val === "Y") {
      let vIncentiveGroups = await GetIncentiveGroup(
        item.row.B_Itmcd,
        vRdxWmsHead.A_Loc,
        false
      );

      if (vIncentiveGroups?.Type?.toUpperCase() === "SUCCESS") {
        SetIncentiveGroups(vIncentiveGroups.ResultSet);
      } else {
        fAlertToast("FAILED", vIncentiveGroups.Message);
      }

      let vCurrentSalesHistory = await GetSalesHistory(item.row.B_Itmcd, false);

      if (vCurrentSalesHistory.length > 0) {
        setToggleGrid(true);
      } else {
        setToggleGrid(false);
      }
    }

    fCloseViewModal();
  };
  const fDetail_Grid_DoubleClick = async (item) => {
    console.log("DoubleClick", item);

    let obj = {
      // Merging the existing object
      SrNo: item.row.B_Srno,
      ItemCd: item.row.B_Itmcd,
      Batch: item.row.BatchCrl,
      Serial: item.row.SerialCrl,
      AutoGrn: item.row.AutoGrn,
    };

    setSerialDetalModal(obj);
    setBatchObj((obj) => ({
      ...obj,
      SrNo: item.row.B_Srno,
      ItemCode: item.row.B_Itmcd,
      ItemName: item.row.ItmName,
      Qty: item.row.B_Qty,
      Unit: item.row.B_Unit,
      BaseQty: item.row.B_BaseQty,
    }));
    let { BatchCrl, SerialCrl, AutoGrn, BatchQty } = item.row;
    console.log(BatchCrl, SerialCrl, AutoGrn, BatchQty);

    if (BatchCrl == "Y" || SerialCrl == "Y") {
      setBatchSelectionModal(true);
    }

    if (AutoGrn == "Y") {
      if (BatchQty == 0) {
        fAlertToast("FAILED", "Batch Quantity is zero");
      } else {
        setRegisterSerialNumberModal(true);
      }
    }
  };
  const fvalidateDiscount = () => {
    setErrorMsgDiscountModal(vErrorMsgDiscountModalInit);
    let iResp = true;
    if (
      Number(GCDiscountPercentage_Obj.A_DiscPerc) != 0 &&
      Number(GCDiscountPercentage_Obj.A_TDiscAmt <= 0)
    ) {
      setErrorMsgDiscountModal((obj) => ({
        ...obj,
        A_TDiscAmt: "Check discount percentage.",
      }));
      iResp = false;
    } else if (
      Number(GCDiscountPercentage_Obj.A_DiscPerc <= 0) &&
      Number(GCDiscountPercentage_Obj.A_TDiscAmt) != 0
    ) {
      setErrorMsgDiscountModal((obj) => ({
        ...obj,
        A_DiscPerc: "Check discount percentage",
      }));
      iResp = false;
    } else if (
      Number(GCDiscountPercentage_Obj.A_DiscPerc > 100) ||
      Number(GCDiscountPercentage_Obj.A_DiscPerc) < 0
    ) {
      setErrorMsgDiscountModal((obj) => ({
        ...obj,
        A_DiscPerc:
          "DiscPerc  must be greater than 0 and less than or equal to 100",
      }));
      iResp = false;
    }
    return iResp;
  };

  //API SALESHISTORY_GETROW
  const GetSalesHistory = async (xItmcd, loader = true) => {
    let vSalesHistoryObj = {
      ItmCd: xItmcd,
      UserCd: vRdxuserInfo.UserID,
    };
    const vSalesHistory = await SalesInvoice_inv08LoadVendorData_GETROW(
      vSalesHistoryObj,
      loader
    );
    if (vSalesHistory.status === 200) {
      let vSalesHistoryResp = vSalesHistory.data.ResultSet.map((obj, i) => ({
        ...obj,
        id: i + 1,
        A_PostDt: moment(obj.A_PostDt).format("DD/MM/YYYY"),
      }));
      setGridSalesHistoryRowData(vSalesHistoryResp);
      return vSalesHistoryResp;
    }
  };
  //API APPLYTDISCOUNT_GETROW
  const GCDiscountPercentage_Get_TDiscount = async () => {
    setErrorMsgDiscountModal(vErrorMsgDiscountModalInit);
    if (fvalidateDiscount()) {
      let vApplyTDiscountObj = {
        v_B_VocTyp: vRdxWmsHead.A_VocTyp,
        v_B_VocNo: vRdxWmsHead.A_VocNo,
        v_TDiscPerc: GCDiscountPercentage_Obj.A_DiscPerc,
      };
      const vApplyTDiscount = await inv09_fINV09_fDiscCalc_GETROW(
        vApplyTDiscountObj
      );
      if (vApplyTDiscount?.status === 200) {
        dispatch(
          Set_SalesReturn_HeadObject_Set({
            ...vRdxWmsHead,
            A_DiscPerc: GCDiscountPercentage_Obj.A_DiscPerc,
          })
        );
        GCDiscountPercentage_fClose();
        fNewDetail(
          vRdxWmsHead.A_VocNo,
          vRdxWmsHead.A_Rounding,
          vRdxWmsHead.A_VocTyp,
          vRdxWmsHead.A_TaxType
        );
        setTimeout(() => {
          document.getElementsByName("B_ItmName")[0]?.focus();
        }, 100);
      }
    }
  };

  const ValidationInv09 = async () => {
    const { HeadObject } = SalesReturnRo();
    const vRdxUserInfoObj = vRdxUserInfo();
    let obj = {
      v_UserId: vRdxUserInfoObj.UserID,
      v_A_VocTyp: HeadObject.A_VocTyp,
      v_A_VocNo: HeadObject.A_VocNo,
      v_A_CUSTFIELD10: "",
      v_A_PostDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
      v_A_Loc: HeadObject.A_Loc,
      v_A_Party: HeadObject.A_Party,
      v_B_Srno: sBufferObj.B_Srno,
      v_B_Itmcd: sBufferObj.B_Itmcd,
      v_B_Qty: sBufferObj.B_Qty,
      v_B_Unit: sBufferObj.B_Unit,
      v_TaxDept: sBufferObj.B_TaxDept,
      v_TaxDept2: sBufferObj.B_TaxDept2,
      Paymode: HeadObject.A_PayMode,
      RSP: sBufferObj.B_URateLc,
      NumerFormat: "N" + HeadObject.A_Rounding,
      Foc: sBufferObj.B_FocFlag,
      netAmt: sBufferObj.B_NetAmt,
      LandVal: sBufferObj.B_NetAmt,
      RefVocTyp: sBufferObj.B_RefDocTyp,
      RefVocNo: sBufferObj.B_RefDocNo,
      NCND: "N",
    };
    let resp = await inv09_validationINV09_GETROW(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (resp?.status === 200) {
      console.log(resp);
      if (resp?.data?.ResultSet?.length > 0) {
        //in this case it will ask or confirmation
        processResponse(resp?.data.ResultSet);
      } else {
        return true;
      }
    } else {
      if (resp.response.status == 500) {
        fAlertToast(
          "FAILED",
          resp.response.data.message.msg ||
            "error in ValidateInvTransHeadUpdate "
        );

        const errorField = resp?.response?.data?.message?.field;
        const errorMsg = resp?.response?.data?.message?.msg;
        if (vErrorMessageInit.hasOwnProperty(errorField)) {
          setErrorMsg((prev) => ({
            ...prev,
            [errorField]: errorMsg,
          }));
        } else {
          fAlertToast(
            "FAILED",
            resp.response.data.message.msg || "error in validationWMINV03 "
          );
        }

        document
          ?.getElementsByName([resp?.response?.data?.message?.field])[0]
          ?.focus();
      }
      return false;
    }
  };
  const ValidationApprove = async (xbool, docstatus) => {
    const { HeadObject } = SalesReturnRo();
    const vRdxUserInfoObj = vRdxUserInfo();
    let obj = {
      v_VocTyp: HeadObject.A_VocTyp,
      v_VocNo: HeadObject.A_VocNo,
      v_UserId: vRdxUserInfoObj.UserID,
      v_DocStat: HeadObject.A_DocStat,
      v_A_PayMode: HeadObject.A_PayMode,
      v_A_PostDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
      v_A_Party: HeadObject.A_Party,
      v_A_Loc: HeadObject.A_Loc,
      v_A_CUSTFIELD1: HeadObject.A_DropShipment,
      v_A_CUSTFIELD6: "N",
      v_A_CUSTFIELD10: "",
      v_A_Narr: HeadObject.A_Narr,
      NumerFormat: "N" + HeadObject.A_Rounding,
      NCND: "N",
    };
    let resp = await inv09_ApproveINV09_GETROW(
      fcheck_null_undefine_replace_empty(obj)
    );

    if (resp?.status === 200) {
      console.log(resp);
      if (resp?.data?.ResultSet.length > 0) {
        //in this case it will ask or confirmation
        processResponse(resp?.data.ResultSet, xbool, docstatus);
      } else {
        return true;
      }
    } else {
      if (resp.response.status == 500) {
        if (resp?.response?.data?.message?.field == "UNKNOWN") {
          fAlertToast(
            "FAILED",
            resp.response.data.message.msg ||
              "error in ValidateInvTransHeadUpdate "
          );
        } else {
          const errorField = resp?.response?.data?.message?.field;
          const errorMsg = resp?.response?.data?.message?.msg;
          if (vErrorMessageInit.hasOwnProperty(errorField)) {
            setErrorMsg((prev) => ({
              ...prev,
              [errorField]: errorMsg,
            }));
          } else if (vErrorMessageDetailInit.hasOwnProperty(errorField)) {
            setErrorMsgDetail((prev) => ({
              ...prev,
              [errorField]: errorMsg,
            }));
          } else {
            fAlertToast(
              "FAILED",
              resp.response.data.message.msg || "error in validationWMINV03 "
            );
          }

          document
            ?.getElementsByName([resp?.response?.data?.message?.field])[0]
            ?.focus();
        }
      }
      return false;
    }
  };
  const [batchFlag, setbatchFlag] = useState(false);

  const [sBatchObj, setBatchObj] = useState({
    SrNo: 0,
    ItemCode: "",
    ItemName: "",
    Qty: 0,
    Unit: "",
    BaseQty: 0,
  });
  const SaveINV09 = async (xSave, xDocStatus = "POST") => {
    const { HeadObject } = SalesReturnRo();
    const iStatus = xSave ? HeadObject.A_DocStat : xDocStatus; //xSave False means Post

    const vRdxUserInfoObj = vRdxUserInfo();
    let obj = {
      A_VocTyp: HeadObject.A_VocTyp,
      A_VocNo: HeadObject.A_VocNo,
      A_PostDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
      A_RefDt: moment(HeadObject.A_RefDt).format("MM/DD/YYYY"),
      A_RefNo: HeadObject.No,
      A_Party: HeadObject.A_Party,
      A_Curr: HeadObject.A_Curr,
      A_ExRate: parseFloat(HeadObject.A_ExRate),
      A_PayMode: HeadObject.A_PayMode,
      A_Type: HeadObject.A_Type,
      A_Loc: HeadObject.A_Loc,
      A_Buyer: HeadObject.A_Buyer,
      A_Narr: HeadObject.A_Narr,
      A_CrAc: "",
      A_DrAc: "",
      A_DiscPerc: parseFloat(HeadObject.A_DiscPerc),
      A_Rounding: parseFloat(HeadObject.A_Rounding),
      A_DocStat: iStatus,
      v_IP: vRdxUserInfoObj.IP,
      v_UserId: vRdxUserInfoObj.UserID,
      A_TaxGross: "N",
      A_Taxable: HeadObject.A_Taxable,
      A_CUSTFIELD1: HeadObject.A_DropShipment,
      A_CUSTFIELD2: HeadObject.Note,
      A_CUSTFIELD3: HeadObject.A_TaxType,
      A_CUSTFIELD4: "N",
      A_CUSTFIELD5: "",
      A_CUSTFIELD6: "N",
      A_CUSTFIELD7: "",
      A_CUSTFIELD8: "",
      A_CUSTFIELD9: "",
      A_CUSTFIELD10: "",
      v_A_LCust: HeadObject.LoyaltyCd,
      v_A_CrNote: HeadObject.CreditNote,
      v_A_CrNote_Commi: HeadObject.Commity,
      A_InvoiceType: HeadObject.A_InvoiceType,

      // Detail
      v_B_Srno: Number(sBufferObj.B_Srno),
      v_B_Itmcd: sBufferObj.B_Itmcd,
      v_B_Qty: parseFloat(sBufferObj.B_Qty),
      v_B_Unit: sBufferObj.B_Unit,
      v_B_BaseQty: parseFloat(sBufferObj.B_BaseQty),
      v_B_URateFc: parseFloat(sBufferObj.B_URateFc),
      v_B_URateLc: parseFloat(sBufferObj.B_URateLc),
      v_B_GrossAmt: parseFloat(sBufferObj.B_GrossAmt),
      v_B_LDiscPerc: parseFloat(sBufferObj.B_LDiscPerc),
      v_B_LDiscAmt: parseFloat(sBufferObj.B_LDiscAmt),
      v_B_FocFlag: sBufferObj.B_FocFlag,
      v_B_FOCAmt: parseFloat(sBufferObj.B_FocAmt),
      v_B_NetAmt: parseFloat(sBufferObj.B_NetAmt),
      v_B_LandVal: parseFloat(sBufferObj.B_NetAmt),
      v_B_RefDocTyp: sBufferObj.B_RefDocTyp,
      v_B_RefDocNo: sBufferObj.B_RefDocNo,
      v_B_BatchNo: "1 Year",
      v_B_RefNo1: "",
      v_B_URate_Fixed: 0,
      v_B_ExciseTaxAmt: parseFloat(sBufferObj.B_ExciseTaxAmt),
      v_B_ExciseTaxNetAmt: parseFloat(sBufferObj.B_ExciseTaxNetAmt),
      v_B_TaxPerc: parseFloat(sBufferObj.B_TaxPerc),
      v_B_TaxAmt: parseFloat(sBufferObj.B_TaxAmt),
      v_B_TaxPerc2: parseFloat(sBufferObj.B_TaxPerc2),
      v_B_TaxAmt2: parseFloat(sBufferObj.B_TaxAmt2),
      v_B_Ad_CessAmt: parseFloat(""),
      v_B_Ad_PCQty: parseFloat(""),
      v_B_Ad_PCRate: parseFloat(""),
      v_B_Ad_NetCessAmt: parseFloat(""),
      v_TaxDept: sBufferObj.B_TaxDept,
      v_TaxDept2: sBufferObj.B_TaxDept2,
      v_B_TDiscPerc: parseFloat(sBufferObj.B_TDiscPerc),
      v_B_TDiscAmt: parseFloat(sBufferObj.B_TDiscAmt),
      v_B_Type: sBufferObj.Reason, //reason
    };

    let vSaveSIHead = await inv09_saveInv09_GETROW(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (vSaveSIHead?.status === 200) {
      let iVocNo = xSave
        ? vSaveSIHead?.data?.ResultSet?.DocNo
        : vRdxWmsHead.A_VocNo;

      if (vRdxWmsHead.A_VocNo == "0") {
        setUser_Doc_Arr([
          ...sUser_Doc_Arr,
          {
            A_VocTyp: vRdxWmsHead.A_VocTyp,
            A_VocNo: iVocNo,
            SrNo: sUser_Doc_Arr.length + 1,
          },
        ]);
      }

      dispatch(
        Set_SalesReturn_HeadObject_A_VocNo_A_DocStat({
          A_VocNo: iVocNo,
          A_DocStat: iStatus,
        })
      );
      //approve bool type false
      if (!xSave) {
        fDisplay(vRdxWmsHead.A_VocTyp, iVocNo);
        fAlertToast("SUCCESS", "Successfully posted");
      } else {
        console.log(vSaveSIHead?.data?.ResultSet);
        let { A_CrAc, A_CrAcName, A_DrAc, A_DrAcName } =
          vSaveSIHead?.data?.ResultSet;

        dispatch(
          Set_SalesReturn_HeadObject_DrCrAccount({
            A_CrAc: A_CrAc,
            A_CrAcName: A_CrAcName,
            A_DrAc: A_DrAc,
            A_DrAcName: A_DrAcName,
          })
        );
        let obj = {
          ...vSaveSIHead?.data?.ResultSet?.Detail[0], // Merging the existing object
          ItemCd: sBufferObj.B_Itmcd, // Adding new field itmcd,
          // ItemCd:101421,// Adding new field itmcd,
          // SrNo:1// Adding new field itmcd,
        };
        setSerialDetalModal(obj);
        let { Batch, Serial, AutoGrn, SrNo } =
          vSaveSIHead?.data?.ResultSet.Detail[0];
        if (Batch == "Y" || Serial == "Y") {
          setBatchObj((obj) => ({
            ...obj,
            SrNo: SrNo,
            ItemCode: sBufferObj.B_Itmcd,
            ItemName: sBufferObj.B_ItmName,
            Qty: sBufferObj.B_Qty,
            Unit: sBufferObj.B_UnitName,
            BaseQty: sBufferObj.B_BaseQty,
          }));
          setBatchSelectionModal(true);
        }

        if (AutoGrn == "Y") {
          setRegisterSerialNumberModal(true);
        }

        fNewDetail(
          iVocNo,
          vRdxWmsHead.A_Rounding,
          vRdxWmsHead.A_VocTyp,
          vRdxWmsHead.A_TaxType
        );
        fAlertToast("SUCCESS", "Successfully Saved");
      }
    } else {
      if (vSaveSIHead.response.status == 500) {
        if (vSaveSIHead?.response?.data?.message?.field == "UNKNOWN") {
          fAlertToast(
            "FAILED",
            vSaveSIHead.response.data.message.msg ||
              "error in ValidateInvTransHeadUpdate "
          );
        } else {
          setErrorMsg((obj) => ({
            ...obj,
            [vSaveSIHead.response.data.message.field]:
              vSaveSIHead.response.data.message.msg,
          }));

          document
            ?.getElementsByName([
              vSaveSIHead?.response?.data?.message?.field,
            ])[0]
            ?.focus();
        }
      }
    }
  };

  //API ITEMNARRATION_GETROW
  const GetItemNarration = useCallback(async (xitmCd, xloc) => {
    let vItemNarrationObj = {
      itmCd: xitmCd,
      loc: xloc,
    };
    const vItemNarration = await fExecuteAPI(
      "ITEMNARRATION_GETROW",
      vItemNarrationObj
    );
    if (vItemNarration?.Type?.toUpperCase() === "SUCCESS") {
      let itemList = vItemNarration.ResultSet.map((obj) => {
        return obj.Name;
      });
      //bcoz itemlist returning "" in arr [0]
      if (itemList[0] != "") {
        setNarrArr(itemList);
      }
    } else {
      fAlertToast(
        "FAILED",
        vItemNarration?.response?.data?.Status ||
          vItemNarration?.response?.data?.message ||
          vItemNarration?.message ||
          "Item narration"
      );
    }
  }, []);

  //API TransTaxType_GETROW
  const GetTransTaxType = async (xLoc, xParty) => {
    let vTransTaxTypeObj = {
      loc: xLoc,
      party: xParty,
      taxtype: "OUT",
    };
    const vItemStock = await fExecuteAPI(
      "TransTaxType_GETROW",
      vTransTaxTypeObj
    );
    if (vItemStock?.Type?.toUpperCase() === "SUCCESS") {
      return vItemStock.ResultSet;
    } else {
      fAlertToast(
        "FAILED",
        vItemStock.response.data.Status ||
          vItemStock?.response?.data?.message ||
          vItemStock?.message
      );
      return [];
    }
  };

  //API CHECKCUSTOMEROVERDUE_GETROW
  const GetCheckCustomerOverDue = async () => {
    let vCheckCustomerOverDueObj = {
      A_Party: vRdxWmsHead?.A_Party,
      userGrp: vRdxuserInfo?.UserGroupCode,
    };
    const vCheckCustomerOverDue = await fExecuteAPI(
      "CHECKCUSTOMEROVERDUE_GETROW",
      vCheckCustomerOverDueObj
    );
    if (vCheckCustomerOverDue?.Type?.toUpperCase() === "SUCCESS") {
      return vCheckCustomerOverDue.ResultSet;
    } else {
      fAlertToast(
        "FAILED",
        vCheckCustomerOverDue.Message ||
          vCheckCustomerOverDue.response.data.Status ||
          vCheckCustomerOverDue?.response?.data?.message ||
          vCheckCustomerOverDue?.message
      );
    }
  };
  //API CHECKCRLIMIT_GETROW
  const GetCheckCRLimit = async () => {
    let vCheckCRLimitObj = {
      A_Party: vRdxWmsHead?.A_Party,
      userGrp: vRdxuserInfo?.UserGroupCode,
      landAmt: sFooterObj?.A_LandVal,
      loc: vRdxWmsHead?.A_Loc,
    };
    const vCheckCRLimit = await fExecuteAPI(
      "CHECKCRLIMIT_GETROW",
      vCheckCRLimitObj
    );
    if (vCheckCRLimit?.Type?.toUpperCase() === "SUCCESS") {
      return vCheckCRLimit?.ResultSet;
    } else {
      fAlertToast(
        "FAILED",
        vCheckCRLimit?.Status || vCheckCRLimit?.Message || "CHECKCRLIMIT_GETROW"
      );
    }
  };

  //API AUDITFIELD_GETROW
  const GetAuditField = async () => {
    // http://localhost:3999/RpDesign/auditFields?trnTyp=WMINV08
    const vAuditField = await fExecuteAPI("AUDITFIELD_GETROW", sTrnTyp);
    if (vAuditField?.Type?.toUpperCase() === "SUCCESS") {
      set_GCAudit_Dropdown_Arr(vAuditField?.ResultSet);
      return vAuditField?.ResultSet;
    } else {
      fAlertToast("FAILED", vAuditField?.Message);
      return vAuditField?.ResultSet;
    }
  };

  //API TRANSAUDIT_GETROW
  const GCAudit_GetTransAudit = async (xid) => {
    let vTransAuditObj = {
      VocTyp: vRdxWmsHead?.A_VocTyp,
      VocNo: vRdxWmsHead?.A_VocNo,
      TrnTyp: sTrnTyp,
      Field: xid,
    };
    const vTransAudit = await fExecuteAPI("INV08_audit_GETROW", vTransAuditObj);
    if (vTransAudit?.Type?.toUpperCase() === "SUCCESS") {
      let vTransAuditRes = vTransAudit?.ResultSet.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setGridDataAuditRows(vTransAuditRes);
    } else {
      fAlertToast("FAILED", vTransAudit?.Message);
    }
  };

  //defcustomersetting_GETROW
  const GetDefcustomersetting = async (xAcCd, xLoc) => {
    if (vRdxDBKernObj?.SONAS_INVOICE?.Val === "Y") {
      let vdefcustomersettingObj = {
        accd: xAcCd,
        loc: xLoc,
      };
      const vdefcustomersetting = await fExecuteAPI(
        "defcustomersetting_GETROW",
        vdefcustomersettingObj
      );
      if (vdefcustomersetting?.Type?.toUpperCase() == "SUCCESS") {
        if (vdefcustomersetting.ResultSet.length > 0) {
          dispatch(
            Set_SalesReturn_HeadObject_SalesGroup_SalesMan({
              A_Buyer: !!vdefcustomersetting?.ResultSet[0]?.SalesMan
                ? vdefcustomersetting?.ResultSet[0]?.SalesMan || ""
                : sSalesman[0]?.UId || "",
              A_SalesGroup: !!vdefcustomersetting?.ResultSet[0]?.SalesGroup
                ? vdefcustomersetting?.ResultSet[0]?.SalesGroup || ""
                : sSalesGroup[0]?.UId || "",
            })
          );
        }
      } else {
        fAlertToast(
          "FAILED",
          vdefcustomersetting?.Message ||
            vdefcustomersetting?.response?.data?.message ||
            vdefcustomersetting?.message ||
            "Error in default setting customer"
        );
      }
    }
  };
  //defcustomersetting_GETROW
  const DefaultPriceLevel = async (xAcCd, xLoc) => {
    let obj = {
      CustCd: xAcCd,
      iLoc: xLoc,
    };
    let resp = await SalesOrder_getCustomerPriceLevel_GETROW(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (resp?.status === 200) {
      console.log(
        "resp",
        resp.data.ResultSet.PriceType,
        vRdxPricelevel,
        vRdxPricelevel.find((obj) => obj.UId == resp.data.ResultSet.PriceType)
      );
      let defaultType = vRdxPricelevel.find(
        (obj) => obj.UId == resp.data.ResultSet.PriceType
      );
      console.log(
        !!defaultType,
        resp.data.ResultSet.PriceType,
        vRdxPricelevel[0],
        !!defaultType ? resp.data.ResultSet.PriceType : vRdxPricelevel[0]
      );

      dispatch(
        Set_HeadObject_Type({
          A_Type: !!defaultType
            ? resp.data.ResultSet.PriceType
            : vRdxPricelevel[0],
        })
      );
    }
  };

  const InterCompanyDependency = (xTaxID, xCessID) => {
    let vtaxGroupValue = vRdxGRNtax1.find((obj) => {
      return obj.UId == xTaxID;
    });
    let vCessGroupValue = vRdxGRNtax2.find((obj) => {
      return obj.UId == xCessID;
    });
    if (vtaxGroupValue) {
      setBufferObj((obj) => ({
        ...obj,
        B_TaxDept: vtaxGroupValue?.UId,
        B_TaxPerc: vtaxGroupValue?.Perc,
        B_TaxDept2: vCessGroupValue?.UId,
        B_TaxPerc2: vCessGroupValue?.Perc,
      }));
    }

    let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      sBufferObj.B_PackQty,
      vRdxWmsHead.A_ExRate,
      sBufferObj.B_URateFc,
      sBufferObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      sBufferObj.B_ExciseTaxAmt,
      vtaxGroupValue?.Perc,
      vCessGroupValue?.Perc,
      sBufferObj.AddCess,
      0
    );

    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
    }));
    return {
      B_TaxPerc: vtaxGroupValue?.Perc,
      B_TaxPerc2: vCessGroupValue?.Perc,
    };
  };
  const GetRevereTransaction = async () => {
    const { HeadObject } = SalesReturnRo();
    const vRdxUserInfoObj = vRdxUserInfo();
    let obj = {
      v_VocTyp: HeadObject.A_VocTyp,
      v_VocNo: HeadObject.A_VocNo,
      v_UserCd: vRdxUserInfoObj.UserID,
      v_DocStat: HeadObject.A_DocStat,
      v_IP: vRdxUserInfoObj.IP,
      v_A_PostDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
      v_A_Loc: HeadObject.A_Loc,
    };
    let resp = await inv09_ReverseINV09_GETROW(
      fcheck_null_undefine_replace_empty(obj)
    );

    if (resp?.status === 200) {
      return true;
    } else {
      if (resp.response.status == 500) {
        fAlertToast(
          "FAILED",
          resp.response.data.message.msg ||
            "error in ValidateInvTransHeadUpdate "
        );
      }
      return false;
    }
  };
  //API FillVanMaster_GETROW
  const GetFillVanMaster = async () => {
    let vFillVanMasterObj = {
      VocTyp: vRdxWmsHead.A_VocTyp,
      VocNo: vRdxWmsHead.A_VocNo,
      SalesGroup: vRdxWmsHead.A_SalesGroup,
      Flag: "N",
    };
    const vFillVanMaster = await fExecuteAPI(
      "FillVanMaster_GETROW",
      vFillVanMasterObj
    );
    if (vFillVanMaster?.Type?.toUpperCase() == "SUCCESS") {
      return vFillVanMaster.Type;
    } else {
      fAlertToast("FAILED", vFillVanMaster.response.data.Status);
      return vFillVanMaster.Type;
    }
  };

  //API EmployeeSearchVanGroup_GETROW
  const GetEmployeeSearchVanGroup = async (xAnyData) => {
    let vEmployeeSearchVanGroupObj = {
      v_AnyData: xAnyData,
      v_FName: GCEmployee_SalesGroup_Obj.FirstName,
      v_LName: GCEmployee_SalesGroup_Obj.LastName,
      v_MName: GCEmployee_SalesGroup_Obj.MiddleName,
      v_UserCd: vRdxuserInfo.UserID,
    };
    const vEmployeeSearchVanGroup = await fExecuteAPI(
      "EmployeeSearchVanGroup_GETROW",
      vEmployeeSearchVanGroupObj
    );
    if (vEmployeeSearchVanGroup?.Type?.toUpperCase() == "SUCCESS") {
      let GridID = vEmployeeSearchVanGroup.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      set_GCEmployee_SalesGroup_GridData_Row(GridID);
    } else {
      fAlertToast(
        "FAILED",
        vEmployeeSearchVanGroup.Message ||
          vEmployeeSearchVanGroup.response.data.Status ||
          "EmployeeSearchVanGroup_GETROW"
      );
    }
  };
  //API WMINV08VANMastItemSave_GETROW
  const GetVANMastItemSave = async () => {
    let vSaveSaleGroupModalObj = {
      v_VocTyp: vRdxWmsHead.A_VocTyp,
      v_VocNo: vRdxWmsHead.A_VocNo,
      v_UId: vRdxWmsHead.A_SalesGroup,
      v_SrNo: GCVanMaster_SalesGroup_ModalObj.SrNo,
      v_Typ: GCVanMaster_SalesGroup_ModalObj.Type,
      v_EMPID: GCVanMaster_SalesGroup_ModalObj.EmployeeID,
      v_UserCd: vRdxuserInfo.UserID,
      v_Ip: vRdxuserInfo.IP,
      v_Active: GCVanMaster_SalesGroup_ModalObj.Active,
    };
    const vSaveSaleGroupModal = await fExecuteAPI(
      "WMINV08VANMastItemSave_GETROW",
      vSaveSaleGroupModalObj
    );
    if (vSaveSaleGroupModal?.Type?.toUpperCase() == "SUCCESS") {
      fAlertToast("SUCCESS", "Successfully Saved");
      GCVanMaster_SalesGroup_fNew();
    } else {
      fAlertToast("FAILED", vSaveSaleGroupModal.response.data.Status);
    }
  };

  //API WMINV08VANMastItemDelete_GETROW
  const GCVanMaster_SalesGroup_GetDelete = async () => {
    let vDeleteSaleGroupModalObj = {
      v_VocTyp: vRdxWmsHead.A_VocTyp,
      v_VocNo: vRdxWmsHead.A_VocNo,
      v_UId: vRdxWmsHead.A_SalesGroup,
      v_SrNo: GCVanMaster_SalesGroup_ModalObj.SrNo,
    };
    const vDeleteSaleGroupModal = await fExecuteAPI(
      "WMINV08VANMastItemDelete_GETROW",
      vDeleteSaleGroupModalObj
    );
    if (vDeleteSaleGroupModal?.Type?.toUpperCase() == "SUCCESS") {
      fAlertToast("SUCCESS", "Successfully Deleted");
      GCVanMaster_SalesGroup_fNew();
    } else {
      fAlertToast("FAILED", vDeleteSaleGroupModal.response.data.Status);
    }
  };

  //API WMINV08VANMastItemList_GETROW
  const GetVANMastItemList = async () => {
    let vVANMastItemListObj = {
      v_VocTyp: vRdxWmsHead.A_VocTyp,
      v_VocNo: vRdxWmsHead.A_VocNo,
      v_UID: vRdxWmsHead.A_SalesGroup,
    };
    const vVANMastItemList = await fExecuteAPI(
      "WMINV08VANMastItemList_GETROW",
      vVANMastItemListObj
    );
    if (vVANMastItemList?.Type?.toUpperCase() == "SUCCESS") {
      let GridID = vVANMastItemList.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      set_GCVanMaster_SalesGroup_GridData_Row(GridID);
    } else {
      fAlertToast("FAILED", vVANMastItemList.response.data.Status);
    }
  };

  //API ItemsAliasList_GETROW
  const ItemsAliasListSearch = useCallback(async (xLoc, xItmCd) => {
    let ItemsAliasListSearchObj = {
      ItmCd: xItmCd,
      Loc: xLoc,
    };
    const vItemsAliasListSearchSearch = await fExecuteAPI(
      "ItemsAliasList_GETROW",
      ItemsAliasListSearchObj
    );
    console.log(vItemsAliasListSearchSearch);
    if (vItemsAliasListSearchSearch?.Type?.toUpperCase() == "SUCCESS") {
      // PostDate: moment(obj.PostDate).format("DD/MM/YYYY")
      let GridID = vItemsAliasListSearchSearch.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setNarrationSearchGridData(GridID);
      setNarrationSearchGridFullData(GridID);
      return GridID;
    } else {
      fAlertToast("FAILED", "Error in loading ItemsAliasListSearchSearch");
      return [];
    }
  }, []);
  const onload = useCallback(async () => {
    if (vRdxDBKernObj?.BATCH_NO_AUTO?.Val === "Y") {
      //batch field should be disabled
      setbatchFlag(true);
    }
    let iAttributeResp = await GetAttributes(
      setUser_Doc_Arr,
      setObjectRights,
      setDocLoading,
      setCurrency,
      setLocation,
      setTaxType,
      setType,
      setSalesman,
      setReason,
      setDefault,
      setInvoiceTyp
    );

    let vResponceObj = {
      B_SLANSuprv: "",
      B_SLANOther: "",
    };
    const vSupervisorSlabs = iAttributeResp?.SupervisorSlabs;
    if (vSupervisorSlabs?.length > 0) {
      vResponceObj.B_SLANSuprv = vSupervisorSlabs[0];
    }
    const vOtherSlabs = iAttributeResp?.OtherSlabs;
    if (vOtherSlabs?.length > 0) {
      vResponceObj.B_SLANOther = vOtherSlabs[0];
    }
    setBufferObj((obj) => ({
      ...obj,
      B_SLANSuprv: vResponceObj.B_SLANSuprv,
      B_SLANOther: vResponceObj.B_SLANOther,
    }));

    var CurrencyArr = {
      Uid: "",
      Name1: "",
      Rate: 0,
    };

    const vCurrency = iAttributeResp?.Currency;
    if (vCurrency.length > 0) {
      CurrencyArr = vCurrency[0];
    }

    var iTypeArr = {
      UId: "",
      Name1: "",
    };
    let vTypeArr = iAttributeResp?.Type;
    if (vTypeArr.length > 0) {
      iTypeArr = vTypeArr[1];
    }
    //Grn Salesman select api
    var SalesManId = "";
    const vSalesman = iAttributeResp?.Salesman;
    if (vSalesman?.length > 0) {
      SalesManId = vSalesman[0].UId;
    }

    var LocationObj = {
      UID: " ",
      Name1: " ",
      Br: "",
    };
    const vLocation = iAttributeResp?.Loc;

    if (vLocation?.length > 0) {
      if (iAttributeResp?.DefaultRecordset) {
        let iDefault = iAttributeResp?.DefaultRecordset?.find(
          (x) => x?.Field == "LOCATION"
        );
        console.log(iDefault);

        if (iDefault) {
          iDefault = iAttributeResp?.Loc?.find((x) => x?.UID == iDefault?.val);
          if (iDefault) {
            LocationObj = iDefault;
          }
        }
      } else {
        LocationObj = vLocation[0];
      }
    }

    let vDefaultTaxType = "OTTRN001";
    let iDefaultTaxType = await GetTransTaxType(
      vRdxWmsHead.A_Loc == "" ||
        vRdxWmsHead.A_Loc === null ||
        vRdxWmsHead.A_Loc === undefined
        ? LocationObj.UID
        : vRdxWmsHead.A_Loc,
      vRdxWmsHead.A_Party
    );

    if (Object.keys(iDefaultTaxType[0]).length != 0) {
      vDefaultTaxType = iDefaultTaxType[0]?.TaxType;
    }

    const vSalesGroup = await GetSalesGroups(
      vRdxWmsHead.A_Loc == "" ||
        vRdxWmsHead.A_Loc === null ||
        vRdxWmsHead.A_Loc === undefined
        ? LocationObj.UID
        : vRdxWmsHead.A_Loc
    );
    if (vSalesGroup?.Type?.toUpperCase() === "SUCCESS") {
      setSalesGroup(vSalesGroup.ResultSet);
    } else {
      fAlertToast("FAILED", vSalesGroup.Message);
    }

    if (vRdxDBKernObj?.INV08_GRID_DATA) {
      set_Sales_History_STOCK_SALES(vRdxDBKernObj?.INV08_GRID_DATA.Val);
    }

    let vDocLoadingObj = {
      VocTyp: "",
      VocName: "",
      Paymode: "",
    };
    const vDocLoading = iAttributeResp?.Vouchar;

    if (vDocLoading.length > 0) {
      vDocLoadingObj = vDocLoading[0];
      fDefaultPayload(
        vRdxWmsHead.A_Curr == "" ||
          vRdxWmsHead.A_Curr === null ||
          vRdxWmsHead.A_Curr === undefined
          ? vDocLoading[0]?.Paymode
          : vRdxWmsHead.A_PayMode,
        dispatch,
        setPaymodeEnable
      );

      let vSalesGroupObj = await fSalesGroup(
        vRdxWmsHead.A_Loc == "" ||
          vRdxWmsHead.A_Loc === null ||
          vRdxWmsHead.A_Loc === undefined
          ? LocationObj.UID
          : vRdxWmsHead.A_Loc
      );

      dispatch(
        Set_SalesReturn_HeadObject_Set({
          ...vRdxWmsHead,
          A_VocTyp:
            vRdxWmsHead.A_VocTyp == "" ||
            vRdxWmsHead.A_VocTyp === null ||
            vRdxWmsHead.A_VocTyp === undefined
              ? vDocLoadingObj.VocTyp
              : vRdxWmsHead.A_VocTyp,
          A_VocTypName:
            vRdxWmsHead.A_VocTyp == "" ||
            vRdxWmsHead.A_VocTyp === null ||
            vRdxWmsHead.A_VocTyp === undefined
              ? vDocLoadingObj?.VocName
              : vRdxWmsHead.A_VocTypName,
          A_Loc:
            vRdxWmsHead.A_Loc == "" ||
            vRdxWmsHead.A_Loc === null ||
            vRdxWmsHead.A_Loc === undefined
              ? LocationObj.UID
              : vRdxWmsHead.A_Loc,

          A_Curr:
            vRdxWmsHead.A_Curr == "" ||
            vRdxWmsHead.A_Curr === null ||
            vRdxWmsHead.A_Curr === undefined
              ? CurrencyArr.Uid
              : vRdxWmsHead.A_Curr,
          A_Currname:
            vRdxWmsHead.A_Curr == "" ||
            vRdxWmsHead.A_Curr === null ||
            vRdxWmsHead.A_Curr === undefined
              ? CurrencyArr.Name1
              : vRdxWmsHead.A_Currname,
          A_ExRate:
            vRdxWmsHead.A_Curr == "" ||
            vRdxWmsHead.A_Curr === null ||
            vRdxWmsHead.A_Curr === undefined
              ? CurrencyArr.Rate
              : vRdxWmsHead.A_ExRate,
          A_Buyer:
            vRdxWmsHead.A_Buyer == "" ||
            vRdxWmsHead.A_Buyer === null ||
            vRdxWmsHead.A_Buyer === undefined
              ? SalesManId
              : vRdxWmsHead.A_Buyer,
          A_SalesGroup:
            vRdxWmsHead.A_SalesGroup == "" ||
            vRdxWmsHead.A_SalesGroup === null ||
            vRdxWmsHead.A_SalesGroup === undefined
              ? vSalesGroupObj?.A_CUSTFIELD2
              : vRdxWmsHead.A_SalesGroup,
          A_TaxType:
            vRdxWmsHead.A_Curr == "" ||
            vRdxWmsHead.A_Curr === null ||
            vRdxWmsHead.A_Curr === undefined
              ? vDefaultTaxType
              : vRdxWmsHead.A_TaxType,
          A_Type:
            vRdxWmsHead.A_Type == "" ||
            vRdxWmsHead.A_Type === null ||
            vRdxWmsHead.A_Type === undefined
              ? iTypeArr.UId
              : vRdxWmsHead.A_Type,
        })
      );
      fLoad_Grid(
        vRdxWmsHead.A_VocNo,
        0,
        0,
        vRdxWmsHead.A_VocTyp == "" ||
          vRdxWmsHead.A_VocTyp === null ||
          vRdxWmsHead.A_VocTyp === undefined
          ? vDocLoadingObj.VocTyp
          : vRdxWmsHead.A_VocTyp
      );
      GetDefcustomersetting(
        vRdxWmsHead.A_Party,
        vRdxWmsHead.A_Loc == "" ||
          vRdxWmsHead.A_Loc === null ||
          vRdxWmsHead.A_Loc === undefined
          ? LocationObj.UID
          : vRdxWmsHead.A_Loc
      );
      DefaultPriceLevel(
        vRdxWmsHead.A_Party,
        vRdxWmsHead.A_Loc == "" ||
          vRdxWmsHead.A_Loc === null ||
          vRdxWmsHead.A_Loc === undefined
          ? LocationObj.UID
          : vRdxWmsHead.A_Loc
      );

      let iInterCompanyDependency = {
        B_TaxPerc: vRdxGRNtax1[0].Perc,
        B_TaxPerc2: vRdxGRNtax2[0].Perc,
      };
      //if inter.comp then tax group should be 0
      if (iDefaultTaxType == "OTTRN003" || iDefaultTaxType == "OTTRN002") {
        iInterCompanyDependency = InterCompanyDependency(
          vRdxDBKernObj.DEF_ZERO_TAX_CODE.Val,
          vRdxDBKernObj.DEF_ZERO_CESS_CODE.Val
        );
      }
      let {
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,

        B_Rounding,
        B_TaxAmt,
        B_TaxAmt2,
        B_NetAddCess,
        B_LandVal,
      } = fCalculate_Detail(
        0, //sBufferObj.B_Qty,
        0, //sBufferObj.B_PackQty,
        vRdxWmsHead.A_Curr == "" ||
          vRdxWmsHead.A_Curr === null ||
          vRdxWmsHead.A_Curr === undefined
          ? CurrencyArr.Rate
          : vRdxWmsHead.A_ExRate, //exchangeRate
        0, //sBufferObj.B_URateFc,
        0, //sBufferObj.B_LDiscPerc,
        vRdxWmsHead?.A_DiscPerc, //sBufferObj.B_TDiscPerc, // initial state A_DiscPerc 0 if refresh then current value
        "N", //sBufferObj.B_FocFlag,
        0, //sBufferObj.B_ExciseTaxAmt,
        iInterCompanyDependency.B_TaxPerc, //tax1%
        iInterCompanyDependency.B_TaxPerc2, //tax%2
        0, //sBufferObj.AddCess,
        0 //Rounding
      );

      setBufferObj((obj) => ({
        ...obj,
        B_BaseQty,
        B_URateLc,
        B_GrossAmt,
        B_LDiscAmt,
        B_TDiscAmt,
        B_FocAmt,
        B_ExciseTaxNetAmt,
        B_NetAmt,

        B_Rounding,
        B_TaxAmt,
        B_TaxAmt2,
        B_NetAddCess,
        B_LandVal,
        B_TDiscPerc: vRdxWmsHead?.A_DiscPerc,
      }));
    }
  }, []);

  useEffect(() => {
    var resultObj = fCheck_Doc_Rights_001(
      vRdxWmsHead.A_DocStat,
      vRdxWmsHead.A_VocTyp,
      !!sObjectRights && sObjectRights.length > 0 ? sObjectRights : []
    );
    setObjRights(resultObj);
  }, [vRdxWmsHead.A_DocStat, vRdxWmsHead.A_VocTyp, sObjectRights]);

  useEffect(() => {
    ItemsAliasListSearch(vRdxWmsHead.A_Loc, sBufferObj.B_Itmcd);
  }, [vRdxWmsHead.A_Loc, sBufferObj.B_Itmcd, ItemsAliasListSearch]);

  useEffect(() => {
    if (sLocation.length > 0 && vRdxWmsHead.A_Loc != "") {
      let iLineItemLoction = sLocation.find(
        (obj) => obj?.UID === vRdxWmsHead?.A_Loc
      );
      let iLineItemLoctionCurrentArr = sLocation.filter((obj) => {
        return iLineItemLoction?.Br === obj?.Br;
      });
      if (iLineItemLoctionCurrentArr.length > 0) {
        setItemLocation(iLineItemLoctionCurrentArr);
      } else {
        setItemLocation([]);
      }
    } else {
      setItemLocation([]);
    }
  }, [vRdxWmsHead.A_Loc, sLocation]);

  useEffect(() => {
    if (
      vRdxWmsHead.A_DocStat !== "ENTER" ||
      vRdxWmsHead.A_Loc === null ||
      vRdxWmsHead.A_Loc === undefined ||
      vRdxWmsHead.A_Loc === "" ||
      sBufferObj.B_Itmcd === "" ||
      sBufferObj.B_Unit === ""
    ) {
      setTransItemStockObj({
        RPStock: 0,
        MSP: 0,
        CostPr: 0,
        LPRate: 0,
      });
      return;
    } else {
      getTransItemStockUOM(
        setTransItemStockObj,
        sBufferObj.B_Itmcd,
        sBufferObj.B_Unit,
        vRdxWmsHead.A_Loc
      );
    }
  }, [
    dispatch,
    sBufferObj.B_Itmcd,
    sBufferObj.B_Unit,
    vRdxWmsHead.A_Loc,
    vRdxWmsHead.A_DocStat,
  ]);

  useEffect(() => {
    if (
      vRdxWmsHead.A_DocStat !== "ENTER" ||
      vRdxWmsHead.A_Party === null ||
      vRdxWmsHead.A_Party === undefined ||
      vRdxWmsHead.A_Party === ""
    ) {
      setOSDetailObj({
        partyos: "0",
        partypdc: "0",
        CrLimit: "0",
        partyNetOS: "0",
        CrlimitPRD: "0",
        FixedCost: "0",
      });
      return;
    } else {
      getOSDetail(setOSDetailObj, vRdxWmsHead.A_Party);
    }
  }, [dispatch, vRdxWmsHead.A_DocStat, vRdxWmsHead.A_Party]);
  // useEffect(() => {

  useEffect(() => {
    GetItemNarration(sBufferObj.B_Itmcd, vRdxWmsHead.A_Loc);
  }, [sBufferObj.B_Itmcd, vRdxWmsHead.A_Loc, GetItemNarration]);

  useEffect(() => {
    onload();
  }, [onload]);
  useEffect(() => {
    RefNoFocusOnLoad.current?.focus();
  }, []);
  const fkeyup = useCallback((e) => {
    if (e.key === "Enter") {
      let lastChild = document.getElementById("WmsSalesReturnContentID");
      let TagArr = !!lastChild ? lastChild.querySelectorAll(".col-4") : "";
      let ilengthz = !!TagArr ? TagArr?.length : "";
      if (!!ilengthz) {
        if (
          TagArr[ilengthz - 1].getElementsByTagName("input")[0].name ==
            e.target.name &&
          document.getElementById("WMSDocStatID").innerHTML == "ENTER"
        ) {
          confirmAlert({
            title: "Save",
            message: "Are you want to Save.",
            buttons: [
              {
                className: "alertBtn",
                name: "SaveYes",
                id: "EnterSave",
                label: "Yes",
                onClick: () => {
                  document.getElementById("INV08BtnSave").click();
                },
              },
              {
                className: "alertBtn",
                label: "No",
                onClick: () => "",
              },
            ],
            onOpen: () => {
              setTimeout(() => {
                document.getElementById("EnterSave")?.focus();
              }, 500);
            },
          });
        }
      }
    }
    if (e.which == 27 || e.key === "Escape") {
      setToggleGrid(false);
      setNarrationToggleDropdown(false);
      set_GCToggleSearch_Customer_Toggle(false);
      setToggleDropdown(false);
      setRefDocToggleDropdown(false);
      setRefDocSearchGridData([]);
      setRefDocSearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    }
  }, []);
  useEffect(() => {
    document.addEventListener("keyup", (e) => fkeyup(e), false);
    return () => {
      document.removeEventListener("keyup", fkeyup, false);
    };
  }, [fkeyup]);

  const fkeyup2 = useCallback(
    (e) => {
      let vRdxPrint = "P";
      FShortCutKey(
        e,
        "INV08BtnNew",
        "INV08BtnSave",
        "INV08BtnApprove",
        "INV08BtnSearch",
        "INV08BtnDelete",
        "INV08BtnAudit",
        vRdxPrint,
        fPrint
      );
    },
    [fPrint]
  );
  useLayoutEffect(() => {
    window.addEventListener("keyup", fkeyup2);

    return () => {
      window.removeEventListener("keyup", fkeyup2);
    };
  }, [fkeyup2]);
  // if ONE TOGGLE FUNCTION OPEN THEN OTHER TOGGLE WILL CLOSE

  useEffect(() => {
    if (GCToggleSearch_Item_ToggleDropdown === true) {
      setNarrationToggleDropdown(false);
      set_GCToggleSearch_Customer_Toggle(false);
    }
  }, [GCToggleSearch_Item_ToggleDropdown]);

  useEffect(() => {
    if (GCToggleSearch_Customer_Toggle === true) {
      setToggleDropdown(false);
      setNarrationToggleDropdown(false);
    }
  }, [GCToggleSearch_Customer_Toggle]);

  useEffect(() => {
    if (sNarrationToggleDropdown === true) {
      set_GCToggleSearch_Customer_Toggle(false);
      setToggleDropdown(false);
    }
  }, [sNarrationToggleDropdown]);

  // CLICK ANY WHERE AND CLOSE IF TOGGLE IS CLOSED
  useEffect(() => {
    const handleClick = (event) => {
      if (GCToggleSearch_Item_ToggleDropdown) {
        const toggleElement = event.target.closest(".dropDowntoggle");
        if (!toggleElement) {
          setToggleDropdown(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [GCToggleSearch_Item_ToggleDropdown]);

  useEffect(() => {
    const handleClick = (event) => {
      if (GCToggleSearch_Customer_Toggle) {
        const toggleElement = event.target.closest(".dropDowntoggle");
        if (!toggleElement) {
          set_GCToggleSearch_Customer_Toggle(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [GCToggleSearch_Customer_Toggle]);

  useEffect(() => {
    const handleClick = (event) => {
      if (sGCSearchBtn_Toggle_ToggleDropDowm) {
        const toggleElement = event.target.closest(".toggleSearch");
        if (!toggleElement) {
          setGCSearchBtn_ToggleDropDowm(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sGCSearchBtn_Toggle_ToggleDropDowm]);

  useEffect(() => {
    const handleClick = (event) => {
      if (sNarrationToggleDropdown) {
        const toggleElement = event.target.closest(".dropDowntoggle");
        if (!toggleElement) {
          setNarrationToggleDropdown(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sNarrationToggleDropdown]);

  useEffect(() => {
    GetOSAmount(vRdxWmsHead.A_Loc, vRdxWmsHead.A_Party, setOsAmount);
  }, [vRdxWmsHead.A_Loc, vRdxWmsHead.A_Party]);

  return (
    <div className="container-fluid">
      {/* mobile Screen nav  */}
      <GCNAV
        fNew={fNew}
        xDisableNew={sObjRights.RNew == "N"}
        fSave={fSave}
        xDisableSave={sObjRights.RSave == "N"}
        sRightClick={sRigntClick}
        xRightClick={(e) => {
          fLeftClick(e);
          setShowMore(false);
          setRigntClick(false);
          setTimeout(() => {
            document.getElementsByName("A_PostDt")[0]?.focus();
          }, 100);
        }}
        xLeftClick={(e) => {
          fRightClick(e);
          setShowMore(false);
          setRigntClick(true);
          setTimeout(() => {
            document.getElementsByName("B_ItmName")[0]?.focus();
          }, 100);
        }}
        setShowMore={setShowMore}
        sShowMore={sShowMore}
        fDelete={fDelete}
        xDisableDelete={
          vRdxWmsHead.A_DocStat == "ENTER" && sBufferObj.B_Srno > 0
            ? false
            : sObjRights.RDelete == "N"
            ? true
            : false
        }
        isBtnDraft={sObjRights.RApprove == "N" && false}
        fDraft={() => {
          fApprove("DRAFT");
        }}
        xDisableDraft={
          DisableApproveFlag()
            ? true
            : vRdxWmsHead.A_DocStat != "ENTER"
            ? true
            : false
        }
        fApprove={() => {
          fApprove("POST");
        }}
        xDisableApprove={
          DisableApproveFlag()
            ? true
            : vRdxWmsHead.A_DocStat == "ENTER" ||
              vRdxWmsHead.A_DocStat == "DRAFT"
            ? sObjRights.RApprove == "N"
            : true
        }
        fView={() => {
          fView();
        }}
        fSummary={() => {
          fSummary();
        }}
        fSearch={() => {
          fSearch();
        }}
      />
      <div style={{ paddingTop: vMediaQuery ? "50px" : "" }}>
        <div className="row" style={{ padding: "0px" }}>
          <div className="col-12" style={{ padding: "0px" }}>
            <div className="Wms-sales-invoice ">
              <Grid
                container
                spacing={0}
                className="my-2 Wms-nav-sm-hide"
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                sx={{ alignItems: "center", justifyContent: "center" }}
              >
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <SalesInvoiceCmpButton001
                    xbtnName="New"
                    xOnClick={(e) => fNew()}
                    xVariant="text"
                    xDisabled={sObjRights.RNew == "N"}
                    xSize="small"
                    xId={"INV08BtnNew"}
                    xSendIcon={<AddBoxRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <SalesInvoiceCmpButton001
                    xbtnName="Save"
                    xOnClick={fSave}
                    xVariant="text"
                    xDisabled={sObjRights.RSave == "N"}
                    xSize="small"
                    xId={"INV08BtnSave"}
                    xSendIcon={<SaveRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  {sObjRights.RApprove == "N" && false ? (
                    <SalesInvoiceCmpButton001
                      xbtnName="Draft"
                      xOnClick={() => {
                        fApprove("DRAFT");
                      }}
                      xVariant="text"
                      // xDisabled={sObjRights.RApprove == "N" ? true : false}
                      xDisabled={
                        DisableApproveFlag()
                          ? true
                          : vRdxWmsHead.A_DocStat != "ENTER"
                          ? true
                          : false
                      }
                      xSize="small"
                      xId={sObjRights.RApprove == "N" ? "IdApprove" : ""}
                      xSendIcon={<CheckCircleOutlineRoundedIcon />}
                    />
                  ) : (
                    <SalesInvoiceCmpButton001
                      xbtnName="Approve"
                      xOnClick={() => {
                        fApprove("POST");
                      }}
                      xVariant="text"
                      // xDisabled={sObjRights.RApprove == "N" ? true : false}
                      xDisabled={
                        DisableApproveFlag()
                          ? true
                          : vRdxWmsHead.A_DocStat == "ENTER" ||
                            vRdxWmsHead.A_DocStat == "DRAFT"
                          ? sObjRights.RApprove == "N"
                          : true
                      }
                      xSize="small"
                      xId={sObjRights.RApprove == "Y" ? "IdApprove" : ""}
                      xSendIcon={<CheckCircleOutlineRoundedIcon />}
                    />
                  )}
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <SalesInvoiceCmpButton001
                    xbtnName="Search"
                    xOnClick={fSearch}
                    xVariant="text"
                    xDisabled={false}
                    xSize="small"
                    xId={"INV08BtnSearch"}
                    xSendIcon={<SearchRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <SalesInvoiceCmpButton001
                    xOnClick={() => {
                      fDelete();
                    }}
                    xVariant="text"
                    xDisabled={
                      vRdxWmsHead.A_DocStat == "ENTER" && sBufferObj.B_Srno > 0
                        ? false
                        : sObjRights.RDelete == "N"
                        ? true
                        : false
                    }
                    xSize="small"
                    xId="INV08BtnDelete"
                    xSendIcon={<DeleteRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2} md={0.5} lg={0.5}>
                  <CmpButtonKIcon
                    xOnClick={fMove_First}
                    xDisabled={false}
                    xIcon={<FirstPageIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Previouse}
                    xDisabled={false}
                    xIcon={<ArrowBackIosIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid item xs={1} sm={4} md={1} lg={1} className="text-center">
                  {sNavDocValue} of {sUser_Doc_Arr.length}
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Next}
                    xDisabled={false}
                    xIcon={<ArrowForwardIosIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Last}
                    xDisabled={false}
                    xIcon={<LastPageIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <DropdownButton
                    id="dropdown-basic-button "
                    title="Print"
                    variant="outlined"
                    size="sm"
                    className="sales-invoice-dropdown-btn"
                    disabled={sObjRights.RPrint == "N" ? true : false}
                  >
                    <Dropdown.Item
                      id="INV08BtnPrint"
                      onClick={(e) => {
                        fPrint("P");
                      }}
                    >
                      Sales Returnß
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={(e) => {
                        fPrint("D");
                      }}
                    >
                      document
                    </Dropdown.Item>
                  </DropdownButton>
                </Grid>
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <SalesInvoiceCmpButton001
                    xbtnName="Audit"
                    xOnClick={fAudit}
                    xVariant="text"
                    xDisabled={false}
                    xSize="small"
                    xId="INV08BtnAudit"
                    xSendIcon={<SendIcon />}
                  />
                </Grid>

                <Grid item xs={1} sm={1} md={1.5} lg={1.5}>
                  <GCMenuBtn
                    menuLabel="More"
                    menuItems={[
                      { label: "Account Detail", onClick: fAccountDetail },
                      {
                        label: "Terms And Conditions",
                        onClick: () => {
                          setTermsModal(true);
                        },
                      },
                      PdfUpload() && {
                        label: "Pdf Upload",
                        onClick: () => {
                          setImageUploaderModal(true);
                        },
                      },
                    ]}
                  />
                </Grid>
              </Grid>

              <>
                <div
                  id="wms-salese-invoice-id"
                  className="sales-invoice-respon-space"
                >
                  <div className=" wms-incoice-sales-m main-wms-sales-invoice-hide-sm main-wms-sales-invoice-show-sm">
                    <GCHead
                      sOSDetailObj={sOSDetailObj}
                      sTransItemStockObj={sTransItemStockObj}
                      xTransItemStockShow={
                        vRdxuserInfo?.UserRights?.USRCUSTFIELD84?.toUpperCase() ==
                        "Y"
                      }
                      sTax={sTax}
                      sInvoiceTyp={sInvoiceTyp}
                      xOsAmount={sOsAmount}
                      xPaymodeEnable={sPaymodeEnable}
                      vRdxWmsHead={vRdxWmsHead}
                      sLocation={sLocation}
                      fonChangeInput_A_ECOM={fonChangeInput_A_ECOM}
                      DocLoading={sDocLoading}
                      currency={sCurrency}
                      selecType={vRdxPricelevel}
                      sPayModeArr={sPayModeArr}
                      fOnChangeSelectDocType={fOnChangeSelectDocType}
                      fOnChangeSelectCurr={fOnChangeSelectCurr}
                      fOnChangeInputDate={fOnChangeInputDate}
                      fOnChangeInputDateRefDate={fOnChangeInputDateRefDate}
                      fonChangeInput={fonChangeInput}
                      fonChangeInputTaxType={fonChangeInputTaxType}
                      fonChangeInputInvoiceType={fonChangeInputInvoiceType}
                      fonChangeInputPayMode={fonChangeInputPayMode}
                      fonChangeInputTaxable={fonChangeInputTaxable}
                      fonChangeInput_CreditNote={fonChangeInput_CreditNote}
                      fonChangeInput_Checkbox={fonChangeInput_Checkbox}
                      fonChangeInput_A_DropShipment={
                        fonChangeInput_A_DropShipment
                      }
                      fonChangeInput_Commity={fonChangeInput_Commity}
                      fonChangeInputLocation={fonChangeInputLocation}
                      sErrorMsg={sErrorMsg}
                      sDetailGridData={sDetailGridData}
                      sToggleGrid={sToggleGrid}
                      GridDataSalesHistoryColumns={
                        sSales_History_STOCK_SALES.toUpperCase() == "STOCK"
                          ? GridDataSalesHistoryColumns2
                          : GridDataSalesHistoryColumns
                      }
                      sGridSalesHistoryRowData={sGridSalesHistoryRowData}
                      vMediaQuery={vMediaQuery}
                      inputReference={RefNoFocusOnLoad}
                      //GCToggleSearch

                      xonChangeInputCustomer={
                        GCToggleSearch_Customer_Main_Input
                      }
                      xhandleClick={GCToggleSearch_Customer_Enter_ModalKey}
                      xrowDropdownSearch={GCToggleSearch_Customer_Row_GridData}
                      xcolumnsDropdownSearch={columnsCustomerDropdownSearch}
                      xOnCellKeyDown={GCToggleSearch_Customer_RowCellClick}
                      xOnRowClick={GCToggleSearch_Customer_RowClick}
                      xToggleDropdown={GCToggleSearch_Customer_Toggle}
                      xData={GCToggleSearch_Customer_Data}
                      xOnChange={GCToggleSearch_Customer_Sub_Input}
                      xDropdownObj={GCToggleSearch_Customer_Obj}
                      xOnKeyUp={GCToggleSearch_Customer_OnKeyUpCustomer}
                    />
                  </div>
                  <div className="wms-sales-Content wms-incoice-sales-m main-wms-sales-invoice-hide-sm ">
                    <div className="wms-incoice-sales-m">
                      <GCSalesContent
                        setBufferObj={setBufferObj}
                        fModalPoType={async (e) => {
                          if (
                            (sBufferObj.B_RefDocTyp == "" &&
                              e.key === "Enter") ||
                            e._reactName === "onClick"
                          ) {
                            const payload = {
                              v_AnyData: sBufferObj.B_RefDocName,
                              v_Cd: "",
                              v_Name: "",
                              v_Prnt: "IN-PO",
                            };
                            let resp = await GRNNormal_RefDocumentType_GETROW(
                              fcheck_null_undefine_replace_empty(payload)
                            );
                            if (
                              resp?.status === 200 &&
                              resp?.data?.ResultSet?.length == 1
                            ) {
                              setBufferObj((obj) => ({
                                ...obj,
                                B_RefDocName: resp?.data?.ResultSet[0].Name1,
                                B_RefDocTyp: resp?.data?.ResultSet[0].UID,
                              }));
                            } else {
                              setPoType(true);
                            }
                          }
                          if (e.key === "Backspace") {
                            setBufferObj((obj) => ({
                              ...obj,
                              B_RefDocTyp: "",
                              B_RefDocNo: "",
                            }));
                          }
                        }}
                        fModalPoNo={async (e) => {
                          if (e.key === "Enter" || e._reactName === "onClick") {
                            const payload = {
                              v_AnyData: sBufferObj.B_RefDocNo,
                              v_TrnTyp: sTrnTyp,
                              v_VocTyp: sBufferObj.B_RefDocTyp,
                            };
                            let resp = await GRNNormal_RefDocumentNo_GETROW(
                              fcheck_null_undefine_replace_empty(payload)
                            );
                            if (
                              resp?.status === 200 &&
                              resp?.data?.ResultSet?.length == 1
                            ) {
                              setBufferObj((obj) => ({
                                ...obj,
                                B_RefDocNo: resp?.data?.ResultSet[0].UID,
                              }));
                            } else {
                              setPoNo(true);
                            }
                          }
                        }}
                        fReason={fReason}
                        sReason={sReason}
                        fTaxGroup={fTaxGroup}
                        fCessGroup={fCessGroup}
                        vRdxGRNtax1={vRdxGRNtax1}
                        vRdxGRNtax2={vRdxGRNtax2}
                        sTransItemStockObj={sTransItemStockObj}
                        //  xContent_Focus={fContent_Focus}
                        //  xContent_Blur={fContent_Blur}
                        fLocationwiseStock={fLocationwiseStock}
                        xTransItemStockShow={
                          vRdxuserInfo?.UserRights?.ViewCost?.toUpperCase() ==
                          "Y"
                        }
                        fGrossAmt={fGrossAmt}
                        bufferObj={sBufferObj}
                        fonClickInputFocus={fContent_Focus}
                        fonClickInputBlur={fContent_Blur}
                        fonChangeInputQty={fonChangeInputQty}
                        fonChangeInputUnit={fonChangeInputUnit}
                        fonChangeInputUnitRateFC={fonChangeInputUnitRateFC}
                        fUnitRateFCSave_onKeyUp={fUnitRateFCSave_onKeyUp}
                        fonChangeInputLDisc={fonChangeInputLDisc}
                        fonChangeInputLDiscAmt={fonChangeInputLDiscAmt}
                        fonChangeInputNarration={fonChangeInputNarration}
                        fonChangeCheckBoxFoc={fonChangeCheckBoxFoc}
                        fonChangeInputExcise={fonChangeInputExcise}
                        fonChangeInputOtherAmtSc={fonChangeInputOtherAmtSc}
                        fonChangeInputSupervisorAmtSc={
                          fonChangeInputSupervisorAmtSc
                        }
                        fOnChangeSelectIncGroup={fOnChangeSelectIncGroup}
                        fOnChangeSelectSupervisorSlab={
                          fOnChangeSelectSupervisorSlab
                        }
                        fOnChangeSelectOtherSlab={fOnChangeSelectOtherSlab}
                        SupervisorSlabs={sSupervisorSlabs}
                        OtherSlabs={sOtherSlabs}
                        IncentiveGroups={sIncentiveGroups}
                        ItemUnit={sItemUnit}
                        ItemLocation={sItemLocation}
                        sErrorMsgDetail={sErrorMsgDetail}
                        xNarrArr={sNarrArr}
                        vRdxWmsHead={vRdxWmsHead}
                        //toggle item GCToggleSearch_Item_
                        fonChangeInputItemName={GCToggleSearch_Item_Main_Input}
                        xcolumnsDropdownSearch={xcolumnsDropdownSearch}
                        xrowDropdownSearch={GCToggleSearch_Item_Row_GridData}
                        xOnCellKeyDown={GCToggleSearch_Item_fOnCellClick}
                        xOnRowClick={GCToggleSearch_Item_fOnRowClick}
                        xToggleDropdown={GCToggleSearch_Item_ToggleDropdown}
                        xData={GCToggleSearch_Item_Data}
                        xOnChange={GCToggleSearch_Item_Sub_Input}
                        xDropdownObj={GCToggleSearch_Item_Obj}
                        xOnKeyUp={GCToggleSearch_Item_Sub_Enter}
                        xhandleClick={GCToggleSearch_Item_Main_Enter}
                        xMediaQuery={vMediaQuery}
                        //toggle item end

                        //togggle narration
                        xNarrationToggleDropdown={sNarrationToggleDropdown}
                        xrowDropdownNarrationSearch={sNarrationSearchGridData}
                        xcolumnsDropdownNarrationSearch={
                          columnsNarrationDropdownSearch
                        }
                        xOnCellKeyNarrationDown={OnCellKeyNarrationDown}
                        xOnRowNarrationClick={OnRowNarrationClick}
                        fNarrationKeyEnter={fNarrationKeyEnter}
                        fFocusShowSalesHistoryGrid={fFocusShowSalesHistoryGrid}
                        xinputRef={ClickNewFocsItem}
                      />
                      {vMediaQuery && (
                        <DetailTblCard
                          data={sDetailGridData}
                          onClick={(item) => {
                            fonRowClickGridObj(item);
                          }}
                          fDelete={fDelete}
                          xDisableDelete={
                            vRdxWmsHead.A_DocStat == "ENTER"
                              ? false
                              : sObjRights.RDelete == "N"
                              ? true
                              : false
                          }
                        />
                      )}
                    </div>
                    <div className="wms-sales-content-grid xs-screen-hide">
                      <div
                        style={{
                          height: vMediaQuery ? 300 : 200,
                          width: "100%",
                        }}
                      >
                        <DataGrid
                          rowHeight={30}
                          headerHeight={40}
                          getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0
                              ? "mui-even-row"
                              : "mui-odd-row"
                          }
                          sx={{
                            border: 1,
                            borderColor: "primary.light",
                          }}
                          rows={sDetailGridData}
                          columns={GridData_Columns_Detail}
                          onRowClick={(item) => {
                            setTimeout(() => {
                              fonRowClickGridObj(item);
                            }, 500);
                          }}
                          hideFooter={sDetailGridData.length < 100}
                          onRowDoubleClick={fDetail_Grid_DoubleClick}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="wms-sales-footer wms-incoice-sales-m main-wms-sales-invoice-hide-sm ">
                    <Footer
                      setShowModal={async () => {
                        let obj = {};
                        let resp = await SalesInvoice001_DetailAddressDropdown(
                          fcheck_null_undefine_replace_empty(obj)
                        );
                        if (resp?.status === 200) {
                          console.log(resp);
                          setDetailDispatchDrpdown(
                            resp?.data?.ResultSet.DetailAddress
                          );
                        } else {
                          if (resp.response.status == 500) {
                            fAlertToast(
                              "FAILED",
                              resp.response.data.message.msg ||
                                "error in ValidateInvTransHeadUpdate "
                            );
                          }
                        }
                        setShowModal(true);
                      }}
                      setShowModal2={async () => {
                        setShowModal2(true);
                      }}
                      setShowModal3={() => {
                        setShowModal3(true);
                      }}
                      loyaltySearchbtn={() => {
                        setShowModal4(true);
                      }}
                      dispatch={dispatch}
                      Salesman={sSalesman}
                      SalesGroup={sSalesGroup}
                      sFooterObj={sFooterObj}
                      fonChangeInputDiscount={fonChangeInputDiscount}
                      fonChangeRounding={fFooter_Rounding_OnChange}
                      fOpenDiscountPercentageModal={
                        fOpenDiscountPercentageModal
                      }
                      fOpenSalesGroupModal={fOpenSalesGroupModal}
                      fonClickInputFocusRounding={fFooter_Rounding_Focus}
                      fonClickInputBlurRounding={fFooter_Rounding_Blur}
                      sErrorMsg={sErrorMsg}
                      vRdxWmsHead={vRdxWmsHead}
                      fonChangeSelectSalesMan={fonChangeSelectSalesMan}
                      fonChangeSelectSalesGroup={fonChangeSelectSalesGroup}
                      fonChangeInputFooter={fonChangeInputFooter}
                    />
                  </div>
                </div>
              </>
            </div>
          </div>
        </div>
      </div>

      {/* //View Modal  */}
      <Modal
        open={sViewModal}
        onClose={fCloseViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Detail"} onClose={fCloseViewModal} />

          <div className="py-3">
            <div style={{ height: "69vh", width: "100%" }}>
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                getRowId={(row) => row.id}
                rows={sDetailGridData}
                columns={GridData_Columns_Detail}
                // pageSize={5}
                // rowsPerPageOptions={[5]}

                onRowClick={fonRowClickGridObj}
                onRowDoubleClick={fDetail_Grid_DoubleClick}
                hideFooter={sDetailGridData.length < 100}
              />
            </div>
          </div>
        </Box>
      </Modal>
      {/* summary  */}
      <Modal
        open={sSummaryModal}
        onClose={fCloseSummaryModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Summary "} onClose={fCloseSummaryModal} />

          <div className="py-2">
            <Footer
              Salesman={sSalesman}
              SalesGroup={sSalesGroup}
              sFooterObj={sFooterObj}
              fonChangeInputDiscount={fonChangeInputDiscount}
              fonChangeRounding={fFooter_Rounding_OnChange}
              fOpenDiscountPercentageModal={fOpenDiscountPercentageModal}
              fOpenSalesGroupModal={fOpenSalesGroupModal}
              fonClickInputFocusRounding={fFooter_Rounding_Focus}
              fonClickInputBlurRounding={fFooter_Rounding_Blur}
              sErrorMsg={sErrorMsg}
              vRdxWmsHead={vRdxWmsHead}
              fonChangeSelectSalesMan={fonChangeSelectSalesMan}
              fonChangeSelectSalesGroup={fonChangeSelectSalesGroup}
              fonChangeInputFooter={fonChangeInputFooter}
            />
          </div>
        </Box>
      </Modal>
      <GCSearchBtn
        open={GCSearch_Toggle}
        xStatusArr={sStatusArr}
        xLocationArr={sLocation}
        xSupplierArr={GCSearch_sTransPartyArr}
        xSalesGroup={GCSearch_SalesGroup_Arr}
        xSearchModalObj={GCSearch_Obj}
        fonChangeStatusModal={GCSearch_fonChange_Status}
        fonChangeVocNoModal={GCSearch_fonChange_VocNo}
        fOnChangeDateModel={GCSearch_fOnChange_Date}
        fonChangePartyModal={GCSearch_fonChange_Party}
        fonChangeLocModal={GCSearch_fonChange_Loc}
        fonChangeRefNoModal={GCSearch_fonChange_RefNo}
        fonChangeSalesGroupModal={GCSearch_fonChange_SalesGroup}
        xGetSearchValue={GCSearch_Get}
        fCloseSearchModal={GCSearch_fClose}
        fClearSearchModal={GCSearch_fClear}
        GridSearchHeadRowData={GCSearch_GridData_Row}
        GridDataColumnsSearch={GridDataColumnsSearch}
        xOnCellKeyDownSearch={GCSearch_fTrans_fRowCellClick}
        xOnRowClickSearch={GCSearch_fTrans_fRowClick}
        vMediaQuery={vMediaQuery}
        xEnterObj={sEnterKeyObj}
        xTitle={"Sales Return - Search"}
        xStatusVal={GCSearch_Obj.Status}
        xVocNoVal={GCSearch_Obj.VocNo}
        xPostDtVal={GCSearch_Obj.PostDt}
        xLocVal={GCSearch_Obj.Loc}
        xRefNoVal={GCSearch_Obj.RefNo}
        xSalesGroupVal={GCSearch_Obj.SalesGroup}
        xPartyVal={GCSearch_Obj.Party}
        xPartyNameVal={GCSearch_Obj.PartyName}
        //new Search lookUp
        xfGCSearchBtn_Name={xfGCSearchBtn_Name}
        xGCSearchBtn_Toggle={sGCSearchBtn_Toggle_ToggleDropDowm}
        xGCSearchBtn_onKeyUp={fGCSearchBtn_onKeyUp_onKeyUp}
        xGCSearchBtn_SearchDropdownObj={
          sGCSearchBtn_SearchDropdownObj_SearchDropdownObj
        }
        xGCSearchBtn_Dropdown_onChange={xGCSearchBtn_Dropdown_onChange}
        xGCSearchBtn_Dropdown_OnKeyUp_Load={fGCSearchBtn__Dropdown_OnKeyUp_Load}
        xGCSearchBtn_Columns_DropdownSearch={
          xGCSearchBtn_Columns_DropdownSearch
        }
        xGCSearchBtn_GridData={sGCSearchBtn_GridData}
        xfGCSearchBtn_OnRowClick={fGCSearchBtn_OnRowClick}
        xfGCSearchBtn_OnCellKeyDown={fGCSearchBtn_OnCellKeyDown}
      />
      <GCDiscountPercentage
        sDiscountPercentageModal={GCDiscountPercentage_Toggle}
        fCloseDiscountPercentageModal={GCDiscountPercentage_fClose}
        xGrossAmount={sFooterObj.A_GrossAmt}
        xLDiscAmount={sFooterObj.A_LDiscAmt}
        xTDiscAmount={GCDiscountPercentage_Obj.A_TDiscAmt}
        xTDiscPer={GCDiscountPercentage_Obj.A_DiscPerc}
        fonChangeInputDiscountModal={GCDiscountPercentage_fonChange_Discount}
        fOnChangeTDiscAmtModal={GCDiscountPercentage_fOnChange_TDiscAmt}
        GetApplyTDiscount={GCDiscountPercentage_Get_TDiscount}
        xErrorMsg_DiscPerc={GCDiscountPercentage_sErrorMsg.A_DiscPerc}
        xErrorMsg_TDiscAmt={GCDiscountPercentage_sErrorMsg.A_TDiscAmt}
        xRdx_DocStatus={vRdxWmsHead.A_DocStat !== "ENTER"}
      />
      <GCVanMaster
        open={GCVanMaster_SalesGroup_Toggle}
        xDocStatus={vRdxWmsHead.A_DocStat == "POST"}
        xVocNo={vRdxWmsHead.A_VocNo}
        xVocType={vRdxWmsHead.A_VocTyp}
        xVocTypeName={vRdxWmsHead.A_VocTypName}
        fCloseSalesGroupModal={GCVanMaster_SalesGroup_fCloseModal}
        xSalesGroup={sSalesGroup}
        xSaleGroupTypeArr={GCVanMaster_SalesGroup_TypeArr}
        xVanMasterModalObj={GCVanMaster_SalesGroup_ModalObj}
        xMediaQuery={vMediaQuery}
        xEnterObj={sEnterKeyObj}
        xGetVanMasterSearchEnter={GCVanMaster_SalesGroup_GetSearchEnter}
        xfOnVanMasterSrNoModal={GCVanMaster_SalesGroup_fSrNoModal}
        xfOnVanMasterEmployeeModal={GCVanMaster_SalesGroup_fEmployeeModal}
        xfOnVanMasterActiveModal={GCVanMaster_SalesGroup_fActiveModal}
        xfNewSaleGroup={GCVanMaster_SalesGroup_fNew}
        xfSaveSaleGroup={GCVanMaster_SalesGroup_fSave}
        xfDeleteSaleGroup={GCVanMaster_SalesGroup_fDelete}
        xfOnVanMasterTypModal={GCVanMaster_SalesGroup_OnChange_Input}
        xrows={GCVanMaster_SalesGroup_GridData_Row}
        xcolumns={GCVanMaster_SalesGroup_GridData_Columns}
        xRowClick={GCVanMaster_SalesGroup_fRowClick}
        xRowCellClick={GCVanMaster_SalesGroup_fRowCellClick}
        xErrorMsg={GCVanMaster_SalesGroup_sErrorMsg}
      />
      {/* Reverse Narration  */}
      <GCReverse
        open={GCReverse_Toggle}
        fCloseReverseTransactionModal={GCReverse_fClose}
        sRevNarr={GCReverse_sRevNarr}
        setRevNarr={GCReverse_setRevNarr}
        fReverse={GCReverse_fReverse}
      />
      {/* GCAudit Modal */}
      <GCAudit
        xOpen={!!GCEmployee_SalesGroup_Toggle ? true : GCAudit_Toggle}
        xTitle={"AUDIT"}
        fCloseAuditModal={GCAudit_fClose}
        sAuditSelectArr={GCAudit_Dropdown_Arr}
        GridDataAuditColumns={GCAudit_GridData_Columns}
        GridDataAuditRows={GCAudit_GridData_Rows}
        xAuditId={GCAudit_xAuditId}
        fonChangeAuditSelect={GCAudit_OnChange_Select}
        xLabel={vRdxWmsHead.A_VocTypName + "-" + vRdxWmsHead.A_VocNo}
      />
      {/* //Employee modal  */}
      <GCEmployee
        open={GCEmployee_SalesGroup_Toggle}
        xCloseSearchModal={GCEmployee_SalesGroup_fClose}
        xTitle={"Employee"}
        xAnyData={""}
        xModelObj={GCEmployee_SalesGroup_Obj}
        xSearchEnter={GCEmployee_SalesGroup_Get_SearchEnter}
        xonChangeInputModal={GCEmployee_SalesGroup_onChange_Input}
        xGridArr={GCEmployee_SalesGroup_GridData_Row}
        xGridDataColumnsSearch={GCEmployee_SalesGroup_GridData_Columns}
        xRowClick={GCEmployee_SalesGroup_fRowClick}
        xRowCellClick={GCEmployee_SalesGroup_fRowCellClick}
        xClearSimpleSearch={GCEmployee_SalesGroup_fClear}
        xMediaQuery={vMediaQuery}
        xEnterObj={sEnterKeyObj}
      />

      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
      <GCAccountDetail
        xOpen={sAccountDetailModal}
        fCloseDetailModal={fCloseAccountDetailModal}
        GridDataAccountDetailColumns={sGridDataAccountDetailColumns}
        GridDataAccountDetailRows={sGridDataAccountDetailRows}
        xTitle={"Account Detail"}
        xLabelVocType={vRdxWmsHead.A_VocTyp}
        xLabelVocName={vRdxWmsHead.A_VocTypName}
        xLabelVocNo={vRdxWmsHead.A_VocNo}
      />
      <GCLocationwiseStock
        xOpen={sLocationwiseStockModal}
        fCloseDetailModal={fCloseLocationwiseStockModal}
        GridDataLocationwiseStockColumns={sGridDataLocationwiseStockColumns}
        GridDataLocationwiseStockRows={sGridDataLocationwiseStockRows}
        xTitle={"Locationwise - Stock"}
        xLabelItemName={sBufferObj.B_Itmcd + " - " + sBufferObj.B_ItmName}
        xLabelBranch={sBufferObj?.B_Br + " - " + sBufferObj?.B_BrName}
      />

      <GCLinkDocument
        xOpen={sLinkDocumentModal}
        fCloseDetailModal={fCloseLinkDocumentModal}
        GridDataLinkDocumentColumns={sGridDataLinkDocumentColumns}
        GridDataLinkDocumentRows={sGridDataLinkDocumentRows}
        xTitle={"Link Document"}
        xLabelVocType={vRdxWmsHead.A_VocTyp}
        xLabelVocName={vRdxWmsHead.A_VocTypName}
        xLabelVocNo={vRdxWmsHead.A_VocNo}
      />
      <GCFilter
        xOpen={showModal && vRdxWmsHead.A_VocNo != 0}
        fCloseModal={() => {
          setShowModal(false);
        }}
        xTitle="Shipping Address"
        component={
          <>
            <ShippingAddressForm
              vocType={vRdxWmsHead.A_VocTyp}
              vocTypeName={vRdxWmsHead.A_VocTypName}
              vocNo={vRdxWmsHead.A_VocNo}
              sDetailDispatchDrpdown={sDetailDispatchDrpdown}
            />
          </>
        }
      />
      <GCFilter
        xOpen={showModal2 && vRdxWmsHead.A_VocNo != 0}
        fCloseModal={() => {
          setShowModal2(false);
        }}
        xTitle={`Sales Invoice Doc.No - ${vRdxWmsHead.A_VocNo}`}
        component={
          <>
            <CustomFieldsForm
              vocType={vRdxWmsHead.A_VocTyp}
              vocTypeName={vRdxWmsHead.A_VocTypName}
              vocNo={vRdxWmsHead.A_VocNo}
            />
          </>
        }
      />
      <GCFilter
        xOpen={showModal3 && vRdxWmsHead.A_VocNo != 0}
        fCloseModal={() => {
          setShowModal3(false);
        }}
        xTitle={`Despatch Detail - Sales Invoice No:  ${vRdxWmsHead.A_VocNo}`}
        component={
          <>
            <DespatchDetailForm
              vocType={vRdxWmsHead.A_VocTyp}
              vocTypeName={vRdxWmsHead.A_VocTypName}
              vocNo={vRdxWmsHead.A_VocNo}
            />
          </>
        }
      />

      <LoyaltySearch
        open={showModal4}
        xTitle={`Customer Help `}
        fCloseSearchModal={() => {
          setShowModal4(false);
        }}
      />
      {/* <Attachment
        open={ImageUploaderModal}
        fCloseSearchModal={() => {
          setImageUploaderModal(false);
        }}
        A_VocTyp={vRdxWmsHead.A_VocTyp}
        A_VocNo={vRdxWmsHead.A_VocNo}
      /> */}
      <FileUploadModal
        open={ImageUploaderModal}
        fCloseSearchModal={() => {
          setImageUploaderModal(false);
        }}
        A_VocTyp={vRdxWmsHead.A_VocTyp}
        A_VocNo={vRdxWmsHead.A_VocNo}
      />

      <TermsAndConditions
        open={TermsModal}
        xTitle={`Terms And Conditions`}
        fCloseSearchModal={() => {
          setTermsModal(false);
        }}
      />

      <RegisterSerialNumberModal
        SrNo={SerialDetalModal.SrNo}
        ItemCd={SerialDetalModal.ItemCd}
        open={registerSerialNumberModal}
        handleClose={() => {
          setRegisterSerialNumberModal(false);
          fNewDetail(
            vRdxWmsHead.A_VocNo,
            vRdxWmsHead.A_Rounding,
            vRdxWmsHead.A_VocTyp,
            vRdxWmsHead.A_TaxType
          );
        }}
        xDisable={vRdxWmsHead.A_DocStat != "ENTER"}
      />
      <BatchSelectionModal
        batchFlag={batchFlag}
        setBatchObj={setBatchObj}
        SerialDetalModal={SerialDetalModal}
        closeModal={() => {
          fNewDetail(
            vRdxWmsHead.A_VocNo,
            vRdxWmsHead.A_Rounding,
            vRdxWmsHead.A_VocTyp,
            vRdxWmsHead.A_TaxType
          );
          setBatchSelectionModal(false);
        }}
        vRdxWmsHead={vRdxWmsHead}
        batchSelectionModal={sbatchSelectionModal}
        sBufferObj={sBufferObj}
        sBatchObj={sBatchObj}
      />
      <POTypeSearchModal
        open={poType && sBufferObj.B_RefDocTyp == ""}
        onClose={() => {
          setPoType(false);
        }}
        defaultValue={sBufferObj.B_RefDocName}
        handleRowClick={(e) => {
          setBufferObj((obj) => ({
            ...obj,
            B_RefDocName: e.row.Name1,
            B_RefDocTyp: e.row.UID,
          }));
          setPoType(false);
        }}
      />
      <PoNoSearchModal
        open={poNo && sBufferObj.B_RefDocTyp != ""}
        onClose={() => {
          setPoNo(false);
        }}
        defaultValue={sBufferObj.B_RefDocNo}
        handleRowClick={(e) => {
          setBufferObj((obj) => ({
            ...obj,
            B_RefDocNo: e.row.UID,
          }));
          setPoNo(false);
        }}
        B_RefDocTyp={sBufferObj.B_RefDocTyp}
      />
    </div>
  );
}
